import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traductions
const resources = {
  fr: {
    translation: {
      // Navigation
      nav: {
        home: "Accueil",
        events: "Événements",
        news: "Actualités",
        association: "L'Association",
        partners: "Partenaires",
        gettingHere: "Venir",
        contact: "Contact",
        volunteer: "Bénévoles",
        membership: "Adhésion"
      },
      // Homepage
      home: {
        welcome: "Bienvenue à Brious'O Folies",
        subtitle: "Association équestre au cœur de la Nouvelle-Aquitaine",
        discoverEvents: "Découvrir nos événements",
        joinUs: "Nous rejoindre",
        becomeVolunteer: "Devenir bénévole",
        becomeMember: "Devenir adhérent",
        upcomingEvents: "Événements à venir",
        viewAllEvents: "Voir tous les événements",
        newsletter: "Newsletter",
        newsletterDesc: "Restez informé de nos actualités",
        email: "Votre email",
        subscribe: "S'inscrire"
      },
      // Events
      events: {
        title: "Nos Événements",
        subtitle: "Découvrez nos courses d'endurance et randonnées équestres",
        allEvents: "Tous",
        endurance: "Endurance",
        randonnee: "Randonnée",
        stage: "Stage",
        concert: "Concert",
        register: "Réserver",
        learnMore: "En savoir plus",
        organization: "Organisation",
        noEvents: "Aucun événement pour le moment"
      },
      // Endurance
      endurance: {
        title: "Règlements & Résultats",
        subtitle: "Règlements officiels FFE, FEI et SHF",
        regulations: "Règlements Officiels",
        results: "Nos Résultats",
        france: "France - FFE",
        international: "International - FEI",
        youngHorses: "Jeunes Chevaux - SHF",
        usefulLinks: "Liens utiles",
        download: "Télécharger"
      },
      // Event Organization
      organization: {
        title: "Organisation",
        schedule: "Horaires",
        participants: "Participants",
        route: "Parcours",
        veterinary: "Vétérinaire",
        practicalInfo: "Infos pratiques",
        program: "Programme de la journée",
        races: "Épreuves",
        participantsList: "Liste des participants et dossards",
        roadBooks: "Road Books",
        mapsRoutes: "Cartes et tracés",
        vetCards: "Cartes de suivi vétérinaire",
        vetInfo: "Informations vétérinaires",
        usefulNumbers: "Numéros utiles",
        emergencyNumbers: "Numéros d'urgence",
        sitePlan: "Plan du site",
        parking: "Parking",
        toilets: "Toilettes",
        vetZone: "Zone vétérinaire",
        groomingZone: "Zone grooming",
        restZone: "Zone repos chevaux",
        backToEvents: "Retour aux événements"
      },
      // Contact
      contact: {
        title: "Contactez-nous",
        subtitle: "Une question ? N'hésitez pas à nous écrire",
        name: "Votre nom",
        email: "Votre email",
        subject: "Sujet",
        message: "Votre message",
        send: "Envoyer",
        sending: "Envoi en cours...",
        success: "Message envoyé avec succès !",
        error: "Erreur lors de l'envoi"
      },
      // Common
      common: {
        readMore: "Lire la suite",
        seeAll: "Voir tout",
        loading: "Chargement...",
        error: "Erreur",
        close: "Fermer",
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        add: "Ajouter",
        search: "Rechercher",
        filter: "Filtrer",
        results: "résultats",
        comingSoon: "À venir",
        date: "Date",
        location: "Lieu",
        distance: "Distance",
        level: "Niveau",
        departure: "Départ",
        back: "Retour",
        backToHome: "Retour à l'accueil",
        backToEvents: "Retour aux événements",
        backToNews: "Retour aux actualités",
        login: "Connexion",
        logout: "Déconnexion",
        logoutSuccess: "Déconnexion réussie",
        loginSuccess: "Connexion réussie",
        loginError: "Erreur de connexion",
        invalidCredentials: "Identifiants incorrects.",
        welcome: "Bienvenue",
        book: "Réserver",
        free: "Gratuit",
        send: "Envoyer",
        sending: "Envoi en cours...",
        download: "Télécharger",
        register: "Inscription",
        confirm: "Confirmer",
        errorOccurred: "Une erreur est survenue",
        tryAgain: "Veuillez réessayer",
        errorSending: "Erreur lors de l'envoi",
        errorCreating: "Erreur lors de la création",
        errorUpdating: "Erreur lors de la mise à jour",
        errorDeleting: "Erreur lors de la suppression",
        errorUpload: "Erreur lors de l'upload",
        confirmDelete: "Supprimer cet élément ?",
        confirmDeleteUser: "Supprimer cet utilisateur ?",
        addUser: "Ajouter Utilisateur",
        sendTestEmail: "Envoyer un email de test",
        sendTestTo: "Envoyer un email de test à :",
        email: "Email",
        password: "Mot de passe",
        adminLogin: "Connexion Admin",
        staffArea: "Espace Staff",
        manageMedia: "Vous pouvez maintenant gérer les médias.",
        regulations: "Règlements & Résultats",
        officialRegulations: "Règlements officiels & Résultats des courses",
        ourResults: "Nos Résultats",
        raceResults: "Résultats des courses Brious'O Folies",
        resultsComingSoon: "Résultats à venir",
        savedSuccess: "Enregistré avec succès",
        savedError: "Erreur lors de la sauvegarde"
      },
      // Footer
      footer: {
        rights: "Tous droits réservés",
        legalNotice: "Mentions légales",
        privacy: "Politique de confidentialité",
        terms: "Conditions générales",
        followUs: "Suivez-nous"
      },
      // Association page
      association: {
        whoAreWe: "Qui sommes-nous ?",
        title: "L'Association",
        description: "Brious'O Folies œuvre toute l'année pour promouvoir les activités équestres, les sports de pleine nature et les événements culturels.",
        heartOfMelusin: "Une association au cœur du",
        paysMelusin: "Pays Mélusin",
        presentation1: "est une association loi 1901 à but non lucratif, créée pour organiser des événements sportifs, équestres et culturels sur le Domaine de la Briouse, à Sanxay (86).",
        ourMission: "Notre mission :",
        missionDesc: "Promouvoir et organiser des activités équestres, sportives, culturelles et patrimoniales, tout en favorisant la convivialité, la transmission et l'accès à la nature pour tous.",
        presentation2: "Randonnées équestres, courses d'endurance, concerts en plein air, événements familiaux… Nous créons des moments de",
        conviviality: "convivialité, de partage et de découverte",
        presentation3: ", ouverts aux cavaliers, aux familles, aux habitants du territoire et aux visiteurs de passage.",
        becomeMember: "Devenir Adhérent",
        becomeVolunteer: "Devenir Bénévole",
        becomePartner: "Devenir Partenaire",
        keyFigures: "Chiffres Clés 2025",
        eventsOrganized: "Événements organisés",
        inYear: "en 2025",
        artistsPerformers: "Artistes & intervenants",
        ridersWelcomed: "Cavaliers accueillis",
        visitorsOnSite: "Visiteurs sur site",
        ourTeam: "Notre Équipe",
        bureauMembers: "Les Membres du Bureau",
        bureauDesc: "Une équipe de bénévoles passionnés aux compétences complémentaires, animés par des valeurs fortes.",
        whatDrivesUs: "Ce qui nous anime",
        ourValues: "Nos Valeurs Fondamentales",
        benevolence: "Bienveillance",
        benevolenceDesc: "Accueillir chaque participant, bénévole ou partenaire dans un climat de respect, d'écoute et de sécurité.",
        respect: "Respect",
        respectDesc: "Veiller au bien-être des chevaux, à la protection de l'environnement et au respect des sites patrimoniaux et des personnes.",
        conviviality2: "Convivialité",
        convivialityDesc: "Créer des moments chaleureux, intergénérationnels, où se rencontrent familles, cavaliers, habitants, touristes et entreprises.",
        environment: "Environnement",
        environmentDesc: "Organiser des événements sobres et responsables, attentifs aux impacts sur la nature et aux usages des espaces ruraux.",
        transmission: "Transmission",
        transmissionDesc: "Partager des savoir-faire équestres, des connaissances sur le patrimoine et des valeurs citoyennes auprès des jeunes et du grand public.",
        accessibility: "Accessibilité",
        accessibilityDesc: "Rendre le sport, la culture et la nature accessibles au plus grand nombre.",
        ourImpact: "Notre Impact",
        ourActions: "Nos Actions",
        actionsDesc: "À travers ses actions, l'association participe activement à la dynamisation du territoire, au développement du tourisme rural et au renforcement du lien social.",
        contactUs: "Contactez-nous",
        contactQuestion: "Pour toute question ou demande d'information",
        writeToUs: "Nous contacter",
        joinAdventure: "Rejoignez l'aventure !",
        ctaDesc: "Que vous soyez cavalier, amateur de culture, passionné de nature ou simplement curieux, il y a une place pour vous chez Brious'O Folies.",
        membershipFor: "Adhérer pour 10€"
      },
      // Login Modal
      loginModal: {
        staffArea: "Espace Staff",
        memberArea: "Espace Adhérent",
        staffDesc: "Administration du site Brious'O Folies",
        memberDesc: "Accédez à votre espace personnel",
        createAccount: "Créez votre compte adhérent",
        member: "Adhérent",
        signIn: "Se connecter",
        firstName: "Prénom",
        lastName: "Nom",
        phone: "Téléphone",
        createMyAccount: "Créer mon compte",
        accountCreated: "Compte créé ! Connectez-vous maintenant.",
        alreadyAccount: "Déjà un compte ? Se connecter",
        noAccount: "Pas encore de compte ? S'inscrire"
      },
      // Partners page
      partners: {
        becomePartner: "Devenez Partenaire",
        supportUs: "Soutenez Brious'O Folies",
        heroDesc: "Entreprises, artisans, collectivités : rejoignez l'aventure et donnez de la visibilité à votre structure tout en soutenant le territoire !",
        downloadDossier: "Télécharger le Dossier Sponsoring",
        contactUs: "Nous Contacter",
        whyJoinUs: "Pourquoi Nous Rejoindre ?",
        partnershipBenefits: "Les Avantages du Partenariat",
        localVisibility: "Visibilité Locale",
        localVisibilityDesc: "Touchez un public familial, passionné et engagé sur le territoire du Pays Mélusin.",
        positiveImage: "Image Positive",
        positiveImageDesc: "Associez votre marque à des valeurs fortes : nature, patrimoine, sport et culture accessible.",
        network: "Réseau",
        networkDesc: "Intégrez un réseau d'entreprises et collectivités engagées pour le territoire.",
        taxBenefits: "Avantages Fiscaux",
        taxBenefitsDesc: "Bénéficiez de réductions d'impôt grâce au mécénat (66% du don déductible).",
        ourFormulas: "Nos Formules",
        choosePackage: "Choisissez Votre Pack Partenaire",
        packagesDesc: "Des formules adaptées à tous les budgets, avec des contreparties concrètes et mesurables.",
        selectPack: "Choisir ce pack",
        technicalPartnership: "Partenariat Technique / Mécénat",
        technicalDesc: "Vous souhaitez nous soutenir autrement ? Mise à disposition de matériel, services, compétences... Contactez-nous pour une offre sur mesure !",
        discussProject: "Discutons de votre projet",
        ourCommitment: "Notre Engagement",
        whatWeGuarantee: "Ce que nous vous garantissons",
        dedicatedContact: "Un interlocuteur dédié pour chaque partenaire",
        taxOptimization: "Fiscalité optimisée (reçu fiscal pour les dons)",
        customOffers: "Offres sur mesure selon vos besoins",
        fullTransparency: "Transparence totale sur l'utilisation des fonds",
        detailedReport: "Bilan détaillé après chaque événement",
        sponsorDossier: "Dossier Sponsoring Complet",
        dossierDesc: "Retrouvez toutes les informations détaillées : événements, budgets, contreparties et contacts.",
        downloadPdf: "Télécharger le PDF",
        questions: "Vous avez des questions ?",
        questionsDesc: "Notre équipe est à votre disposition pour construire ensemble un partenariat sur mesure.",
        thankPartners: "Merci à nos partenaires",
        theyTrusted: "Ils nous ont fait confiance",
        thankYouDesc: "Un grand merci à toutes les entreprises, institutions et collectivités qui soutiennent Brious'O Folies.",
        institutionsCollectivities: "Institutions & Collectivités",
        equestrianFederations: "Fédérations Équestres",
        partnerCompanies: "Entreprises Partenaires",
        tourismLeisure: "Tourisme & Loisirs",
        readyToJoin: "Prêt à nous rejoindre ?",
        ctaDesc: "Contactez-nous dès maintenant pour discuter de votre projet de partenariat et rejoindre l'aventure Brious'O Folies !",
        partnershipRequest: "Demande de partenariat",
        selectedPack: "Pack sélectionné",
        thankYouInterest: "Merci pour votre intérêt !",
        requestSent: "Votre demande a bien été envoyée. Nous vous recontacterons très prochainement pour discuter de votre partenariat.",
        fullName: "Nom complet",
        company: "Entreprise",
        phone: "Téléphone",
        sendRequest: "Envoyer ma demande",
        formConsent: "En soumettant ce formulaire, vous acceptez d'être contacté par l'association Brious'O Folies."
      },
      // Homepage extended
      homeExt: {
        heroTitle1: "Vivez les événements",
        heroTitle2: "à Sanxay",
        heroSubtitle: "Activités équestres, sports de pleine nature et événements culturels au cœur du",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Voir les événements",
        becomeMember: "Devenir Adhérent",
        becomeVolunteer: "Devenir bénévole",
        receiveNews: "Recevoir les actualités",
        eventsPerYear: "Événements/an",
        visitorsWelcomed: "Visiteurs accueillis",
        volunteersActive: "Bénévoles mobilisés",
        landArea: "De terrain",
        dontMiss: "Ne manquez rien !",
        upcomingEvents: "Prochains Événements",
        upcomingEventsDesc: "Concerts, randonnées équestres, courses d'endurance, soirées country... Découvrez notre programme et réservez votre place !",
        reserve: "Réserver",
        free: "GRATUIT",
        seeAllEvents: "Voir tous les événements",
        allYear: "Toute l'année",
        seasonTitle: "Saison Brious'O Folies",
        seasonDesc: "Des événements toute l'année au rythme des saisons",
        spring: "Printemps",
        summer: "Été",
        autumn: "Automne",
        winter: "Hiver",
        springEvents: ["Stages équitation", "Randonnées nature", "Chasse aux œufs", "Soirées country"],
        summerEvents: ["Concerts de Chœurs", "Course d'endurance championnat départemental", "Brocantes"],
        autumnEvents: ["Rando Halloween", "Ciné-goûter", "Course d'endurance"],
        winterEvents: ["Ciné-goûter", "Concerts intimistes", "Ateliers", "Jeux"],
        joinCommunity: "Rejoignez la communauté Brious'O Folies",
        newsletterDesc: "Recevez les actualités de nos événements, concerts, activités nature et courses d'endurance.",
        iWantInfo: "Je souhaite recevoir des informations sur :",
        nlEndurance: "Course d'endurance équestre",
        nlConcerts: "Concerts et spectacles",
        nlNature: "Activités nature et randonnées",
        nlFamily: "Événements familiaux",
        nlPedagogy: "Activités pédagogiques",
        nlVolunteer: "Devenir bénévole",
        emailPlaceholder: "Votre adresse email",
        joinCommunityBtn: "Je rejoins la communauté",
        thankYou: "Merci !",
        subscribedMsg: "Vous êtes maintenant inscrit à notre newsletter.",
        welcomeMsg: "Bienvenue dans la communauté !",
        welcomeDesc: "Vous recevrez bientôt nos actualités.",
        prefsUpdated: "Préférences mises à jour !",
        prefsUpdatedDesc: "Vos centres d'intérêt ont été actualisés.",
        joinTeam: "Rejoignez l'équipe",
        becomeVolunteerTitle: "Devenez bénévole Brious'O Folies",
        volunteerDesc: "Vous souhaitez participer à l'organisation d'événements sportifs et culturels ? Rejoignez notre équipe de bénévoles pour des moments de partage inoubliables !",
        volunteerBenefit1: "Vivre les événements de l'intérieur",
        volunteerBenefit2: "Faire de belles rencontres",
        volunteerBenefit3: "Aucune expérience requise",
        volunteerBtn: "Devenir bénévole",
        volunteersTrustUs: "Bénévoles nous font confiance",
        heritageNature: "Patrimoine & Nature",
        discoverSanxay: "Découvrir Sanxay et sa région",
        discoverDesc: "Le Domaine de la Briouse est idéalement situé pour explorer les trésors du Pays Mélusin",
        discoverRegion: "Découvrir la région",
        ourCommitment: "Notre Engagement",
        valuesTitle: "Des valeurs qui nous rassemblent",
        benevolence: "Bienveillance",
        benevolenceDesc: "Accueil chaleureux pour tous",
        conviviality: "Convivialité",
        convivialityDesc: "Moments de partage et de rencontre",
        respect: "Respect",
        respectDesc: "De la nature et des chevaux",
        culture: "Culture",
        cultureDesc: "Événements artistiques accessibles",
        ourPlace: "Notre Lieu",
        domainTitle: "Le Domaine de la Briouse",
        domainDesc: "Situé au cœur du Pays Mélusin, le Domaine de la Briouse offre un cadre naturel et patrimonial d'exception. À proximité du célèbre site gallo-romain de Sanxay, c'est le lieu idéal pour des événements alliant sport, culture et nature.",
        howToCome: "Comment venir",
        joinAdventure: "Rejoignez l'aventure Brious'O Folies",
        ctaDesc: "Devenez adhérent et participez à la vie de notre association. Ensemble, faisons vivre le patrimoine et la convivialité du Pays Mélusin.",
        memberFor10: "Adhérer pour 10€",
        contactUsBtn: "Nous contacter",
        call: "Appeler",
        galloRomanSite: "Site Gallo-Romain de Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      // Events page extended
      eventsExt: {
        calendar: "Calendrier",
        calendar2026: "Calendrier 2026",
        title: "Nos Événements",
        subtitle: "Randonnées équestres, concerts, courses d'endurance et événements familiaux... Découvrez toutes nos animations au Domaine de la Briouse.",
        downloadLivret: "Télécharger le Livret PDF",
        featured: "À la Une",
        grandeTombola: "Grande Tombola",
        winBalloon: "Gagnez un Vol en Montgolfière !",
        tombolaDesc: "Participez à notre grande tombola et tentez de gagner un vol en montgolfière pour 2 personnes décollant directement du Domaine de la Briouse !",
        ticket: "le ticket",
        drawAt: "Tirage à 18h",
        participateTombola: "Participer à la Tombola",
        learnMore: "En savoir plus",
        filterByCategory: "Filtrer par catégorie",
        allCategories: "Toutes les catégories",
        resetFilters: "Réinitialiser les filtres",
        becomeMember: "Devenez Adhérent",
        memberDesc: "Soutenez notre association et bénéficiez d'avantages exclusifs.",
        memberFor10: "Adhérer pour 10€",
        noEventsFound: "Aucun événement trouvé pour ces critères.",
        seeAllEvents: "Voir tous les événements",
        reserve: "Réserver",
        freeEntry: "Entrée libre",
        orga: "Orga",
        equitation: "Équitation",
        concert: "Concert",
        randonnee: "Randonnée",
        course: "Course",
        brocante: "Brocante",
        cinema: "Cinéma"
      },
      // Contact page extended
      contactExt: {
        contactUs: "Contactez-nous",
        title: "Contact",
        subtitle: "Une question, une suggestion, une envie de nous rejoindre ? N'hésitez pas à nous contacter.",
        contactInfo: "Informations de Contact",
        phone: "Téléphone",
        address: "Adresse",
        onlineMembership: "Adhésion en ligne",
        joinViaHelloAsso: "Rejoignez notre association via HelloAsso.",
        memberFor10: "Adhérer pour 10€",
        sendMessage: "Envoyez-nous un message",
        fullName: "Nom complet *",
        email: "Email *",
        subject: "Sujet *",
        subjectPlaceholder: "À propos de...",
        message: "Message *",
        messagePlaceholder: "Votre message...",
        newsletterCheckbox: "Je souhaite m'inscrire à la newsletter pour recevoir les actualités de Brious'O Folies",
        sendBtn: "Envoyer le message",
        successMsg: "Message envoyé avec succès !",
        successDescNewsletter: "Vous êtes aussi inscrit à la newsletter.",
        successDesc: "Nous vous répondrons dans les plus brefs délais.",
        errorMsg: "Erreur lors de l'envoi",
        errorDesc: "Veuillez réessayer ultérieurement.",
        findUs: "Nous Trouver"
      },
      // Volunteers page
      benevoles: {
        joinAdventure: "Rejoignez l'aventure",
        title: "Devenez Bénévole",
        heroDesc: "Les événements que nous organisons ne pourraient voir le jour sans l'engagement et la générosité de celles et ceux qui donnent un peu de leur temps.",
        signUp: "Je m'inscris comme bénévole",
        thanks: "Merci !",
        callTitle: "Brious'O Folies lance un appel !",
        callP1: "Aujourd'hui, <strong>Brious'O Folies</strong> lance un appel à toutes les habitantes et tous les habitants qui souhaitent devenir bénévoles et participer à la vie locale.",
        callP2: "<strong>Événements sportifs, concerts, spectacles, randonnées, animations familiales ou rendez-vous festifs</strong> : nos projets sont variés, et chacun peut y trouver sa place.",
        callP3: "Accueil du public, aide à l'organisation, logistique, installation, communication, accompagnement des participants ou simple coup de main ponctuel… <strong>il existe mille façons de s'impliquer</strong>, selon ses envies, ses compétences et ses disponibilités.",
        chooseEvent: "Choisissez votre événement",
        eventsCalendar: "Calendrier des Événements",
        clickToSign: "Cliquez sur un événement pour vous inscrire comme bénévole",
        selectedEvent: "Événement sélectionné",
        monthEvents: "Événements du mois",
        volunteerForEvent: "Devenir bénévole pour cet événement",
        seeAllEvents: "Voir tous les événements",
        noEventThisMonth: "Pas d'événement ce mois-ci.",
        navigateCalendar: "Naviguez dans le calendrier !",
        findYourPlace: "Trouvez votre place",
        missionTypes: "Types de Missions",
        missionDesc: "Il y a de nombreuses façons de contribuer selon vos envies et compétences.",
        publicWelcome: "Accueil du public",
        publicWelcomeDesc: "Orienter et renseigner les visiteurs lors de nos événements",
        logistics: "Logistique & Installation",
        logisticsDesc: "Mise en place des stands, signalétique et aménagements",
        animation: "Animation",
        animationDesc: "Accompagner les participants lors des spectacles et concerts",
        helpOut: "Coup de main ponctuel",
        helpOutDesc: "Aide diverse selon vos disponibilités et envies",
        whyJoin: "Pourquoi nous rejoindre ?",
        beingVolunteer: "Être bénévole, c'est…",
        beingVolunteerDesc: "Vivre les événements de l'intérieur, partager des moments forts, faire de belles rencontres et contribuer à des projets porteurs de sens pour notre territoire.",
        benefit1: "Vivre les événements de l'intérieur",
        benefit2: "Faire de belles rencontres",
        benefit3: "Contribuer à des projets porteurs de sens",
        benefit4: "Ambiance conviviale et bienveillante",
        benefit5: "Aucune expérience requise",
        benefit6: "Engagement selon vos disponibilités",
        essentialDesire: "L'essentiel, c'est l'envie !",
        essentialP1: "Aucune expérience particulière n'est nécessaire : l'essentiel est l'envie de participer, d'échanger et de faire partie d'une aventure collective.",
        essentialP2: "Rejoindre l'équipe des bénévoles Brious'O Folies, c'est s'engager dans une",
        essentialP2Bold: "ambiance conviviale et bienveillante",
        essentialP2End: ", au service du partage, de la culture, du sport et de la nature.",
        ifAdventureTempts: "Si l'aventure vous tente...",
        ctaDesc: "Venez nous rencontrer lors de nos événements ou inscrivez-vous directement : nous serons ravis de vous accueillir et d'écrire la suite de cette belle histoire ensemble !",
        becomeVolunteer: "Je deviens bénévole",
        contactUs: "Nous contacter",
        followSocial: "Suivez-nous sur les réseaux !",
        dayNames: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"]
      },
      // Footer
      footerExt: {
        visitorsSay: "Ce que disent nos visiteurs",
        review1: "Super ambiance, équipe au top !",
        review2: "Événements de qualité, on reviendra !",
        review3: "Magnifique cadre, chevaux bien soignés",
        navigation: "Navigation",
        home: "Accueil",
        events: "Événements",
        association: "L'Association",
        gettingHere: "Venir",
        news: "Actualités",
        volunteers: "Bénévoles",
        partners: "Partenaires",
        contactLabel: "Contact",
        contactTitle: "Contact",
        contactUsLink: "Nous contacter",
        ourValues: "Nos Valeurs",
        value1: "Transmission & Partage",
        value2: "Sport Responsable",
        value3: "Culture Accessible",
        value4: "Respect de la Nature",
        value5: "Convivialité",
        value6: "Bienveillance",
        becomeMember: "Devenir Adhérent",
        allRights: "Tous droits réservés",
        legalNotice: "Mentions légales",
        cgv: "CGV",
        privacy: "Confidentialité",
        description: "Association loi 1901 dédiée à la promotion des activités équestres, des sports de pleine nature et des événements culturels au Domaine de la Briouse."
      },
      // Venir (Getting Here) page
      venir: {
        title: "Venir au Domaine",
        subtitle: "Domaine de la Briouse",
        heroDesc: "Toutes les informations pratiques pour venir nous voir au cœur du Pays Mélusin.",
        howToCome: "Comment venir",
        accommodation: "Hébergements",
        restaurants: "Restaurants",
        discover: "Découvrir",
        byCar: "En voiture",
        byTrain: "En train",
        byPlane: "En avion",
        gps: "Coordonnées GPS",
        distance: "Distance",
        all: "Tous",
        onSite: "Sur place",
        nearby: "À proximité",
        book: "Réserver",
        visitWebsite: "Visiter le site",
        seeOnMap: "Voir sur la carte",
        discoverRegion: "Découvrir la Région",
        discoverDesc: "Le Domaine de la Briouse est idéalement situé au cœur du Pays Mélusin, entouré de sites remarquables.",
        filterByDistance: "Filtrer par distance",
        heritageNature: "Patrimoine & Nature",
        leisure: "Loisirs & Culture",
        beaches: "Plages & Littoral",
        contactTitle: "Besoin d'informations ?",
        contactDesc: "Notre équipe est disponible pour vous aider à organiser votre séjour.",
        contactBtn: "Nous contacter",
        callUs: "Appelez-nous",
        name: "Nom *",
        email: "Email *",
        messageLabel: "Message *",
        sendBtn: "Envoyer",
        msgSent: "Message envoyé !",
        msgSentDesc: "Nous vous répondrons rapidement.",
        msgError: "Erreur lors de l'envoi",
        msgErrorDesc: "Veuillez réessayer.",
        chambreHotes: "Chambres d'hôtes & Gîtes",
        camping: "Camping",
        hotel: "Hôtel",
        gite: "Gîte",
        traditional: "Cuisine traditionnelle",
        gastro: "Gastronomie",
        pizzeria: "Pizzeria",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Gamme de prix"
      },
      // Adhesion page
      adhesion: {
        title: "Adhésion",
        subtitle: "Devenir Adhérent",
        heroDesc: "Rejoignez l'association Brious'O Folies et participez à la vie du Domaine de la Briouse.",
        why: "Pourquoi adhérer ?",
        benefit1: "Soutenir nos événements",
        benefit1Desc: "Votre adhésion finance directement nos concerts, randonnées et animations.",
        benefit2: "Accès privilégié",
        benefit2Desc: "Tarifs réduits et accès prioritaire à certains événements.",
        benefit3: "Communauté",
        benefit3Desc: "Rejoignez une communauté passionnée du Pays Mélusin.",
        joinNow: "Adhérer maintenant",
        memberFor10: "Adhésion annuelle : 10€",
        helloAssoInfo: "L'adhésion se fait via HelloAsso, notre partenaire de paiement sécurisé.",
        questions: "Des questions ?",
        contactUs: "Contactez-nous"
      },
      // Actualites (News) page
      actualites: {
        title: "Actualités",
        subtitle: "Nos Actualités",
        heroDesc: "Suivez les dernières nouvelles de Brious'O Folies et du Domaine de la Briouse.",
        noNews: "Aucune actualité pour le moment.",
        stayTuned: "Restez connectés !",
        followUs: "Suivez-nous sur les réseaux sociaux pour ne rien manquer.",
        readMore: "Lire la suite",
        published: "Publié le",
        categories: "Catégories",
        all: "Toutes",
        mediaDeleted: "Média supprimé"
      },
      // Tombola page
      tombola: {
        title: "Grande Tombola",
        subtitle: "Tombola Brious'O Folies",
        heroDesc: "Participez à notre grande tombola et tentez de gagner un vol en montgolfière !",
        winBalloon: "Gagnez un Vol en Montgolfière !",
        description: "Participez à notre grande tombola et tentez de gagner un vol en montgolfière pour 2 personnes décollant directement du Domaine de la Briouse !",
        ticketPrice: "le ticket",
        drawDate: "Tirage le 8 Nov. 2026",
        drawTime: "Tirage à 18h",
        participate: "Participer à la Tombola",
        howItWorks: "Comment ça marche ?",
        step1: "Achetez votre ticket",
        step1Desc: "Tickets disponibles en ligne via HelloAsso ou sur place lors de nos événements.",
        step2: "Attendez le tirage",
        step2Desc: "Le tirage au sort aura lieu le 8 novembre 2026 à 18h au Domaine de la Briouse.",
        step3: "Envolez-vous !",
        step3Desc: "Le gagnant profitera d'un vol en montgolfière pour 2 personnes.",
        rules: "Règlement",
        rulesDesc: "Tombola organisée conformément à la réglementation en vigueur."
      },
      // Mentions Legales page
      legal: {
        title: "Mentions Légales",
        legalNotice: "Mentions Légales",
        cgv: "CGV",
        privacy: "Confidentialité",
        editor: "Éditeur du site",
        hosting: "Hébergement",
        intellectual: "Propriété intellectuelle",
        intellectualDesc: "L'ensemble du contenu de ce site (textes, images, vidéos) est protégé par le droit d'auteur.",
        dataProtection: "Protection des données",
        dataProtectionDesc: "Conformément au RGPD, vous disposez d'un droit d'accès, de modification et de suppression de vos données personnelles.",
        cookies: "Cookies",
        cookiesDesc: "Ce site utilise des cookies pour améliorer votre expérience de navigation.",
        contact: "Contact"
      },
      ip: {
        title: "Infos Pratiques",
        subtitle: "Toutes les informations essentielles pour chaque événement",
        selectEvent: "Sélectionnez un événement",
        navAcces: "Accès", navParcours: "Parcours", navProgramme: "Programme", navDocuments: "Documents",
        navContacts: "Contacts", navRestau: "Restauration", navResultats: "Résultats", navSecurite: "Sécurité", navConseils: "Conseils",
        accesTitle: "Accès & Stationnement", consignes: "Consignes d'accès",
        parcoursTitle: "Parcours & Itinéraires",
        programmeTitle: "Programme & Horaires", programmeComingSoon: "Programme à venir",
        programmeComingSoonDesc: "Le programme détaillé sera publié prochainement.",
        documentsTitle: "Documents & Roadbook", documentsOfficiels: "Documents Officiels",
        uploadDoc: "Déposer un document", uploading: "Envoi...",
        noDocsYet: "Aucun document officiel déposé pour le moment.",
        contactsTitle: "Contacts & Numéros Utiles", emergency: "Urgence",
        restaurationTitle: "Restauration & Buvette",
        resultatsTitle: "Résultats & Classements",
        securiteTitle: "Règles & Sécurité", readRules: "Lire le règlement complet", hideRules: "Masquer le règlement",
        weather14: "Météo à 14 jours", seoTitle: "Mots-clés de cette page", backToTop: "Retour en haut",
        download: "Télécharger", downloadGpx: "Télécharger le GPX", downloadPdf: "Télécharger le programme PDF",
        guideTitle: "Comprendre l'endurance équestre", guideSubtitle: "Guide pratique",
        guideIntro: "Ce guide vous accompagne pour comprendre les différentes catégories d'épreuves, les distances, les vitesses de référence et le calcul de votre temps sur piste.",
        guideCategories: "Les types d'épreuves",
        guideTable: "Tableau distance / temps", guideTableSub: "Temps estimé sur piste selon la distance et la vitesse moyenne",
        guideCalc: "Calculateur de vitesse",
        calcDepart: "Heure de départ", calcArrivee: "Heure d'arrivée", calcDistance: "Distance parcourue",
        calcReset: "Réinitialiser", calcTotalTime: "Temps total", calcAvgSpeed: "Vitesse moyenne",
        calcPlaceholder: "Renseignez vos données", calcPlaceholderSub: "Le résultat s'affichera automatiquement",
        guideRemember: "À retenir",
        guideRemember1: "Les temps indiqués sont des repères indicatifs pour vous aider à préparer votre course.",
        guideRemember2: "Le règlement officiel de l'épreuve reste toujours la référence.",
        guideRemember3: "Les temps réels peuvent varier selon les conditions météo, le terrain et le format de l'épreuve.",
        guideRemember4: "Écoutez votre cheval et privilégiez toujours le bien-être animal.",
        progDeparts: "Programme des départs", progDistance: "Distance", progDepart: "Départ",
        progCategories: "Catégories", progBoucles: "Boucles à suivre", progReal: "réels",
        progReadCourse: "Comment lire votre course",
        progReadCourseSub: "Suivez les couleurs dans l'ordre indiqué pour votre distance",
        progLegend: "Légende des boucles", progOrganisation: "Organisation de la journée",
        progPrizes: "Remise des prix", progImportantInfo: "Informations importantes",
        progBriefing: "Le briefing officiel est obligatoire avant chaque départ. Présentez-vous 30 min avant votre heure.",
        progAdjust: "Les horaires peuvent être ajustés le jour J selon les conditions météo ou de sécurité.",
        progVet: "Le contrôle vétérinaire est obligatoire avant la course et entre chaque boucle.",
        progReglement: "Référez-vous au règlement officiel de l'épreuve pour les modalités complètes.",
        progWarning: "Les cavaliers sont tenus de respecter strictement le balisage couleur de leurs boucles.",
        elevDistance: "Distance", elevDenivele: "Dénivelé", elevAltMin: "Alt. Min", elevAltMax: "Alt. Max",
        elevTerrain: "Chemins, sentiers et routes communales", elevWater: "Points d'eau sur le parcours",
        courses10to80: "Courses 10 à 80 km", courses100and120: "Courses 100 et 120 km",
        guideDistLabel: "Distances", guideNivLabel: "Niveaux", guideSpeedLabel: "Vitesses",
        calcExample: "Exemple", progBouclesLabel: "Boucles",
        catAmateurDesc: "Épreuves ouvertes aux cavaliers possédant une licence FFE. L'endurance amateur offre un cadre compétitif adapté à tous les profils.",
        catClubDesc: "Épreuves de découverte et de formation pour les cavaliers licenciés club. Idéales pour débuter en compétition.",
        catPrepaDesc: "Épreuves de formation et d'entraînement en conditions réelles avant la compétition officielle. Parfaites pour se préparer.",
        catVIDesc: "Le cavalier doit maintenir une vitesse précise imposée par le jury. La régularité et le contrôle sont essentiels.",
        catVRDesc: "Le cavalier doit respecter une vitesse cible avec une tolérance définie. Évalue la capacité à gérer son allure.",
        catSHFDesc: "Programme dédié aux jeunes chevaux sous l'égide de la Société Hippique Française. Formation sportive progressive.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Alt.",
        secCavaliers: "Sécurité des cavaliers", secChevaux: "Respect des chevaux", secEnvironnement: "Environnement",
        conseilsTitle: "Infos Pratiques & Conseils", conseilsSub: "Check-list, recommandations et météo",
        conseilsRecos: "Conseils & Recommandations", checklistTitle: "Check-list Cavaliers",
        logistiqueTitle: "Conseils Logistiques", viewAccommodation: "Voir les hébergements",
        weatherTitle: "Météo Sanxay — Prévisions 14 jours",
        weatherForecast: "Voir les prévisions à 14 jours sur Météo France",
        weatherLoading: "Chargement des prévisions...", weatherUnavailable: "Prévisions temporairement indisponibles",
        weatherLink: "Consulter Météo France — Sanxay",
        shareBtn: "PARTAGER", shareTitle: "Partager cette page", shareMessage: "Découvre les infos pratiques de {{event}} par Brious'O Folies",
        shareCopyLink: "Copier le lien", shareCopied: "Lien copié !"
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        events: "Events",
        news: "News",
        association: "The Association",
        partners: "Partners",
        gettingHere: "Getting Here",
        contact: "Contact",
        volunteer: "Volunteers",
        membership: "Membership"
      },
      home: {
        welcome: "Welcome to Brious'O Folies",
        subtitle: "Equestrian association in the heart of Nouvelle-Aquitaine",
        discoverEvents: "Discover our events",
        joinUs: "Join us",
        becomeVolunteer: "Become a volunteer",
        becomeMember: "Become a member",
        upcomingEvents: "Upcoming Events",
        viewAllEvents: "View all events",
        newsletter: "Newsletter",
        newsletterDesc: "Stay informed of our news",
        email: "Your email",
        subscribe: "Subscribe"
      },
      events: {
        title: "Our Events",
        subtitle: "Discover our endurance races and equestrian trails",
        allEvents: "All",
        endurance: "Endurance",
        randonnee: "Trail Ride",
        stage: "Training",
        concert: "Concert",
        register: "Register",
        learnMore: "Learn more",
        organization: "Organization",
        noEvents: "No events at the moment"
      },
      endurance: {
        title: "Regulations & Results",
        subtitle: "Official FFE, FEI and SHF regulations",
        regulations: "Official Regulations",
        results: "Our Results",
        france: "France - FFE",
        international: "International - FEI",
        youngHorses: "Young Horses - SHF",
        usefulLinks: "Useful Links",
        download: "Download"
      },
      organization: {
        title: "Organization",
        schedule: "Schedule",
        participants: "Participants",
        route: "Route",
        veterinary: "Veterinary",
        practicalInfo: "Practical Info",
        program: "Day Schedule",
        races: "Races",
        participantsList: "Participants List & Bib Numbers",
        roadBooks: "Road Books",
        mapsRoutes: "Maps & Routes",
        vetCards: "Veterinary Tracking Cards",
        vetInfo: "Veterinary Information",
        usefulNumbers: "Useful Numbers",
        emergencyNumbers: "Emergency Numbers",
        sitePlan: "Site Map",
        parking: "Parking",
        toilets: "Toilets",
        vetZone: "Veterinary Zone",
        groomingZone: "Grooming Zone",
        restZone: "Horse Rest Zone",
        backToEvents: "Back to events"
      },
      contact: {
        title: "Contact Us",
        subtitle: "Have a question? Don't hesitate to write to us",
        name: "Your name",
        email: "Your email",
        subject: "Subject",
        message: "Your message",
        send: "Send",
        sending: "Sending...",
        success: "Message sent successfully!",
        error: "Error sending message"
      },
      common: {
        readMore: "Read more",
        seeAll: "See all",
        loading: "Loading...",
        error: "Error",
        close: "Close",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        add: "Add",
        search: "Search",
        filter: "Filter",
        results: "results",
        comingSoon: "Coming soon",
        date: "Date",
        location: "Location",
        distance: "Distance",
        level: "Level",
        departure: "Departure",
        back: "Back",
        backToHome: "Back to home",
        backToEvents: "Back to events",
        backToNews: "Back to news",
        login: "Login",
        logout: "Logout",
        logoutSuccess: "Logged out successfully",
        loginSuccess: "Login successful",
        loginError: "Login error",
        invalidCredentials: "Invalid credentials.",
        welcome: "Welcome",
        book: "Book",
        free: "Free",
        send: "Send",
        sending: "Sending...",
        download: "Download",
        register: "Register",
        confirm: "Confirm",
        errorOccurred: "An error occurred",
        tryAgain: "Please try again",
        errorSending: "Error sending",
        errorCreating: "Error creating",
        errorUpdating: "Error updating",
        errorDeleting: "Error deleting",
        errorUpload: "Upload error",
        confirmDelete: "Delete this item?",
        confirmDeleteUser: "Delete this user?",
        addUser: "Add User",
        sendTestEmail: "Send test email",
        sendTestTo: "Send a test email to:",
        email: "Email",
        password: "Password",
        adminLogin: "Admin Login",
        staffArea: "Staff Area",
        manageMedia: "You can now manage media.",
        regulations: "Regulations & Results",
        officialRegulations: "Official regulations & Race results",
        ourResults: "Our Results",
        raceResults: "Brious'O Folies race results",
        resultsComingSoon: "Results coming soon",
        savedSuccess: "Saved successfully",
        savedError: "Error saving"
      },
      footer: {
        rights: "All rights reserved",
        legalNotice: "Legal Notice",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions",
        followUs: "Follow us"
      },
      // Association page
      association: {
        whoAreWe: "Who are we?",
        title: "The Association",
        description: "Brious'O Folies works year-round to promote equestrian activities, outdoor sports and cultural events.",
        heartOfMelusin: "An association in the heart of",
        paysMelusin: "Pays Mélusin",
        presentation1: "is a non-profit association under the 1901 law, created to organize sporting, equestrian and cultural events at the Domaine de la Briouse, in Sanxay (86).",
        ourMission: "Our mission:",
        missionDesc: "To promote and organize equestrian, sporting, cultural and heritage activities, while fostering conviviality, transmission and access to nature for all.",
        presentation2: "Equestrian rides, endurance races, open-air concerts, family events... We create moments of",
        conviviality: "conviviality, sharing and discovery",
        presentation3: ", open to riders, families, local residents and passing visitors.",
        becomeMember: "Become a Member",
        becomeVolunteer: "Become a Volunteer",
        becomePartner: "Become a Partner",
        keyFigures: "Key Figures 2025",
        eventsOrganized: "Events organized",
        inYear: "in 2025",
        artistsPerformers: "Artists & performers",
        ridersWelcomed: "Riders welcomed",
        visitorsOnSite: "Visitors on site",
        ourTeam: "Our Team",
        bureauMembers: "Board Members",
        bureauDesc: "A team of passionate volunteers with complementary skills, driven by strong values.",
        whatDrivesUs: "What drives us",
        ourValues: "Our Core Values",
        benevolence: "Benevolence",
        benevolenceDesc: "Welcoming each participant, volunteer or partner in a climate of respect, listening and safety.",
        respect: "Respect",
        respectDesc: "Ensuring the well-being of horses, protection of the environment and respect for heritage sites and people.",
        conviviality2: "Conviviality",
        convivialityDesc: "Creating warm, intergenerational moments where families, riders, residents, tourists and businesses meet.",
        environment: "Environment",
        environmentDesc: "Organizing sober and responsible events, attentive to impacts on nature and uses of rural spaces.",
        transmission: "Transmission",
        transmissionDesc: "Sharing equestrian know-how, heritage knowledge and civic values with young people and the general public.",
        accessibility: "Accessibility",
        accessibilityDesc: "Making sport, culture and nature accessible to as many people as possible.",
        ourImpact: "Our Impact",
        ourActions: "Our Actions",
        actionsDesc: "Through its actions, the association actively participates in revitalizing the territory, developing rural tourism and strengthening social bonds.",
        contactUs: "Contact us",
        contactQuestion: "For any question or information request",
        writeToUs: "Contact us",
        joinAdventure: "Join the adventure!",
        ctaDesc: "Whether you are a rider, a culture lover, a nature enthusiast or simply curious, there is a place for you at Brious'O Folies.",
        membershipFor: "Join for €10"
      },
      // Partners page
      partners: {
        becomePartner: "Become a Partner",
        supportUs: "Support Brious'O Folies",
        heroDesc: "Companies, artisans, local authorities: join the adventure and give visibility to your organization while supporting the territory!",
        downloadDossier: "Download Sponsorship Kit",
        contactUs: "Contact Us",
        whyJoinUs: "Why Join Us?",
        partnershipBenefits: "Partnership Benefits",
        localVisibility: "Local Visibility",
        localVisibilityDesc: "Reach a family-oriented, passionate and engaged audience in the Pays Mélusin territory.",
        positiveImage: "Positive Image",
        positiveImageDesc: "Associate your brand with strong values: nature, heritage, sport and accessible culture.",
        network: "Network",
        networkDesc: "Join a network of companies and local authorities committed to the territory.",
        taxBenefits: "Tax Benefits",
        taxBenefitsDesc: "Benefit from tax reductions through patronage (66% of donation deductible).",
        ourFormulas: "Our Formulas",
        choosePackage: "Choose Your Partner Package",
        packagesDesc: "Formulas adapted to all budgets, with concrete and measurable benefits.",
        selectPack: "Select this pack",
        technicalPartnership: "Technical Partnership / Patronage",
        technicalDesc: "Would you like to support us differently? Equipment, services, skills... Contact us for a custom offer!",
        discussProject: "Let's discuss your project",
        ourCommitment: "Our Commitment",
        whatWeGuarantee: "What we guarantee you",
        dedicatedContact: "A dedicated contact for each partner",
        taxOptimization: "Optimized taxation (tax receipt for donations)",
        customOffers: "Custom offers based on your needs",
        fullTransparency: "Full transparency on the use of funds",
        detailedReport: "Detailed report after each event",
        sponsorDossier: "Complete Sponsorship Kit",
        dossierDesc: "Find all detailed information: events, budgets, benefits and contacts.",
        downloadPdf: "Download PDF",
        questions: "Do you have questions?",
        questionsDesc: "Our team is at your disposal to build together a customized partnership.",
        thankPartners: "Thanks to our partners",
        theyTrusted: "They trusted us",
        thankYouDesc: "A big thank you to all the companies, institutions and local authorities that support Brious'O Folies.",
        institutionsCollectivities: "Institutions & Local Authorities",
        equestrianFederations: "Equestrian Federations",
        partnerCompanies: "Partner Companies",
        tourismLeisure: "Tourism & Leisure",
        readyToJoin: "Ready to join us?",
        ctaDesc: "Contact us now to discuss your partnership project and join the Brious'O Folies adventure!",
        partnershipRequest: "Partnership request",
        selectedPack: "Selected package",
        thankYouInterest: "Thank you for your interest!",
        requestSent: "Your request has been sent successfully. We will contact you very soon to discuss your partnership.",
        fullName: "Full name",
        company: "Company",
        phone: "Phone",
        sendRequest: "Send my request",
        formConsent: "By submitting this form, you agree to be contacted by the Brious'O Folies association."
      },
      // Homepage extended
      homeExt: {
        heroTitle1: "Experience the events of",
        heroTitle2: "in Sanxay",
        heroSubtitle: "Equestrian activities, outdoor sports and cultural events in the heart of",
        paysMelusin: "Pays Mélusin",
        seeEvents: "See events",
        becomeMember: "Become a Member",
        becomeVolunteer: "Become a volunteer",
        receiveNews: "Receive the news",
        eventsPerYear: "Events/year",
        visitorsWelcomed: "Visitors welcomed",
        volunteersActive: "Volunteers mobilized",
        landArea: "Of land",
        dontMiss: "Don't miss out!",
        upcomingEvents: "Upcoming Events",
        upcomingEventsDesc: "Concerts, equestrian rides, endurance races, country evenings... Discover our program and book your spot!",
        reserve: "Book",
        free: "FREE",
        seeAllEvents: "See all events",
        allYear: "All year round",
        seasonTitle: "Brious'O Folies Season",
        seasonDesc: "Events all year round following the rhythm of the seasons",
        spring: "Spring",
        summer: "Summer",
        autumn: "Autumn",
        winter: "Winter",
        springEvents: ["Riding lessons", "Nature hikes", "Easter egg hunt", "Country evenings"],
        summerEvents: ["Choir concerts", "Departmental endurance championship", "Flea markets"],
        autumnEvents: ["Halloween ride", "Movie afternoon", "Endurance race"],
        winterEvents: ["Movie afternoon", "Intimate concerts", "Workshops", "Games"],
        joinCommunity: "Join the Brious'O Folies community",
        newsletterDesc: "Receive news about our events, concerts, nature activities and endurance races.",
        iWantInfo: "I want to receive information about:",
        nlEndurance: "Equestrian endurance races",
        nlConcerts: "Concerts and shows",
        nlNature: "Nature activities and hikes",
        nlFamily: "Family events",
        nlPedagogy: "Educational activities",
        nlVolunteer: "Becoming a volunteer",
        emailPlaceholder: "Your email address",
        joinCommunityBtn: "Join the community",
        thankYou: "Thank you!",
        subscribedMsg: "You are now subscribed to our newsletter.",
        welcomeMsg: "Welcome to the community!",
        welcomeDesc: "You will soon receive our news.",
        prefsUpdated: "Preferences updated!",
        prefsUpdatedDesc: "Your interests have been updated.",
        joinTeam: "Join the team",
        becomeVolunteerTitle: "Become a Brious'O Folies volunteer",
        volunteerDesc: "Would you like to help organize sporting and cultural events? Join our volunteer team for unforgettable shared moments!",
        volunteerBenefit1: "Experience events from the inside",
        volunteerBenefit2: "Make great connections",
        volunteerBenefit3: "No experience required",
        volunteerBtn: "Become a volunteer",
        volunteersTrustUs: "Volunteers trust us",
        heritageNature: "Heritage & Nature",
        discoverSanxay: "Discover Sanxay and its region",
        discoverDesc: "The Domaine de la Briouse is ideally located to explore the treasures of Pays Mélusin",
        discoverRegion: "Discover the region",
        ourCommitment: "Our Commitment",
        valuesTitle: "Values that bring us together",
        benevolence: "Benevolence",
        benevolenceDesc: "A warm welcome for everyone",
        conviviality: "Conviviality",
        convivialityDesc: "Moments of sharing and meeting",
        respect: "Respect",
        respectDesc: "For nature and horses",
        culture: "Culture",
        cultureDesc: "Accessible artistic events",
        ourPlace: "Our Venue",
        domainTitle: "The Domaine de la Briouse",
        domainDesc: "Located in the heart of Pays Mélusin, the Domaine de la Briouse offers an exceptional natural and heritage setting. Close to the famous Gallo-Roman site of Sanxay, it is the ideal place for events combining sport, culture and nature.",
        howToCome: "How to get here",
        joinAdventure: "Join the Brious'O Folies adventure",
        ctaDesc: "Become a member and participate in the life of our association. Together, let's keep the heritage and conviviality of Pays Mélusin alive.",
        memberFor10: "Join for €10",
        contactUsBtn: "Contact us",
        call: "Call",
        galloRomanSite: "Gallo-Roman Site of Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      // Events page extended
      eventsExt: {
        calendar: "Calendar",
        calendar2026: "Calendar 2026",
        title: "Our Events",
        subtitle: "Equestrian rides, concerts, endurance races and family events... Discover all our activities at the Domaine de la Briouse.",
        downloadLivret: "Download the PDF Booklet",
        featured: "Featured",
        grandeTombola: "Grand Raffle",
        winBalloon: "Win a Hot Air Balloon Ride!",
        tombolaDesc: "Enter our grand raffle for a chance to win a hot air balloon ride for 2 people taking off directly from the Domaine de la Briouse!",
        ticket: "per ticket",
        drawAt: "Draw at 6pm",
        participateTombola: "Enter the Raffle",
        learnMore: "Learn more",
        filterByCategory: "Filter by category",
        allCategories: "All categories",
        resetFilters: "Reset filters",
        becomeMember: "Become a Member",
        memberDesc: "Support our association and enjoy exclusive benefits.",
        memberFor10: "Join for €10",
        noEventsFound: "No events found for these criteria.",
        seeAllEvents: "See all events",
        reserve: "Book",
        freeEntry: "Free entry",
        orga: "Org",
        equitation: "Riding",
        concert: "Concert",
        randonnee: "Trail Ride",
        course: "Race",
        brocante: "Flea Market",
        cinema: "Cinema"
      },
      // Contact page extended
      contactExt: {
        contactUs: "Contact Us",
        title: "Contact",
        subtitle: "A question, a suggestion, want to join us? Don't hesitate to contact us.",
        contactInfo: "Contact Information",
        phone: "Phone",
        address: "Address",
        onlineMembership: "Online Membership",
        joinViaHelloAsso: "Join our association via HelloAsso.",
        memberFor10: "Join for €10",
        sendMessage: "Send us a message",
        fullName: "Full name *",
        email: "Email *",
        subject: "Subject *",
        subjectPlaceholder: "About...",
        message: "Message *",
        messagePlaceholder: "Your message...",
        newsletterCheckbox: "I want to subscribe to the newsletter to receive Brious'O Folies news",
        sendBtn: "Send message",
        successMsg: "Message sent successfully!",
        successDescNewsletter: "You are also subscribed to the newsletter.",
        successDesc: "We will reply to you as soon as possible.",
        errorMsg: "Error sending message",
        errorDesc: "Please try again later.",
        findUs: "Find Us"
      },
      // Volunteers page
      benevoles: {
        joinAdventure: "Join the adventure",
        title: "Become a Volunteer",
        heroDesc: "The events we organize would not be possible without the commitment and generosity of those who give a little of their time.",
        signUp: "Sign up as a volunteer",
        thanks: "Thank you!",
        callTitle: "Brious'O Folies is calling!",
        callP1: "Today, <strong>Brious'O Folies</strong> is calling all residents who wish to become volunteers and participate in local life.",
        callP2: "<strong>Sporting events, concerts, shows, hikes, family activities or festive gatherings</strong>: our projects are varied, and everyone can find their place.",
        callP3: "Welcoming the public, helping with organization, logistics, installation, communication, accompanying participants or a simple helping hand... <strong>there are a thousand ways to get involved</strong>, according to your wishes, skills and availability.",
        chooseEvent: "Choose your event",
        eventsCalendar: "Events Calendar",
        clickToSign: "Click on an event to sign up as a volunteer",
        selectedEvent: "Selected Event",
        monthEvents: "Events this month",
        volunteerForEvent: "Volunteer for this event",
        seeAllEvents: "See all events",
        noEventThisMonth: "No events this month.",
        navigateCalendar: "Navigate the calendar!",
        findYourPlace: "Find your place",
        missionTypes: "Types of Missions",
        missionDesc: "There are many ways to contribute according to your wishes and skills.",
        publicWelcome: "Public Welcome",
        publicWelcomeDesc: "Guide and inform visitors during our events",
        logistics: "Logistics & Setup",
        logisticsDesc: "Setting up stands, signage and facilities",
        animation: "Entertainment",
        animationDesc: "Assist participants during shows and concerts",
        helpOut: "Occasional Help",
        helpOutDesc: "Various help according to your availability and wishes",
        whyJoin: "Why join us?",
        beingVolunteer: "Being a volunteer means...",
        beingVolunteerDesc: "Experience events from the inside, share strong moments, make great connections and contribute to meaningful projects for our territory.",
        benefit1: "Experience events from the inside",
        benefit2: "Make great connections",
        benefit3: "Contribute to meaningful projects",
        benefit4: "Friendly and caring atmosphere",
        benefit5: "No experience required",
        benefit6: "Commitment based on your availability",
        essentialDesire: "The essential thing is the desire!",
        essentialP1: "No particular experience is necessary: the essential thing is the desire to participate, to share and to be part of a collective adventure.",
        essentialP2: "Joining the Brious'O Folies volunteer team means committing to a",
        essentialP2Bold: "friendly and caring atmosphere",
        essentialP2End: ", in service of sharing, culture, sport and nature.",
        ifAdventureTempts: "If the adventure tempts you...",
        ctaDesc: "Come meet us at our events or sign up directly: we will be delighted to welcome you and write the next chapter of this beautiful story together!",
        becomeVolunteer: "I become a volunteer",
        contactUs: "Contact us",
        followSocial: "Follow us on social media!",
        dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
      },
      // Footer
      footerExt: {
        visitorsSay: "What our visitors say",
        review1: "Great atmosphere, top team!",
        review2: "Quality events, we'll be back!",
        review3: "Magnificent setting, well-cared-for horses",
        navigation: "Navigation",
        home: "Home",
        events: "Events",
        association: "The Association",
        gettingHere: "Getting Here",
        news: "News",
        volunteers: "Volunteers",
        partners: "Partners",
        contactLabel: "Contact",
        contactTitle: "Contact",
        contactUsLink: "Contact us",
        ourValues: "Our Values",
        value1: "Transmission & Sharing",
        value2: "Responsible Sport",
        value3: "Accessible Culture",
        value4: "Respect for Nature",
        value5: "Conviviality",
        value6: "Benevolence",
        becomeMember: "Become a Member",
        allRights: "All rights reserved",
        legalNotice: "Legal Notice",
        cgv: "T&Cs",
        privacy: "Privacy",
        description: "Non-profit association dedicated to promoting equestrian activities, outdoor sports and cultural events at the Domaine de la Briouse."
      },
      venir: {
        title: "Getting Here",
        subtitle: "Domaine de la Briouse",
        heroDesc: "All the practical information to visit us in the heart of Pays Mélusin.",
        howToCome: "How to get here",
        accommodation: "Accommodation",
        restaurants: "Restaurants",
        discover: "Discover",
        byCar: "By car",
        byTrain: "By train",
        byPlane: "By plane",
        gps: "GPS Coordinates",
        distance: "Distance",
        all: "All",
        onSite: "On site",
        nearby: "Nearby",
        book: "Book",
        visitWebsite: "Visit website",
        seeOnMap: "See on map",
        discoverRegion: "Discover the Region",
        discoverDesc: "The Domaine de la Briouse is ideally located in the heart of Pays Mélusin, surrounded by remarkable sites.",
        filterByDistance: "Filter by distance",
        heritageNature: "Heritage & Nature",
        leisure: "Leisure & Culture",
        beaches: "Beaches & Coast",
        contactTitle: "Need information?",
        contactDesc: "Our team is available to help you plan your stay.",
        contactBtn: "Contact us",
        callUs: "Call us",
        name: "Name *",
        email: "Email *",
        messageLabel: "Message *",
        sendBtn: "Send",
        msgSent: "Message sent!",
        msgSentDesc: "We will reply soon.",
        msgError: "Error sending message",
        msgErrorDesc: "Please try again.",
        chambreHotes: "B&B & Cottages",
        camping: "Camping",
        hotel: "Hotel",
        gite: "Holiday cottage",
        traditional: "Traditional cuisine",
        gastro: "Fine dining",
        pizzeria: "Pizzeria",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Price range"
      },
      adhesion: {
        title: "Membership",
        subtitle: "Become a Member",
        heroDesc: "Join the Brious'O Folies association and participate in the life of the Domaine de la Briouse.",
        why: "Why join?",
        benefit1: "Support our events",
        benefit1Desc: "Your membership directly funds our concerts, rides and activities.",
        benefit2: "Priority access",
        benefit2Desc: "Reduced rates and priority access to certain events.",
        benefit3: "Community",
        benefit3Desc: "Join a passionate community of Pays Mélusin.",
        joinNow: "Join now",
        memberFor10: "Annual membership: €10",
        helloAssoInfo: "Membership is done via HelloAsso, our secure payment partner.",
        questions: "Questions?",
        contactUs: "Contact us"
      },
      actualites: {
        title: "News",
        subtitle: "Our News",
        heroDesc: "Follow the latest news from Brious'O Folies and the Domaine de la Briouse.",
        noNews: "No news at the moment.",
        stayTuned: "Stay connected!",
        followUs: "Follow us on social media to not miss anything.",
        readMore: "Read more",
        published: "Published on",
        categories: "Categories",
        all: "All",
        mediaDeleted: "Media deleted"
      },
      tombola: {
        title: "Grand Raffle",
        subtitle: "Brious'O Folies Raffle",
        heroDesc: "Enter our grand raffle for a chance to win a hot air balloon ride!",
        winBalloon: "Win a Hot Air Balloon Ride!",
        description: "Enter our grand raffle for a chance to win a hot air balloon ride for 2 people taking off directly from the Domaine de la Briouse!",
        ticketPrice: "per ticket",
        drawDate: "Draw on Nov 8, 2026",
        drawTime: "Draw at 6pm",
        participate: "Enter the Raffle",
        howItWorks: "How does it work?",
        step1: "Buy your ticket",
        step1Desc: "Tickets available online via HelloAsso or on site during our events.",
        step2: "Wait for the draw",
        step2Desc: "The draw will take place on November 8, 2026 at 6pm at the Domaine de la Briouse.",
        step3: "Take flight!",
        step3Desc: "The winner will enjoy a hot air balloon ride for 2 people.",
        rules: "Rules",
        rulesDesc: "Raffle organized in accordance with current regulations."
      },
      legal: {
        title: "Legal Notice",
        legalNotice: "Legal Notice",
        cgv: "Terms & Conditions",
        privacy: "Privacy Policy",
        editor: "Website publisher",
        hosting: "Hosting",
        intellectual: "Intellectual property",
        intellectualDesc: "All content on this site (text, images, videos) is protected by copyright.",
        dataProtection: "Data protection",
        dataProtectionDesc: "In accordance with GDPR, you have the right to access, modify and delete your personal data.",
        cookies: "Cookies",
        cookiesDesc: "This site uses cookies to improve your browsing experience.",
        contact: "Contact"
      },
      loginModal: {
        staffArea: "Staff Area",
        memberArea: "Member Area",
        staffDesc: "Administration of the Brious'O Folies website",
        memberDesc: "Access your personal space",
        createAccount: "Create your member account",
        member: "Member",
        signIn: "Sign In",
        firstName: "First Name",
        lastName: "Last Name",
        phone: "Phone",
        createMyAccount: "Create my account",
        accountCreated: "Account created! Sign in now.",
        alreadyAccount: "Already have an account? Sign in",
        noAccount: "No account yet? Register"
      },
      ip: {
        title: "Practical Info", subtitle: "All essential information for each event",
        selectEvent: "Select an event",
        navAcces: "Access", navParcours: "Trails", navProgramme: "Schedule", navDocuments: "Documents",
        navContacts: "Contacts", navRestau: "Catering", navResultats: "Results", navSecurite: "Safety", navConseils: "Tips",
        accesTitle: "Access & Parking", consignes: "Access instructions",
        parcoursTitle: "Trails & Routes",
        programmeTitle: "Schedule & Timetable", programmeComingSoon: "Schedule coming soon",
        programmeComingSoonDesc: "The detailed schedule will be published soon.",
        documentsTitle: "Documents & Roadbook", documentsOfficiels: "Official Documents",
        uploadDoc: "Upload a document", uploading: "Uploading...",
        noDocsYet: "No official documents uploaded yet.",
        contactsTitle: "Contacts & Useful Numbers", emergency: "Emergency",
        restaurationTitle: "Catering & Refreshments", resultatsTitle: "Results & Rankings",
        securiteTitle: "Rules & Safety", readRules: "Read full rules", hideRules: "Hide rules",
        weather14: "14-day weather", seoTitle: "Keywords for this page", backToTop: "Back to top",
        download: "Download", downloadGpx: "Download GPX", downloadPdf: "Download schedule PDF",
        guideTitle: "Understanding equestrian endurance", guideSubtitle: "Practical guide",
        guideIntro: "This guide helps you understand event categories, distances, reference speeds and time calculation.",
        guideCategories: "Types of events",
        guideTable: "Distance / time table", guideTableSub: "Estimated trail time by distance and average speed",
        guideCalc: "Speed calculator",
        calcDepart: "Departure time", calcArrivee: "Arrival time", calcDistance: "Distance covered",
        calcReset: "Reset", calcTotalTime: "Total time", calcAvgSpeed: "Average speed",
        calcPlaceholder: "Enter your data", calcPlaceholderSub: "Results will appear automatically",
        guideRemember: "Remember",
        guideRemember1: "Times shown are indicative benchmarks.",
        guideRemember2: "The official event rules always remain the reference.",
        guideRemember3: "Actual times may vary depending on conditions.",
        guideRemember4: "Listen to your horse and always prioritize animal welfare.",
        progDeparts: "Departure schedule", progDistance: "Distance", progDepart: "Start",
        progCategories: "Categories", progBoucles: "Loops to follow", progReal: "actual",
        progReadCourse: "How to read your course",
        progReadCourseSub: "Follow the colors in the order shown for your distance",
        progLegend: "Loop legend", progOrganisation: "Day organization",
        progPrizes: "Prize ceremony", progImportantInfo: "Important information",
        progBriefing: "The official briefing is mandatory before each start.",
        progAdjust: "Schedules may be adjusted depending on conditions.",
        progVet: "Veterinary checks are mandatory before the race and between each loop.",
        progReglement: "Please refer to the official event rules for full details.",
        progWarning: "Riders must strictly follow the color markings of their loops.",
        elevDistance: "Distance", elevDenivele: "Elevation", elevAltMin: "Alt. Min", elevAltMax: "Alt. Max",
        elevTerrain: "Paths, trails and local roads", elevWater: "Water points along the trail",
        courses10to80: "Races 10 to 80 km", courses100and120: "Races 100 and 120 km",
        guideDistLabel: "Distances", guideNivLabel: "Levels", guideSpeedLabel: "Speeds",
        calcExample: "Example", progBouclesLabel: "Loops",
        catAmateurDesc: "Events open to riders with an FFE license. Amateur endurance provides a competitive framework for all profiles.",
        catClubDesc: "Discovery and training events for club-licensed riders. Ideal for starting in competition.",
        catPrepaDesc: "Training events in real conditions before official competition. Perfect for preparation.",
        catVIDesc: "The rider must maintain a precise speed set by the judges. Regularity and control are essential.",
        catVRDesc: "The rider must respect a target speed within a defined tolerance. Tests the ability to manage pace.",
        catSHFDesc: "Program for young horses under the French Horse Society. Progressive sports training.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Alt.",
        secCavaliers: "Rider safety", secChevaux: "Horse welfare", secEnvironnement: "Environment",
        conseilsTitle: "Practical Info & Tips", conseilsSub: "Checklist, recommendations and weather",
        conseilsRecos: "Tips & Recommendations", checklistTitle: "Rider Checklist",
        logistiqueTitle: "Logistics Tips", viewAccommodation: "View accommodations",
        weatherTitle: "Sanxay Weather — 14-day forecast",
        weatherForecast: "View 14-day forecast on Météo France",
        weatherLoading: "Loading forecast...", weatherUnavailable: "Forecast temporarily unavailable",
        weatherLink: "Check Météo France — Sanxay",
        shareBtn: "SHARE", shareTitle: "Share this page", shareMessage: "Check out the practical info for {{event}} by Brious'O Folies",
        shareCopyLink: "Copy link", shareCopied: "Link copied!"
      }
    }
  },
  es: {
    translation: {
      nav: {
        home: "Inicio",
        events: "Eventos",
        news: "Noticias",
        association: "La Asociación",
        partners: "Socios",
        gettingHere: "Cómo llegar",
        contact: "Contacto",
        volunteer: "Voluntarios",
        membership: "Membresía"
      },
      home: {
        welcome: "Bienvenido a Brious'O Folies",
        subtitle: "Asociación ecuestre en el corazón de Nueva Aquitania",
        discoverEvents: "Descubre nuestros eventos",
        joinUs: "Únete a nosotros",
        becomeVolunteer: "Ser voluntario",
        becomeMember: "Hacerse miembro",
        upcomingEvents: "Próximos eventos",
        viewAllEvents: "Ver todos los eventos",
        newsletter: "Boletín",
        newsletterDesc: "Mantente informado de nuestras noticias",
        email: "Tu email",
        subscribe: "Suscribirse"
      },
      events: {
        title: "Nuestros Eventos",
        subtitle: "Descubre nuestras carreras de resistencia y rutas ecuestres",
        allEvents: "Todos",
        endurance: "Resistencia",
        randonnee: "Ruta",
        stage: "Entrenamiento",
        concert: "Concierto",
        register: "Inscribirse",
        learnMore: "Más información",
        organization: "Organización",
        noEvents: "No hay eventos por el momento"
      },
      endurance: {
        title: "Reglamentos y Resultados",
        subtitle: "Reglamentos oficiales FFE, FEI y SHF",
        regulations: "Reglamentos Oficiales",
        results: "Nuestros Resultados",
        france: "Francia - FFE",
        international: "Internacional - FEI",
        youngHorses: "Caballos Jóvenes - SHF",
        usefulLinks: "Enlaces útiles",
        download: "Descargar"
      },
      organization: {
        title: "Organización",
        schedule: "Horarios",
        participants: "Participantes",
        route: "Recorrido",
        veterinary: "Veterinario",
        practicalInfo: "Info práctica",
        program: "Programa del día",
        races: "Pruebas",
        participantsList: "Lista de participantes y dorsales",
        roadBooks: "Road Books",
        mapsRoutes: "Mapas y rutas",
        vetCards: "Tarjetas de seguimiento veterinario",
        vetInfo: "Información veterinaria",
        usefulNumbers: "Números útiles",
        emergencyNumbers: "Números de emergencia",
        sitePlan: "Plano del sitio",
        parking: "Aparcamiento",
        toilets: "Aseos",
        vetZone: "Zona veterinaria",
        groomingZone: "Zona de grooming",
        restZone: "Zona de descanso caballos",
        backToEvents: "Volver a eventos"
      },
      contact: {
        title: "Contáctanos",
        subtitle: "¿Tienes una pregunta? No dudes en escribirnos",
        name: "Tu nombre",
        email: "Tu email",
        subject: "Asunto",
        message: "Tu mensaje",
        send: "Enviar",
        sending: "Enviando...",
        success: "¡Mensaje enviado con éxito!",
        error: "Error al enviar el mensaje"
      },
      common: {
        readMore: "Leer más",
        seeAll: "Ver todo",
        loading: "Cargando...",
        error: "Error",
        close: "Cerrar",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        add: "Añadir",
        search: "Buscar",
        filter: "Filtrar",
        results: "resultados",
        comingSoon: "Próximamente",
        date: "Fecha",
        location: "Ubicación",
        distance: "Distancia",
        level: "Nivel",
        departure: "Salida",
        back: "Volver",
        backToHome: "Volver al inicio",
        backToEvents: "Volver a eventos",
        backToNews: "Volver a noticias",
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        logoutSuccess: "Sesión cerrada correctamente",
        loginSuccess: "Sesión iniciada correctamente",
        loginError: "Error de inicio de sesión",
        invalidCredentials: "Credenciales incorrectas.",
        welcome: "Bienvenido",
        book: "Reservar",
        free: "Gratis",
        send: "Enviar",
        sending: "Enviando...",
        download: "Descargar",
        register: "Inscripción",
        confirm: "Confirmar",
        errorOccurred: "Se produjo un error",
        tryAgain: "Por favor, inténtelo de nuevo",
        errorSending: "Error al enviar",
        errorCreating: "Error al crear",
        errorUpdating: "Error al actualizar",
        errorDeleting: "Error al eliminar",
        errorUpload: "Error al subir",
        confirmDelete: "¿Eliminar este elemento?",
        confirmDeleteUser: "¿Eliminar este usuario?",
        addUser: "Añadir Usuario",
        sendTestEmail: "Enviar email de prueba",
        sendTestTo: "Enviar email de prueba a:",
        email: "Email",
        password: "Contraseña",
        adminLogin: "Acceso Admin",
        staffArea: "Área Staff",
        manageMedia: "Ahora puede gestionar los medios.",
        regulations: "Reglamentos y Resultados",
        officialRegulations: "Reglamentos oficiales y Resultados de carreras",
        ourResults: "Nuestros Resultados",
        raceResults: "Resultados de carreras Brious'O Folies",
        resultsComingSoon: "Resultados próximamente",
        savedSuccess: "Guardado correctamente",
        savedError: "Error al guardar"
      },
      footer: {
        rights: "Todos los derechos reservados",
        legalNotice: "Aviso legal",
        privacy: "Política de privacidad",
        terms: "Términos y condiciones",
        followUs: "Síguenos"
      },
      // Association page
      association: {
        whoAreWe: "¿Quiénes somos?",
        title: "La Asociación",
        description: "Brious'O Folies trabaja todo el año para promover las actividades ecuestres, los deportes al aire libre y los eventos culturales.",
        heartOfMelusin: "Una asociación en el corazón del",
        paysMelusin: "Pays Mélusin",
        presentation1: "es una asociación sin ánimo de lucro según la ley de 1901, creada para organizar eventos deportivos, ecuestres y culturales en el Domaine de la Briouse, en Sanxay (86).",
        ourMission: "Nuestra misión:",
        missionDesc: "Promover y organizar actividades ecuestres, deportivas, culturales y patrimoniales, fomentando la convivencia, la transmisión y el acceso a la naturaleza para todos.",
        presentation2: "Paseos a caballo, carreras de resistencia, conciertos al aire libre, eventos familiares... Creamos momentos de",
        conviviality: "convivencia, intercambio y descubrimiento",
        presentation3: ", abiertos a jinetes, familias, residentes locales y visitantes de paso.",
        becomeMember: "Hacerse Socio",
        becomeVolunteer: "Ser Voluntario",
        becomePartner: "Ser Socio",
        keyFigures: "Cifras Clave 2025",
        eventsOrganized: "Eventos organizados",
        inYear: "en 2025",
        artistsPerformers: "Artistas e intérpretes",
        ridersWelcomed: "Jinetes acogidos",
        visitorsOnSite: "Visitantes en el sitio",
        ourTeam: "Nuestro Equipo",
        bureauMembers: "Miembros de la Junta",
        bureauDesc: "Un equipo de voluntarios apasionados con habilidades complementarias, impulsados por valores fuertes.",
        whatDrivesUs: "Lo que nos impulsa",
        ourValues: "Nuestros Valores Fundamentales",
        benevolence: "Benevolencia",
        benevolenceDesc: "Acoger a cada participante, voluntario o socio en un clima de respeto, escucha y seguridad.",
        respect: "Respeto",
        respectDesc: "Velar por el bienestar de los caballos, la protección del medio ambiente y el respeto de los sitios patrimoniales y las personas.",
        conviviality2: "Convivencia",
        convivialityDesc: "Crear momentos cálidos e intergeneracionales donde se encuentren familias, jinetes, residentes, turistas y empresas.",
        environment: "Medio Ambiente",
        environmentDesc: "Organizar eventos sobrios y responsables, atentos a los impactos sobre la naturaleza y los usos de los espacios rurales.",
        transmission: "Transmisión",
        transmissionDesc: "Compartir conocimientos ecuestres, conocimientos patrimoniales y valores cívicos con los jóvenes y el público en general.",
        accessibility: "Accesibilidad",
        accessibilityDesc: "Hacer accesible el deporte, la cultura y la naturaleza al mayor número de personas posible.",
        ourImpact: "Nuestro Impacto",
        ourActions: "Nuestras Acciones",
        actionsDesc: "A través de sus acciones, la asociación participa activamente en la dinamización del territorio, el desarrollo del turismo rural y el fortalecimiento de los lazos sociales.",
        contactUs: "Contáctanos",
        contactQuestion: "Para cualquier pregunta o solicitud de información",
        writeToUs: "Contactar",
        joinAdventure: "¡Únete a la aventura!",
        ctaDesc: "Ya seas jinete, amante de la cultura, entusiasta de la naturaleza o simplemente curioso, hay un lugar para ti en Brious'O Folies.",
        membershipFor: "Únete por 10€"
      },
      // Partners page
      partners: {
        becomePartner: "Conviértete en Socio",
        supportUs: "Apoya a Brious'O Folies",
        heroDesc: "Empresas, artesanos, colectividades: ¡únete a la aventura y da visibilidad a tu organización mientras apoyas el territorio!",
        downloadDossier: "Descargar Dossier de Patrocinio",
        contactUs: "Contáctanos",
        whyJoinUs: "¿Por qué unirse?",
        partnershipBenefits: "Beneficios del Patrocinio",
        localVisibility: "Visibilidad Local",
        localVisibilityDesc: "Llega a un público familiar, apasionado y comprometido en el territorio del Pays Mélusin.",
        positiveImage: "Imagen Positiva",
        positiveImageDesc: "Asocia tu marca con valores fuertes: naturaleza, patrimonio, deporte y cultura accesible.",
        network: "Red",
        networkDesc: "Únete a una red de empresas y colectividades comprometidas con el territorio.",
        taxBenefits: "Beneficios Fiscales",
        taxBenefitsDesc: "Benefíciate de reducciones fiscales gracias al mecenazgo (66% de la donación deducible).",
        ourFormulas: "Nuestras Fórmulas",
        choosePackage: "Elige tu Pack de Socio",
        packagesDesc: "Fórmulas adaptadas a todos los presupuestos, con contrapartidas concretas y medibles.",
        selectPack: "Elegir este pack",
        technicalPartnership: "Patrocinio Técnico / Mecenazgo",
        technicalDesc: "¿Quieres apoyarnos de otra manera? Equipos, servicios, habilidades... ¡Contáctanos para una oferta personalizada!",
        discussProject: "Hablemos de tu proyecto",
        ourCommitment: "Nuestro Compromiso",
        whatWeGuarantee: "Lo que te garantizamos",
        dedicatedContact: "Un interlocutor dedicado para cada socio",
        taxOptimization: "Fiscalidad optimizada (recibo fiscal para donaciones)",
        customOffers: "Ofertas personalizadas según tus necesidades",
        fullTransparency: "Transparencia total sobre el uso de los fondos",
        detailedReport: "Informe detallado después de cada evento",
        sponsorDossier: "Dossier de Patrocinio Completo",
        dossierDesc: "Encuentra toda la información detallada: eventos, presupuestos, contrapartidas y contactos.",
        downloadPdf: "Descargar PDF",
        questions: "¿Tienes preguntas?",
        questionsDesc: "Nuestro equipo está a tu disposición para construir juntos un patrocinio personalizado.",
        thankPartners: "Gracias a nuestros socios",
        theyTrusted: "Ellos confiaron en nosotros",
        thankYouDesc: "Un gran agradecimiento a todas las empresas, instituciones y colectividades que apoyan a Brious'O Folies.",
        institutionsCollectivities: "Instituciones y Colectividades",
        equestrianFederations: "Federaciones Ecuestres",
        partnerCompanies: "Empresas Socias",
        tourismLeisure: "Turismo y Ocio",
        readyToJoin: "¿Listo para unirte?",
        ctaDesc: "¡Contáctanos ahora para discutir tu proyecto de patrocinio y unirte a la aventura Brious'O Folies!",
        partnershipRequest: "Solicitud de patrocinio",
        selectedPack: "Pack seleccionado",
        thankYouInterest: "¡Gracias por tu interés!",
        requestSent: "Tu solicitud ha sido enviada con éxito. Te contactaremos muy pronto para discutir tu patrocinio.",
        fullName: "Nombre completo",
        company: "Empresa",
        phone: "Teléfono",
        sendRequest: "Enviar mi solicitud",
        formConsent: "Al enviar este formulario, aceptas ser contactado por la asociación Brious'O Folies."
      },
      loginModal: {
        staffArea: "Área Staff",
        memberArea: "Área Miembro",
        staffDesc: "Administración del sitio Brious'O Folies",
        memberDesc: "Accede a tu espacio personal",
        createAccount: "Crea tu cuenta de miembro",
        member: "Miembro",
        signIn: "Iniciar sesión",
        firstName: "Nombre",
        lastName: "Apellido",
        phone: "Teléfono",
        createMyAccount: "Crear mi cuenta",
        accountCreated: "¡Cuenta creada! Inicia sesión ahora.",
        alreadyAccount: "¿Ya tienes cuenta? Iniciar sesión",
        noAccount: "¿No tienes cuenta? Registrarse"
      },
      ip: {
        title: "Información Práctica", subtitle: "Toda la información esencial para cada evento",
        selectEvent: "Seleccione un evento",
        navAcces: "Acceso", navParcours: "Recorridos", navProgramme: "Programa", navDocuments: "Documentos",
        navContacts: "Contactos", navRestau: "Restauración", navResultats: "Resultados", navSecurite: "Seguridad", navConseils: "Consejos",
        accesTitle: "Acceso & Estacionamiento", consignes: "Instrucciones de acceso",
        parcoursTitle: "Recorridos & Rutas",
        programmeTitle: "Programa & Horarios", programmeComingSoon: "Programa próximamente",
        programmeComingSoonDesc: "El programa detallado se publicará pronto.",
        documentsTitle: "Documentos & Roadbook", documentsOfficiels: "Documentos Oficiales",
        uploadDoc: "Subir un documento", uploading: "Subiendo...",
        noDocsYet: "Ningún documento oficial subido todavía.",
        contactsTitle: "Contactos & Números Útiles", emergency: "Urgencia",
        restaurationTitle: "Restauración & Bar", resultatsTitle: "Resultados & Clasificaciones",
        securiteTitle: "Reglas & Seguridad", readRules: "Leer reglamento completo", hideRules: "Ocultar reglamento",
        weather14: "Meteorología a 14 días", seoTitle: "Palabras clave", backToTop: "Volver arriba",
        download: "Descargar", downloadGpx: "Descargar GPX", downloadPdf: "Descargar programa PDF",
        guideTitle: "Entender la resistencia ecuestre", guideSubtitle: "Guía práctica",
        guideIntro: "Esta guía le ayuda a comprender las categorías de pruebas, distancias y velocidades.",
        guideCategories: "Tipos de pruebas",
        guideTable: "Tabla distancia / tiempo", guideTableSub: "Tiempo estimado según distancia y velocidad media",
        guideCalc: "Calculador de velocidad",
        calcDepart: "Hora de salida", calcArrivee: "Hora de llegada", calcDistance: "Distancia recorrida",
        calcReset: "Reiniciar", calcTotalTime: "Tiempo total", calcAvgSpeed: "Velocidad media",
        calcPlaceholder: "Introduzca sus datos", calcPlaceholderSub: "El resultado aparecerá automáticamente",
        guideRemember: "A recordar",
        guideRemember1: "Los tiempos son referencias indicativas.",
        guideRemember2: "El reglamento oficial es siempre la referencia.",
        guideRemember3: "Los tiempos reales pueden variar según las condiciones.",
        guideRemember4: "Escuche a su caballo y priorice el bienestar animal.",
        progDeparts: "Programa de salidas", progDistance: "Distancia", progDepart: "Salida",
        progCategories: "Categorías", progBoucles: "Bucles a seguir", progReal: "reales",
        progReadCourse: "Cómo leer su carrera", progReadCourseSub: "Siga los colores en el orden indicado",
        progLegend: "Leyenda de bucles", progOrganisation: "Organización del día",
        progPrizes: "Entrega de premios", progImportantInfo: "Información importante",
        progBriefing: "El briefing oficial es obligatorio. Preséntese 30 min antes.",
        progAdjust: "Los horarios pueden ajustarse según las condiciones.",
        progVet: "El control veterinario es obligatorio antes y entre cada bucle.",
        progReglement: "Consulte el reglamento oficial para los detalles completos.",
        progWarning: "Los jinetes deben respetar estrictamente las marcas de color.",
        elevDistance: "Distancia", elevDenivele: "Desnivel", elevAltMin: "Alt. Mín", elevAltMax: "Alt. Máx",
        elevTerrain: "Caminos, senderos y carreteras locales", elevWater: "Puntos de agua en el recorrido",
        courses10to80: "Carreras 10 a 80 km", courses100and120: "Carreras 100 y 120 km",
        guideDistLabel: "Distancias", guideNivLabel: "Niveles", guideSpeedLabel: "Velocidades",
        calcExample: "Ejemplo", progBouclesLabel: "Bucles",
        catAmateurDesc: "Pruebas abiertas a jinetes con licencia FFE. La resistencia amateur ofrece un marco competitivo para todos los perfiles.",
        catClubDesc: "Pruebas de descubrimiento y formación para jinetes con licencia de club. Ideales para iniciarse en competición.",
        catPrepaDesc: "Pruebas de formación en condiciones reales antes de la competición oficial. Perfectas para prepararse.",
        catVIDesc: "El jinete debe mantener una velocidad precisa impuesta por el jurado. La regularidad y el control son esenciales.",
        catVRDesc: "El jinete debe respetar una velocidad objetivo con una tolerancia definida.",
        catSHFDesc: "Programa dedicado a caballos jóvenes bajo la Sociedad Hípica Francesa. Formación deportiva progresiva.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Alt.",
        secCavaliers: "Seguridad de jinetes", secChevaux: "Bienestar del caballo", secEnvironnement: "Medio ambiente",
        conseilsTitle: "Info Práctica & Consejos", conseilsSub: "Lista de verificación, recomendaciones y clima",
        conseilsRecos: "Consejos & Recomendaciones", checklistTitle: "Lista de verificación Jinetes",
        logistiqueTitle: "Consejos Logísticos", viewAccommodation: "Ver alojamientos",
        weatherTitle: "Clima Sanxay — Previsión 14 días",
        weatherForecast: "Ver previsión a 14 días en Météo France",
        weatherLoading: "Cargando previsiones...", weatherUnavailable: "Previsiones no disponibles temporalmente",
        weatherLink: "Consultar Météo France — Sanxay",
        shareBtn: "COMPARTIR", shareTitle: "Compartir esta página", shareMessage: "Descubre la info práctica de {{event}} por Brious'O Folies",
        shareCopyLink: "Copiar enlace", shareCopied: "Enlace copiado!"
      },
      homeExt: {
        heroTitle1: "Vive los eventos de",
        heroTitle2: "en Sanxay",
        heroSubtitle: "Actividades ecuestres, deportes al aire libre y eventos culturales en el corazón del",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Ver eventos",
        becomeMember: "Hacerse Miembro",
        becomeVolunteer: "Ser voluntario",
        receiveNews: "Recibir noticias",
        eventsPerYear: "Eventos/año",
        visitorsWelcomed: "Visitantes acogidos",
        volunteersActive: "Voluntarios movilizados",
        landArea: "De terreno",
        dontMiss: "¡No te pierdas nada!",
        upcomingEvents: "Próximos Eventos",
        upcomingEventsDesc: "Conciertos, rutas ecuestres, carreras de resistencia, noches country... ¡Descubre nuestro programa y reserva tu plaza!",
        reserve: "Reservar",
        free: "GRATIS",
        seeAllEvents: "Ver todos los eventos",
        allYear: "Todo el año",
        seasonTitle: "Temporada Brious'O Folies",
        seasonDesc: "Eventos todo el año al ritmo de las estaciones",
        spring: "Primavera",
        summer: "Verano",
        autumn: "Otoño",
        winter: "Invierno",
        springEvents: ["Clases de equitación", "Rutas en la naturaleza", "Búsqueda de huevos", "Noches country"],
        summerEvents: ["Conciertos de coros", "Campeonato departamental de resistencia", "Mercadillos"],
        autumnEvents: ["Ruta Halloween", "Cine-merienda", "Carrera de resistencia"],
        winterEvents: ["Cine-merienda", "Conciertos íntimos", "Talleres", "Juegos"],
        joinCommunity: "Únete a la comunidad Brious'O Folies",
        newsletterDesc: "Recibe noticias sobre nuestros eventos, conciertos, actividades en la naturaleza y carreras de resistencia.",
        iWantInfo: "Quiero recibir información sobre:",
        nlEndurance: "Carreras de resistencia ecuestre",
        nlConcerts: "Conciertos y espectáculos",
        nlNature: "Actividades en la naturaleza y rutas",
        nlFamily: "Eventos familiares",
        nlPedagogy: "Actividades pedagógicas",
        nlVolunteer: "Ser voluntario",
        emailPlaceholder: "Tu dirección de email",
        joinCommunityBtn: "Me uno a la comunidad",
        thankYou: "¡Gracias!",
        subscribedMsg: "Ya estás suscrito a nuestro boletín.",
        welcomeMsg: "¡Bienvenido a la comunidad!",
        welcomeDesc: "Pronto recibirás nuestras noticias.",
        prefsUpdated: "¡Preferencias actualizadas!",
        prefsUpdatedDesc: "Tus intereses han sido actualizados.",
        joinTeam: "Únete al equipo",
        becomeVolunteerTitle: "Hazte voluntario de Brious'O Folies",
        volunteerDesc: "¿Quieres participar en la organización de eventos deportivos y culturales? ¡Únete a nuestro equipo de voluntarios para momentos de compartir inolvidables!",
        volunteerBenefit1: "Vive los eventos desde dentro",
        volunteerBenefit2: "Haz grandes amistades",
        volunteerBenefit3: "Sin experiencia requerida",
        volunteerBtn: "Ser voluntario",
        volunteersTrustUs: "Voluntarios confían en nosotros",
        heritageNature: "Patrimonio y Naturaleza",
        discoverSanxay: "Descubre Sanxay y su región",
        discoverDesc: "El Domaine de la Briouse está idealmente situado para explorar los tesoros del Pays Mélusin",
        discoverRegion: "Descubrir la región",
        ourCommitment: "Nuestro Compromiso",
        valuesTitle: "Valores que nos unen",
        benevolence: "Benevolencia",
        benevolenceDesc: "Acogida cálida para todos",
        conviviality: "Convivencia",
        convivialityDesc: "Momentos de intercambio y encuentro",
        respect: "Respeto",
        respectDesc: "Por la naturaleza y los caballos",
        culture: "Cultura",
        cultureDesc: "Eventos artísticos accesibles",
        ourPlace: "Nuestro Lugar",
        domainTitle: "El Domaine de la Briouse",
        domainDesc: "Situado en el corazón del Pays Mélusin, el Domaine de la Briouse ofrece un marco natural y patrimonial excepcional. Cerca del famoso sitio galo-romano de Sanxay, es el lugar ideal para eventos que combinan deporte, cultura y naturaleza.",
        howToCome: "Cómo llegar",
        joinAdventure: "Únete a la aventura Brious'O Folies",
        ctaDesc: "Hazte miembro y participa en la vida de nuestra asociación. Juntos, mantengamos vivo el patrimonio y la convivencia del Pays Mélusin.",
        memberFor10: "Únete por 10€",
        contactUsBtn: "Contáctanos",
        call: "Llamar",
        galloRomanSite: "Sitio Galo-Romano de Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      eventsExt: {
        calendar: "Calendario",
        calendar2026: "Calendario 2026",
        title: "Nuestros Eventos",
        subtitle: "Rutas ecuestres, conciertos, carreras de resistencia y eventos familiares... Descubre todas nuestras actividades en el Domaine de la Briouse.",
        downloadLivret: "Descargar el Folleto PDF",
        featured: "Destacado",
        grandeTombola: "Gran Tombola",
        winBalloon: "¡Gana un Vuelo en Globo!",
        tombolaDesc: "¡Participa en nuestra gran tombola y gana un vuelo en globo para 2 personas despegando directamente del Domaine de la Briouse!",
        ticket: "el ticket",
        drawAt: "Sorteo a las 18h",
        participateTombola: "Participar en la Tombola",
        learnMore: "Más información",
        filterByCategory: "Filtrar por categoría",
        allCategories: "Todas las categorías",
        resetFilters: "Restablecer filtros",
        becomeMember: "Hazte Miembro",
        memberDesc: "Apoya nuestra asociación y disfruta de ventajas exclusivas.",
        memberFor10: "Únete por 10€",
        noEventsFound: "No se encontraron eventos para estos criterios.",
        seeAllEvents: "Ver todos los eventos",
        reserve: "Reservar",
        freeEntry: "Entrada libre",
        orga: "Org",
        equitation: "Equitación",
        concert: "Concierto",
        randonnee: "Ruta",
        course: "Carrera",
        brocante: "Mercadillo",
        cinema: "Cine"
      },
      contactExt: {
        contactUs: "Contáctanos",
        title: "Contacto",
        subtitle: "¿Una pregunta, una sugerencia, ganas de unirte? No dudes en contactarnos.",
        contactInfo: "Información de Contacto",
        phone: "Teléfono",
        address: "Dirección",
        onlineMembership: "Membresía en línea",
        joinViaHelloAsso: "Únete a nuestra asociación a través de HelloAsso.",
        memberFor10: "Únete por 10€",
        sendMessage: "Envíanos un mensaje",
        fullName: "Nombre completo *",
        email: "Email *",
        subject: "Asunto *",
        subjectPlaceholder: "Acerca de...",
        message: "Mensaje *",
        messagePlaceholder: "Tu mensaje...",
        newsletterCheckbox: "Quiero suscribirme al boletín para recibir noticias de Brious'O Folies",
        sendBtn: "Enviar mensaje",
        successMsg: "¡Mensaje enviado con éxito!",
        successDescNewsletter: "También estás suscrito al boletín.",
        successDesc: "Te responderemos lo antes posible.",
        errorMsg: "Error al enviar el mensaje",
        errorDesc: "Por favor, inténtelo más tarde.",
        findUs: "Encuéntranos"
      },
      benevoles: {
        joinAdventure: "Únete a la aventura",
        title: "Hazte Voluntario",
        heroDesc: "Los eventos que organizamos no serían posibles sin el compromiso y la generosidad de quienes dan un poco de su tiempo.",
        signUp: "Me inscribo como voluntario",
        thanks: "¡Gracias!",
        callTitle: "¡Brious'O Folies hace un llamamiento!",
        callP1: "Hoy, <strong>Brious'O Folies</strong> hace un llamamiento a todos los habitantes que deseen ser voluntarios y participar en la vida local.",
        callP2: "<strong>Eventos deportivos, conciertos, espectáculos, rutas, actividades familiares o encuentros festivos</strong>: nuestros proyectos son variados y cada uno puede encontrar su lugar.",
        callP3: "Acogida del público, ayuda en la organización, logística, instalación, comunicación, acompañamiento de participantes o una simple ayuda puntual... <strong>hay mil formas de participar</strong>, según tus deseos, habilidades y disponibilidad.",
        chooseEvent: "Elige tu evento",
        eventsCalendar: "Calendario de Eventos",
        clickToSign: "Haz clic en un evento para inscribirte como voluntario",
        selectedEvent: "Evento Seleccionado",
        monthEvents: "Eventos del mes",
        volunteerForEvent: "Ser voluntario para este evento",
        seeAllEvents: "Ver todos los eventos",
        noEventThisMonth: "Sin eventos este mes.",
        navigateCalendar: "¡Navega por el calendario!",
        findYourPlace: "Encuentra tu lugar",
        missionTypes: "Tipos de Misiones",
        missionDesc: "Hay muchas formas de contribuir según tus deseos y habilidades.",
        publicWelcome: "Acogida del público",
        publicWelcomeDesc: "Orientar e informar a los visitantes durante nuestros eventos",
        logistics: "Logística e Instalación",
        logisticsDesc: "Montaje de stands, señalización y equipamientos",
        animation: "Animación",
        animationDesc: "Acompañar a los participantes durante espectáculos y conciertos",
        helpOut: "Ayuda puntual",
        helpOutDesc: "Ayuda diversa según tu disponibilidad y deseos",
        whyJoin: "¿Por qué unirte?",
        beingVolunteer: "Ser voluntario es...",
        beingVolunteerDesc: "Vivir los eventos desde dentro, compartir momentos fuertes, hacer grandes amistades y contribuir a proyectos con sentido para nuestro territorio.",
        benefit1: "Vivir los eventos desde dentro",
        benefit2: "Hacer grandes amistades",
        benefit3: "Contribuir a proyectos con sentido",
        benefit4: "Ambiente amigable y acogedor",
        benefit5: "Sin experiencia requerida",
        benefit6: "Compromiso según tu disponibilidad",
        essentialDesire: "¡Lo esencial es las ganas!",
        essentialP1: "No se necesita experiencia particular: lo esencial son las ganas de participar, compartir y formar parte de una aventura colectiva.",
        essentialP2: "Unirse al equipo de voluntarios Brious'O Folies es comprometerse en un",
        essentialP2Bold: "ambiente amigable y acogedor",
        essentialP2End: ", al servicio del intercambio, la cultura, el deporte y la naturaleza.",
        ifAdventureTempts: "Si la aventura te tienta...",
        ctaDesc: "¡Ven a conocernos en nuestros eventos o inscríbete directamente: estaremos encantados de acogerte y escribir juntos la continuación de esta hermosa historia!",
        becomeVolunteer: "Me hago voluntario",
        contactUs: "Contáctanos",
        followSocial: "¡Síguenos en redes sociales!",
        dayNames: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"]
      },
      footerExt: {
        visitorsSay: "Lo que dicen nuestros visitantes",
        review1: "¡Gran ambiente, equipo genial!",
        review2: "¡Eventos de calidad, volveremos!",
        review3: "Marco magnífico, caballos bien cuidados",
        navigation: "Navegación",
        home: "Inicio",
        events: "Eventos",
        association: "La Asociación",
        gettingHere: "Cómo llegar",
        news: "Noticias",
        volunteers: "Voluntarios",
        partners: "Socios",
        contactLabel: "Contacto",
        contactTitle: "Contacto",
        contactUsLink: "Contáctanos",
        ourValues: "Nuestros Valores",
        value1: "Transmisión y Compartir",
        value2: "Deporte Responsable",
        value3: "Cultura Accesible",
        value4: "Respeto por la Naturaleza",
        value5: "Convivencia",
        value6: "Benevolencia",
        becomeMember: "Hacerse Miembro",
        allRights: "Todos los derechos reservados",
        legalNotice: "Aviso Legal",
        cgv: "CGV",
        privacy: "Privacidad",
        description: "Asociación sin ánimo de lucro dedicada a la promoción de actividades ecuestres, deportes al aire libre y eventos culturales en el Domaine de la Briouse."
      },
      venir: {
        title: "Cómo llegar",
        subtitle: "Domaine de la Briouse",
        heroDesc: "Toda la información práctica para visitarnos en el corazón del Pays Mélusin.",
        howToCome: "Cómo llegar",
        accommodation: "Alojamientos",
        restaurants: "Restaurantes",
        discover: "Descubrir",
        byCar: "En coche",
        byTrain: "En tren",
        byPlane: "En avión",
        gps: "Coordenadas GPS",
        distance: "Distancia",
        all: "Todos",
        onSite: "En el lugar",
        nearby: "Cerca",
        book: "Reservar",
        visitWebsite: "Visitar sitio web",
        seeOnMap: "Ver en el mapa",
        discoverRegion: "Descubrir la Región",
        discoverDesc: "El Domaine de la Briouse está idealmente situado en el corazón del Pays Mélusin, rodeado de lugares destacados.",
        filterByDistance: "Filtrar por distancia",
        heritageNature: "Patrimonio y Naturaleza",
        leisure: "Ocio y Cultura",
        beaches: "Playas y Costa",
        contactTitle: "¿Necesitas información?",
        contactDesc: "Nuestro equipo está disponible para ayudarte a organizar tu estancia.",
        contactBtn: "Contáctanos",
        callUs: "Llámanos",
        name: "Nombre *",
        email: "Email *",
        messageLabel: "Mensaje *",
        sendBtn: "Enviar",
        msgSent: "¡Mensaje enviado!",
        msgSentDesc: "Te responderemos pronto.",
        msgError: "Error al enviar",
        msgErrorDesc: "Por favor, inténtelo de nuevo.",
        chambreHotes: "B&B y Casas rurales",
        camping: "Camping",
        hotel: "Hotel",
        gite: "Casa rural",
        traditional: "Cocina tradicional",
        gastro: "Gastronomía",
        pizzeria: "Pizzería",
        bar: "Bar",
        crêperie: "Crepería",
        priceRange: "Rango de precios"
      },
      adhesion: {
        title: "Membresía",
        subtitle: "Hacerse Miembro",
        heroDesc: "Únete a la asociación Brious'O Folies y participa en la vida del Domaine de la Briouse.",
        why: "¿Por qué unirse?",
        benefit1: "Apoyar nuestros eventos",
        benefit1Desc: "Tu membresía financia directamente nuestros conciertos, rutas y actividades.",
        benefit2: "Acceso prioritario",
        benefit2Desc: "Tarifas reducidas y acceso prioritario a ciertos eventos.",
        benefit3: "Comunidad",
        benefit3Desc: "Únete a una comunidad apasionada del Pays Mélusin.",
        joinNow: "Unirse ahora",
        memberFor10: "Membresía anual: 10€",
        helloAssoInfo: "La membresía se realiza a través de HelloAsso, nuestro socio de pago seguro.",
        questions: "¿Preguntas?",
        contactUs: "Contáctanos"
      },
      actualites: {
        title: "Noticias",
        subtitle: "Nuestras Noticias",
        heroDesc: "Sigue las últimas noticias de Brious'O Folies y del Domaine de la Briouse.",
        noNews: "No hay noticias por el momento.",
        stayTuned: "¡Mantente conectado!",
        followUs: "Síguenos en redes sociales para no perderte nada.",
        readMore: "Leer más",
        published: "Publicado el",
        categories: "Categorías",
        all: "Todas",
        mediaDeleted: "Medio eliminado"
      },
      tombola: {
        title: "Gran Tombola",
        subtitle: "Tombola Brious'O Folies",
        heroDesc: "¡Participa en nuestra gran tombola y gana un vuelo en globo!",
        winBalloon: "¡Gana un Vuelo en Globo!",
        description: "¡Participa en nuestra gran tombola y gana un vuelo en globo para 2 personas despegando directamente del Domaine de la Briouse!",
        ticketPrice: "el ticket",
        drawDate: "Sorteo el 8 Nov. 2026",
        drawTime: "Sorteo a las 18h",
        participate: "Participar en la Tombola",
        howItWorks: "¿Cómo funciona?",
        step1: "Compra tu ticket",
        step1Desc: "Tickets disponibles en línea a través de HelloAsso o en el lugar durante nuestros eventos.",
        step2: "Espera el sorteo",
        step2Desc: "El sorteo tendrá lugar el 8 de noviembre de 2026 a las 18h en el Domaine de la Briouse.",
        step3: "¡Vuela!",
        step3Desc: "El ganador disfrutará de un vuelo en globo para 2 personas.",
        rules: "Reglamento",
        rulesDesc: "Tombola organizada conforme a la normativa vigente."
      },
      legal: {
        title: "Aviso Legal",
        legalNotice: "Aviso Legal",
        cgv: "Términos y Condiciones",
        privacy: "Política de Privacidad",
        editor: "Editor del sitio",
        hosting: "Alojamiento",
        intellectual: "Propiedad intelectual",
        intellectualDesc: "Todo el contenido de este sitio (textos, imágenes, vídeos) está protegido por derechos de autor.",
        dataProtection: "Protección de datos",
        dataProtectionDesc: "Conforme al RGPD, usted tiene derecho de acceso, modificación y supresión de sus datos personales.",
        cookies: "Cookies",
        cookiesDesc: "Este sitio utiliza cookies para mejorar su experiencia de navegación.",
        contact: "Contacto"
      }
    }
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        events: "Veranstaltungen",
        news: "Neuigkeiten",
        association: "Der Verein",
        partners: "Partner",
        gettingHere: "Anfahrt",
        contact: "Kontakt",
        volunteer: "Ehrenamtliche",
        membership: "Mitgliedschaft"
      },
      home: {
        welcome: "Willkommen bei Brious'O Folies",
        subtitle: "Reitverein im Herzen von Nouvelle-Aquitaine",
        discoverEvents: "Unsere Veranstaltungen entdecken",
        joinUs: "Mitmachen",
        becomeVolunteer: "Ehrenamtlicher werden",
        becomeMember: "Mitglied werden",
        upcomingEvents: "Kommende Veranstaltungen",
        viewAllEvents: "Alle Veranstaltungen ansehen",
        newsletter: "Newsletter",
        newsletterDesc: "Bleiben Sie über unsere Neuigkeiten informiert",
        email: "Ihre E-Mail",
        subscribe: "Abonnieren"
      },
      events: {
        title: "Unsere Veranstaltungen",
        subtitle: "Entdecken Sie unsere Distanzritte und Wanderritte",
        allEvents: "Alle",
        endurance: "Distanz",
        randonnee: "Wanderritt",
        stage: "Training",
        concert: "Konzert",
        register: "Anmelden",
        learnMore: "Mehr erfahren",
        organization: "Organisation",
        noEvents: "Derzeit keine Veranstaltungen"
      },
      endurance: {
        title: "Reglements & Ergebnisse",
        subtitle: "Offizielle FFE, FEI und SHF Reglements",
        regulations: "Offizielle Reglements",
        results: "Unsere Ergebnisse",
        france: "Frankreich - FFE",
        international: "International - FEI",
        youngHorses: "Junge Pferde - SHF",
        usefulLinks: "Nützliche Links",
        download: "Herunterladen"
      },
      organization: {
        title: "Organisation",
        schedule: "Zeitplan",
        participants: "Teilnehmer",
        route: "Strecke",
        veterinary: "Tierarzt",
        practicalInfo: "Praktische Infos",
        program: "Tagesprogramm",
        races: "Prüfungen",
        participantsList: "Teilnehmerliste & Startnummern",
        roadBooks: "Road Books",
        mapsRoutes: "Karten & Strecken",
        vetCards: "Tierärztliche Überwachungskarten",
        vetInfo: "Tierärztliche Informationen",
        usefulNumbers: "Nützliche Nummern",
        emergencyNumbers: "Notfallnummern",
        sitePlan: "Lageplan",
        parking: "Parkplatz",
        toilets: "Toiletten",
        vetZone: "Tierarztzone",
        groomingZone: "Grooming-Zone",
        restZone: "Pferderuhebereich",
        backToEvents: "Zurück zu Veranstaltungen"
      },
      contact: {
        title: "Kontaktieren Sie uns",
        subtitle: "Eine Frage? Zögern Sie nicht, uns zu schreiben",
        name: "Ihr Name",
        email: "Ihre E-Mail",
        subject: "Betreff",
        message: "Ihre Nachricht",
        send: "Senden",
        sending: "Wird gesendet...",
        success: "Nachricht erfolgreich gesendet!",
        error: "Fehler beim Senden"
      },
      common: {
        readMore: "Weiterlesen",
        seeAll: "Alle anzeigen",
        loading: "Laden...",
        error: "Fehler",
        close: "Schließen",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        edit: "Bearbeiten",
        add: "Hinzufügen",
        search: "Suchen",
        filter: "Filtern",
        results: "Ergebnisse",
        comingSoon: "Demnächst",
        date: "Datum",
        location: "Ort",
        distance: "Distanz",
        level: "Niveau",
        departure: "Start",
        back: "Zurück",
        backToHome: "Zurück zur Startseite",
        backToEvents: "Zurück zu Veranstaltungen",
        backToNews: "Zurück zu Neuigkeiten",
        login: "Anmelden",
        logout: "Abmelden",
        logoutSuccess: "Erfolgreich abgemeldet",
        loginSuccess: "Erfolgreich angemeldet",
        loginError: "Anmeldefehler",
        invalidCredentials: "Ungültige Anmeldedaten.",
        welcome: "Willkommen",
        book: "Buchen",
        free: "Kostenlos",
        send: "Senden",
        sending: "Wird gesendet...",
        download: "Herunterladen",
        register: "Anmeldung",
        confirm: "Bestätigen",
        errorOccurred: "Ein Fehler ist aufgetreten",
        tryAgain: "Bitte versuchen Sie es erneut",
        errorSending: "Fehler beim Senden",
        errorCreating: "Fehler beim Erstellen",
        errorUpdating: "Fehler beim Aktualisieren",
        errorDeleting: "Fehler beim Löschen",
        errorUpload: "Fehler beim Hochladen",
        confirmDelete: "Dieses Element löschen?",
        confirmDeleteUser: "Diesen Benutzer löschen?",
        addUser: "Benutzer hinzufügen",
        sendTestEmail: "Test-E-Mail senden",
        sendTestTo: "Test-E-Mail senden an:",
        email: "E-Mail",
        password: "Passwort",
        adminLogin: "Admin-Anmeldung",
        staffArea: "Mitarbeiterbereich",
        manageMedia: "Sie können jetzt Medien verwalten.",
        regulations: "Reglements & Ergebnisse",
        officialRegulations: "Offizielle Reglements & Rennergebnisse",
        ourResults: "Unsere Ergebnisse",
        raceResults: "Brious'O Folies Rennergebnisse",
        resultsComingSoon: "Ergebnisse demnächst",
        savedSuccess: "Erfolgreich gespeichert",
        savedError: "Fehler beim Speichern"
      },
      footer: {
        rights: "Alle Rechte vorbehalten",
        legalNotice: "Impressum",
        privacy: "Datenschutz",
        terms: "AGB",
        followUs: "Folgen Sie uns"
      },
      // Association page
      association: {
        whoAreWe: "Wer sind wir?",
        title: "Der Verein",
        description: "Brious'O Folies arbeitet das ganze Jahr daran, Reitsportaktivitäten, Outdoor-Sportarten und kulturelle Veranstaltungen zu fördern.",
        heartOfMelusin: "Ein Verein im Herzen des",
        paysMelusin: "Pays Mélusin",
        presentation1: "ist ein gemeinnütziger Verein nach dem Gesetz von 1901, gegründet um sportliche, reiterliche und kulturelle Veranstaltungen auf dem Domaine de la Briouse in Sanxay (86) zu organisieren.",
        ourMission: "Unsere Mission:",
        missionDesc: "Förderung und Organisation von Reit-, Sport-, Kultur- und Denkmalaktivitäten unter Förderung von Geselligkeit, Weitergabe und Zugang zur Natur für alle.",
        presentation2: "Ausritte, Distanzrennen, Open-Air-Konzerte, Familienveranstaltungen... Wir schaffen Momente der",
        conviviality: "Geselligkeit, des Austauschs und der Entdeckung",
        presentation3: ", offen für Reiter, Familien, Einwohner und Besucher.",
        becomeMember: "Mitglied werden",
        becomeVolunteer: "Ehrenamtlicher werden",
        becomePartner: "Partner werden",
        keyFigures: "Schlüsselzahlen 2025",
        eventsOrganized: "Organisierte Veranstaltungen",
        inYear: "im Jahr 2025",
        artistsPerformers: "Künstler & Darsteller",
        ridersWelcomed: "Begrüßte Reiter",
        visitorsOnSite: "Besucher vor Ort",
        ourTeam: "Unser Team",
        bureauMembers: "Vorstandsmitglieder",
        bureauDesc: "Ein Team leidenschaftlicher Ehrenamtlicher mit sich ergänzenden Fähigkeiten, angetrieben von starken Werten.",
        whatDrivesUs: "Was uns antreibt",
        ourValues: "Unsere Grundwerte",
        benevolence: "Wohlwollen",
        benevolenceDesc: "Jeden Teilnehmer, Ehrenamtlichen oder Partner in einem Klima des Respekts, des Zuhörens und der Sicherheit empfangen.",
        respect: "Respekt",
        respectDesc: "Für das Wohlergehen der Pferde, den Schutz der Umwelt und den Respekt vor Kulturerbe und Menschen sorgen.",
        conviviality2: "Geselligkeit",
        convivialityDesc: "Warme, generationsübergreifende Momente schaffen, in denen Familien, Reiter, Einwohner, Touristen und Unternehmen zusammenkommen.",
        environment: "Umwelt",
        environmentDesc: "Verantwortungsvolle Veranstaltungen organisieren, die auf die Auswirkungen auf die Natur und die Nutzung ländlicher Räume achten.",
        transmission: "Weitergabe",
        transmissionDesc: "Reitwissen, Kulturerbe-Kenntnisse und bürgerliche Werte an junge Menschen und die breite Öffentlichkeit weitergeben.",
        accessibility: "Zugänglichkeit",
        accessibilityDesc: "Sport, Kultur und Natur für möglichst viele Menschen zugänglich machen.",
        ourImpact: "Unsere Wirkung",
        ourActions: "Unsere Aktionen",
        actionsDesc: "Durch seine Aktionen beteiligt sich der Verein aktiv an der Belebung des Gebiets, der Entwicklung des ländlichen Tourismus und der Stärkung sozialer Bindungen.",
        contactUs: "Kontaktieren Sie uns",
        contactQuestion: "Für Fragen oder Informationsanfragen",
        writeToUs: "Kontakt",
        joinAdventure: "Werden Sie Teil des Abenteuers!",
        ctaDesc: "Ob Sie Reiter, Kulturliebhaber, Naturbegeisterter oder einfach neugierig sind - bei Brious'O Folies gibt es einen Platz für Sie.",
        membershipFor: "Mitglied werden für 10€"
      },
      // Partners page
      partners: {
        becomePartner: "Partner werden",
        supportUs: "Unterstützen Sie Brious'O Folies",
        heroDesc: "Unternehmen, Handwerker, Kommunen: Werden Sie Teil des Abenteuers und geben Sie Ihrer Organisation Sichtbarkeit, während Sie das Gebiet unterstützen!",
        downloadDossier: "Sponsoring-Dossier herunterladen",
        contactUs: "Kontaktieren Sie uns",
        whyJoinUs: "Warum mitmachen?",
        partnershipBenefits: "Vorteile der Partnerschaft",
        localVisibility: "Lokale Sichtbarkeit",
        localVisibilityDesc: "Erreichen Sie ein familienorientiertes, leidenschaftliches und engagiertes Publikum im Pays Mélusin.",
        positiveImage: "Positives Image",
        positiveImageDesc: "Verbinden Sie Ihre Marke mit starken Werten: Natur, Kulturerbe, Sport und zugängliche Kultur.",
        network: "Netzwerk",
        networkDesc: "Treten Sie einem Netzwerk von Unternehmen und Kommunen bei, die sich für das Gebiet engagieren.",
        taxBenefits: "Steuervorteile",
        taxBenefitsDesc: "Profitieren Sie von Steuerermäßigungen durch Mäzenatentum (66% der Spende absetzbar).",
        ourFormulas: "Unsere Formeln",
        choosePackage: "Wählen Sie Ihr Partner-Paket",
        packagesDesc: "An alle Budgets angepasste Formeln mit konkreten und messbaren Gegenleistungen.",
        selectPack: "Dieses Paket wählen",
        technicalPartnership: "Technische Partnerschaft / Mäzenatentum",
        technicalDesc: "Möchten Sie uns anders unterstützen? Ausrüstung, Dienstleistungen, Fähigkeiten... Kontaktieren Sie uns für ein maßgeschneidertes Angebot!",
        discussProject: "Besprechen wir Ihr Projekt",
        ourCommitment: "Unser Engagement",
        whatWeGuarantee: "Was wir Ihnen garantieren",
        dedicatedContact: "Ein dedizierter Ansprechpartner für jeden Partner",
        taxOptimization: "Optimierte Besteuerung (Spendenquittung für Spenden)",
        customOffers: "Maßgeschneiderte Angebote nach Ihren Bedürfnissen",
        fullTransparency: "Volle Transparenz über die Verwendung der Mittel",
        detailedReport: "Detaillierter Bericht nach jeder Veranstaltung",
        sponsorDossier: "Vollständiges Sponsoring-Dossier",
        dossierDesc: "Finden Sie alle detaillierten Informationen: Veranstaltungen, Budgets, Gegenleistungen und Kontakte.",
        downloadPdf: "PDF herunterladen",
        questions: "Haben Sie Fragen?",
        questionsDesc: "Unser Team steht Ihnen zur Verfügung, um gemeinsam eine maßgeschneiderte Partnerschaft aufzubauen.",
        thankPartners: "Dank an unsere Partner",
        theyTrusted: "Sie haben uns vertraut",
        thankYouDesc: "Ein großes Dankeschön an alle Unternehmen, Institutionen und Kommunen, die Brious'O Folies unterstützen.",
        institutionsCollectivities: "Institutionen & Kommunen",
        equestrianFederations: "Reitsportverbände",
        partnerCompanies: "Partnerunternehmen",
        tourismLeisure: "Tourismus & Freizeit",
        readyToJoin: "Bereit, mitzumachen?",
        ctaDesc: "Kontaktieren Sie uns jetzt, um Ihr Partnerschaftsprojekt zu besprechen und Teil des Brious'O Folies Abenteuers zu werden!",
        partnershipRequest: "Partnerschaftsanfrage",
        selectedPack: "Ausgewähltes Paket",
        thankYouInterest: "Danke für Ihr Interesse!",
        requestSent: "Ihre Anfrage wurde erfolgreich gesendet. Wir werden Sie sehr bald kontaktieren, um Ihre Partnerschaft zu besprechen.",
        fullName: "Vollständiger Name",
        company: "Unternehmen",
        phone: "Telefon",
        sendRequest: "Meine Anfrage senden",
        formConsent: "Mit dem Absenden dieses Formulars erklären Sie sich damit einverstanden, vom Verein Brious'O Folies kontaktiert zu werden."
      },
      loginModal: {
        staffArea: "Mitarbeiterbereich",
        memberArea: "Mitgliederbereich",
        staffDesc: "Verwaltung der Brious'O Folies Website",
        memberDesc: "Zugang zu Ihrem persönlichen Bereich",
        createAccount: "Erstellen Sie Ihr Mitgliedskonto",
        member: "Mitglied",
        signIn: "Anmelden",
        firstName: "Vorname",
        lastName: "Nachname",
        phone: "Telefon",
        createMyAccount: "Mein Konto erstellen",
        accountCreated: "Konto erstellt! Melden Sie sich jetzt an.",
        alreadyAccount: "Bereits ein Konto? Anmelden",
        noAccount: "Noch kein Konto? Registrieren"
      },
      ip: {
        title: "Praktische Infos", subtitle: "Alle wichtigen Informationen für jede Veranstaltung",
        selectEvent: "Wählen Sie eine Veranstaltung",
        navAcces: "Anfahrt", navParcours: "Strecken", navProgramme: "Programm", navDocuments: "Dokumente",
        navContacts: "Kontakte", navRestau: "Verpflegung", navResultats: "Ergebnisse", navSecurite: "Sicherheit", navConseils: "Tipps",
        accesTitle: "Anfahrt & Parken", consignes: "Zugangshinweise",
        parcoursTitle: "Strecken & Routen",
        programmeTitle: "Programm & Zeitplan", programmeComingSoon: "Programm folgt",
        programmeComingSoonDesc: "Das Programm wird in Kürze veröffentlicht.",
        documentsTitle: "Dokumente & Roadbook", documentsOfficiels: "Offizielle Dokumente",
        uploadDoc: "Dokument hochladen", uploading: "Hochladen...",
        noDocsYet: "Noch keine offiziellen Dokumente.",
        contactsTitle: "Kontakte & Wichtige Nummern", emergency: "Notfall",
        restaurationTitle: "Verpflegung & Getränke", resultatsTitle: "Ergebnisse & Ranglisten",
        securiteTitle: "Regeln & Sicherheit", readRules: "Vollständige Regeln", hideRules: "Regeln ausblenden",
        weather14: "14-Tage-Wetter", seoTitle: "Schlüsselwörter", backToTop: "Nach oben",
        download: "Herunterladen", downloadGpx: "GPX herunterladen", downloadPdf: "Programm-PDF herunterladen",
        guideTitle: "Distanzreiten verstehen", guideSubtitle: "Praktischer Leitfaden",
        guideIntro: "Dieser Leitfaden hilft Ihnen, die Prüfungskategorien, Distanzen und Geschwindigkeiten zu verstehen.",
        guideCategories: "Prüfungsarten",
        guideTable: "Distanz-/Zeittabelle", guideTableSub: "Geschätzte Zeit nach Distanz und Geschwindigkeit",
        guideCalc: "Geschwindigkeitsrechner",
        calcDepart: "Startzeit", calcArrivee: "Ankunftszeit", calcDistance: "Zurückgelegte Distanz",
        calcReset: "Zurücksetzen", calcTotalTime: "Gesamtzeit", calcAvgSpeed: "Durchschnittsgeschwindigkeit",
        calcPlaceholder: "Daten eingeben", calcPlaceholderSub: "Ergebnis erscheint automatisch",
        guideRemember: "Zu beachten",
        guideRemember1: "Die Zeiten sind Richtwerte.",
        guideRemember2: "Das offizielle Reglement bleibt die Referenz.",
        guideRemember3: "Tatsächliche Zeiten können variieren.",
        guideRemember4: "Hören Sie auf Ihr Pferd und priorisieren Sie das Tierwohl.",
        progDeparts: "Startprogramm", progDistance: "Distanz", progDepart: "Start",
        progCategories: "Kategorien", progBoucles: "Zu folgende Schleifen", progReal: "tatsächlich",
        progReadCourse: "So lesen Sie Ihren Kurs", progReadCourseSub: "Folgen Sie den Farben in der Reihenfolge",
        progLegend: "Schleifenlegende", progOrganisation: "Tagesorganisation",
        progPrizes: "Preisverleihung", progImportantInfo: "Wichtige Informationen",
        progBriefing: "Das Briefing ist vor jedem Start Pflicht.",
        progAdjust: "Zeiten können angepasst werden.",
        progVet: "Veterinärkontrolle ist obligatorisch.",
        progReglement: "Bitte lesen Sie das offizielle Reglement.",
        progWarning: "Reiter müssen Farbmarkierungen strikt befolgen.",
        elevDistance: "Distanz", elevDenivele: "Höhenunterschied", elevAltMin: "Höhe Min", elevAltMax: "Höhe Max",
        elevTerrain: "Wege, Pfade und Gemeindestraßen", elevWater: "Wasserstellen auf der Strecke",
        courses10to80: "Rennen 10 bis 80 km", courses100and120: "Rennen 100 und 120 km",
        guideDistLabel: "Distanzen", guideNivLabel: "Niveaus", guideSpeedLabel: "Geschwindigkeiten",
        calcExample: "Beispiel", progBouclesLabel: "Schleifen",
        catAmateurDesc: "Wettbewerbe für Reiter mit FFE-Lizenz. Amateur-Distanzreiten bietet einen angepassten Wettbewerbsrahmen.",
        catClubDesc: "Entdeckungs- und Ausbildungsprüfungen für Club-Reiter. Ideal für den Einstieg.",
        catPrepaDesc: "Trainingsprüfungen unter realen Bedingungen. Perfekt zur Vorbereitung.",
        catVIDesc: "Der Reiter muss eine vom Jury festgelegte Geschwindigkeit einhalten. Regelmäßigkeit ist entscheidend.",
        catVRDesc: "Der Reiter muss eine Zielgeschwindigkeit innerhalb einer Toleranz einhalten.",
        catSHFDesc: "Programm für junge Pferde der Société Hippique Française. Progressive Ausbildung.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Höhe",
        secCavaliers: "Sicherheit der Reiter", secChevaux: "Pferdewohlbefinden", secEnvironnement: "Umwelt",
        conseilsTitle: "Praktische Infos & Tipps", conseilsSub: "Checkliste, Empfehlungen und Wetter",
        conseilsRecos: "Tipps & Empfehlungen", checklistTitle: "Reiter-Checkliste",
        logistiqueTitle: "Logistik-Tipps", viewAccommodation: "Unterkünfte ansehen",
        weatherTitle: "Wetter Sanxay — 14-Tage-Prognose",
        weatherForecast: "14-Tage-Prognose auf Météo France ansehen",
        weatherLoading: "Prognose wird geladen...", weatherUnavailable: "Prognose vorübergehend nicht verfügbar",
        weatherLink: "Météo France — Sanxay prüfen",
        shareBtn: "TEILEN", shareTitle: "Diese Seite teilen", shareMessage: "Entdecke die praktischen Infos für {{event}} von Brious'O Folies",
        shareCopyLink: "Link kopieren", shareCopied: "Link kopiert!"
      },
      homeExt: {
        heroTitle1: "Erleben Sie die Veranstaltungen von",
        heroTitle2: "in Sanxay",
        heroSubtitle: "Reitsportaktivitäten, Outdoor-Sportarten und kulturelle Veranstaltungen im Herzen des",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Veranstaltungen ansehen",
        becomeMember: "Mitglied werden",
        becomeVolunteer: "Ehrenamtlicher werden",
        receiveNews: "Neuigkeiten erhalten",
        eventsPerYear: "Veranstaltungen/Jahr",
        visitorsWelcomed: "Begrüßte Besucher",
        volunteersActive: "Mobilisierte Ehrenamtliche",
        landArea: "Gelände",
        dontMiss: "Verpassen Sie nichts!",
        upcomingEvents: "Kommende Veranstaltungen",
        upcomingEventsDesc: "Konzerte, Wanderritte, Distanzrennen, Country-Abende... Entdecken Sie unser Programm und reservieren Sie Ihren Platz!",
        reserve: "Buchen",
        free: "KOSTENLOS",
        seeAllEvents: "Alle Veranstaltungen ansehen",
        allYear: "Das ganze Jahr",
        seasonTitle: "Brious'O Folies Saison",
        seasonDesc: "Veranstaltungen das ganze Jahr im Rhythmus der Jahreszeiten",
        spring: "Frühling",
        summer: "Sommer",
        autumn: "Herbst",
        winter: "Winter",
        springEvents: ["Reitunterricht", "Naturwanderungen", "Ostereiersuche", "Country-Abende"],
        summerEvents: ["Chorkonzerte", "Departement-Distanzmeisterschaft", "Flohmärkte"],
        autumnEvents: ["Halloween-Ritt", "Kino-Nachmittag", "Distanzrennen"],
        winterEvents: ["Kino-Nachmittag", "Intimkonzerte", "Workshops", "Spiele"],
        joinCommunity: "Treten Sie der Brious'O Folies Gemeinschaft bei",
        newsletterDesc: "Erhalten Sie Neuigkeiten über unsere Veranstaltungen, Konzerte, Naturaktivitäten und Distanzrennen.",
        iWantInfo: "Ich möchte Informationen erhalten über:",
        nlEndurance: "Distanzritte",
        nlConcerts: "Konzerte und Shows",
        nlNature: "Naturaktivitäten und Wanderungen",
        nlFamily: "Familienveranstaltungen",
        nlPedagogy: "Pädagogische Aktivitäten",
        nlVolunteer: "Ehrenamtlicher werden",
        emailPlaceholder: "Ihre E-Mail-Adresse",
        joinCommunityBtn: "Der Gemeinschaft beitreten",
        thankYou: "Danke!",
        subscribedMsg: "Sie sind jetzt für unseren Newsletter angemeldet.",
        welcomeMsg: "Willkommen in der Gemeinschaft!",
        welcomeDesc: "Sie werden bald unsere Neuigkeiten erhalten.",
        prefsUpdated: "Präferenzen aktualisiert!",
        prefsUpdatedDesc: "Ihre Interessen wurden aktualisiert.",
        joinTeam: "Treten Sie dem Team bei",
        becomeVolunteerTitle: "Werden Sie Ehrenamtlicher bei Brious'O Folies",
        volunteerDesc: "Möchten Sie bei der Organisation von Sport- und Kulturveranstaltungen helfen? Treten Sie unserem Ehrenamtlichen-Team bei für unvergessliche gemeinsame Momente!",
        volunteerBenefit1: "Veranstaltungen von innen erleben",
        volunteerBenefit2: "Großartige Begegnungen machen",
        volunteerBenefit3: "Keine Erfahrung erforderlich",
        volunteerBtn: "Ehrenamtlicher werden",
        volunteersTrustUs: "Ehrenamtliche vertrauen uns",
        heritageNature: "Kulturerbe & Natur",
        discoverSanxay: "Entdecken Sie Sanxay und seine Region",
        discoverDesc: "Das Domaine de la Briouse ist ideal gelegen, um die Schätze des Pays Mélusin zu erkunden",
        discoverRegion: "Die Region entdecken",
        ourCommitment: "Unser Engagement",
        valuesTitle: "Werte, die uns verbinden",
        benevolence: "Wohlwollen",
        benevolenceDesc: "Herzlicher Empfang für alle",
        conviviality: "Geselligkeit",
        convivialityDesc: "Momente des Austauschs und der Begegnung",
        respect: "Respekt",
        respectDesc: "Für die Natur und die Pferde",
        culture: "Kultur",
        cultureDesc: "Zugängliche künstlerische Veranstaltungen",
        ourPlace: "Unser Ort",
        domainTitle: "Das Domaine de la Briouse",
        domainDesc: "Im Herzen des Pays Mélusin gelegen, bietet das Domaine de la Briouse einen außergewöhnlichen natürlichen und kulturellen Rahmen. In der Nähe der berühmten gallo-römischen Stätte von Sanxay ist es der ideale Ort für Veranstaltungen, die Sport, Kultur und Natur verbinden.",
        howToCome: "Anfahrt",
        joinAdventure: "Werden Sie Teil des Brious'O Folies Abenteuers",
        ctaDesc: "Werden Sie Mitglied und nehmen Sie am Vereinsleben teil. Gemeinsam halten wir das Erbe und die Geselligkeit des Pays Mélusin lebendig.",
        memberFor10: "Mitglied werden für 10€",
        contactUsBtn: "Kontaktieren Sie uns",
        call: "Anrufen",
        galloRomanSite: "Gallo-Römische Stätte von Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      eventsExt: {
        calendar: "Kalender",
        calendar2026: "Kalender 2026",
        title: "Unsere Veranstaltungen",
        subtitle: "Wanderritte, Konzerte, Distanzrennen und Familienveranstaltungen... Entdecken Sie alle unsere Aktivitäten auf dem Domaine de la Briouse.",
        downloadLivret: "PDF-Broschüre herunterladen",
        featured: "Highlight",
        grandeTombola: "Große Tombola",
        winBalloon: "Gewinnen Sie eine Ballonfahrt!",
        tombolaDesc: "Nehmen Sie an unserer großen Tombola teil und gewinnen Sie eine Ballonfahrt für 2 Personen, die direkt vom Domaine de la Briouse startet!",
        ticket: "pro Los",
        drawAt: "Ziehung um 18 Uhr",
        participateTombola: "An der Tombola teilnehmen",
        learnMore: "Mehr erfahren",
        filterByCategory: "Nach Kategorie filtern",
        allCategories: "Alle Kategorien",
        resetFilters: "Filter zurücksetzen",
        becomeMember: "Mitglied werden",
        memberDesc: "Unterstützen Sie unseren Verein und genießen Sie exklusive Vorteile.",
        memberFor10: "Mitglied werden für 10€",
        noEventsFound: "Keine Veranstaltungen für diese Kriterien gefunden.",
        seeAllEvents: "Alle Veranstaltungen ansehen",
        reserve: "Buchen",
        freeEntry: "Freier Eintritt",
        orga: "Org",
        equitation: "Reiten",
        concert: "Konzert",
        randonnee: "Wanderritt",
        course: "Rennen",
        brocante: "Flohmarkt",
        cinema: "Kino"
      },
      contactExt: {
        contactUs: "Kontaktieren Sie uns",
        title: "Kontakt",
        subtitle: "Eine Frage, ein Vorschlag, Lust mitzumachen? Zögern Sie nicht, uns zu kontaktieren.",
        contactInfo: "Kontaktinformationen",
        phone: "Telefon",
        address: "Adresse",
        onlineMembership: "Online-Mitgliedschaft",
        joinViaHelloAsso: "Treten Sie unserem Verein über HelloAsso bei.",
        memberFor10: "Mitglied werden für 10€",
        sendMessage: "Senden Sie uns eine Nachricht",
        fullName: "Vollständiger Name *",
        email: "E-Mail *",
        subject: "Betreff *",
        subjectPlaceholder: "Bezüglich...",
        message: "Nachricht *",
        messagePlaceholder: "Ihre Nachricht...",
        newsletterCheckbox: "Ich möchte den Newsletter abonnieren, um Neuigkeiten von Brious'O Folies zu erhalten",
        sendBtn: "Nachricht senden",
        successMsg: "Nachricht erfolgreich gesendet!",
        successDescNewsletter: "Sie sind auch für den Newsletter angemeldet.",
        successDesc: "Wir werden Ihnen so schnell wie möglich antworten.",
        errorMsg: "Fehler beim Senden der Nachricht",
        errorDesc: "Bitte versuchen Sie es später erneut.",
        findUs: "Finden Sie uns"
      },
      benevoles: {
        joinAdventure: "Werden Sie Teil des Abenteuers",
        title: "Ehrenamtlicher werden",
        heroDesc: "Die Veranstaltungen, die wir organisieren, wären ohne das Engagement und die Großzügigkeit derer, die etwas von ihrer Zeit geben, nicht möglich.",
        signUp: "Ich melde mich als Ehrenamtlicher an",
        thanks: "Danke!",
        callTitle: "Brious'O Folies ruft auf!",
        callP1: "Heute ruft <strong>Brious'O Folies</strong> alle Einwohner auf, die ehrenamtlich tätig werden und am lokalen Leben teilnehmen möchten.",
        callP2: "<strong>Sportveranstaltungen, Konzerte, Shows, Wanderungen, Familienaktivitäten oder festliche Treffen</strong>: Unsere Projekte sind vielfältig und jeder kann seinen Platz finden.",
        callP3: "Publikumsempfang, Organisationshilfe, Logistik, Aufbau, Kommunikation, Teilnehmerbegleitung oder einfach eine helfende Hand... <strong>es gibt tausend Möglichkeiten, sich einzubringen</strong>, nach Ihren Wünschen, Fähigkeiten und Verfügbarkeit.",
        chooseEvent: "Wählen Sie Ihre Veranstaltung",
        eventsCalendar: "Veranstaltungskalender",
        clickToSign: "Klicken Sie auf eine Veranstaltung, um sich als Ehrenamtlicher anzumelden",
        selectedEvent: "Ausgewählte Veranstaltung",
        monthEvents: "Veranstaltungen dieses Monats",
        volunteerForEvent: "Ehrenamtlicher für diese Veranstaltung werden",
        seeAllEvents: "Alle Veranstaltungen ansehen",
        noEventThisMonth: "Keine Veranstaltungen diesen Monat.",
        navigateCalendar: "Navigieren Sie durch den Kalender!",
        findYourPlace: "Finden Sie Ihren Platz",
        missionTypes: "Arten von Aufgaben",
        missionDesc: "Es gibt viele Möglichkeiten, je nach Ihren Wünschen und Fähigkeiten beizutragen.",
        publicWelcome: "Publikumsempfang",
        publicWelcomeDesc: "Besucher bei unseren Veranstaltungen orientieren und informieren",
        logistics: "Logistik & Aufbau",
        logisticsDesc: "Stände aufbauen, Beschilderung und Einrichtungen",
        animation: "Animation",
        animationDesc: "Teilnehmer bei Shows und Konzerten begleiten",
        helpOut: "Gelegentliche Hilfe",
        helpOutDesc: "Verschiedene Hilfe je nach Verfügbarkeit und Wünschen",
        whyJoin: "Warum mitmachen?",
        beingVolunteer: "Ehrenamtlich sein bedeutet...",
        beingVolunteerDesc: "Veranstaltungen von innen erleben, starke Momente teilen, großartige Begegnungen machen und zu sinnvollen Projekten für unser Gebiet beitragen.",
        benefit1: "Veranstaltungen von innen erleben",
        benefit2: "Großartige Begegnungen machen",
        benefit3: "Zu sinnvollen Projekten beitragen",
        benefit4: "Freundliche und fürsorgliche Atmosphäre",
        benefit5: "Keine Erfahrung erforderlich",
        benefit6: "Engagement nach Ihrer Verfügbarkeit",
        essentialDesire: "Das Wesentliche ist der Wunsch!",
        essentialP1: "Keine besondere Erfahrung ist erforderlich: Das Wesentliche ist der Wunsch, teilzunehmen, zu teilen und Teil eines gemeinsamen Abenteuers zu sein.",
        essentialP2: "Dem Ehrenamtlichen-Team von Brious'O Folies beizutreten bedeutet, sich in einer",
        essentialP2Bold: "freundlichen und fürsorglichen Atmosphäre",
        essentialP2End: " zu engagieren, im Dienste des Austauschs, der Kultur, des Sports und der Natur.",
        ifAdventureTempts: "Wenn das Abenteuer Sie reizt...",
        ctaDesc: "Kommen Sie uns bei unseren Veranstaltungen besuchen oder melden Sie sich direkt an: Wir freuen uns, Sie willkommen zu heißen und gemeinsam das nächste Kapitel dieser schönen Geschichte zu schreiben!",
        becomeVolunteer: "Ich werde Ehrenamtlicher",
        contactUs: "Kontaktieren Sie uns",
        followSocial: "Folgen Sie uns in den sozialen Medien!",
        dayNames: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]
      },
      footerExt: {
        visitorsSay: "Was unsere Besucher sagen",
        review1: "Tolle Atmosphäre, super Team!",
        review2: "Qualitätsveranstaltungen, wir kommen wieder!",
        review3: "Wunderschöne Umgebung, gut gepflegte Pferde",
        navigation: "Navigation",
        home: "Startseite",
        events: "Veranstaltungen",
        association: "Der Verein",
        gettingHere: "Anfahrt",
        news: "Neuigkeiten",
        volunteers: "Ehrenamtliche",
        partners: "Partner",
        contactLabel: "Kontakt",
        contactTitle: "Kontakt",
        contactUsLink: "Kontaktieren Sie uns",
        ourValues: "Unsere Werte",
        value1: "Weitergabe & Austausch",
        value2: "Verantwortungsvoller Sport",
        value3: "Zugängliche Kultur",
        value4: "Respekt für die Natur",
        value5: "Geselligkeit",
        value6: "Wohlwollen",
        becomeMember: "Mitglied werden",
        allRights: "Alle Rechte vorbehalten",
        legalNotice: "Impressum",
        cgv: "AGB",
        privacy: "Datenschutz",
        description: "Gemeinnütziger Verein zur Förderung von Reitsportaktivitäten, Outdoor-Sportarten und kulturellen Veranstaltungen auf dem Domaine de la Briouse."
      },
      venir: {
        title: "Anfahrt",
        subtitle: "Domaine de la Briouse",
        heroDesc: "Alle praktischen Informationen, um uns im Herzen des Pays Mélusin zu besuchen.",
        howToCome: "Anfahrt",
        accommodation: "Unterkünfte",
        restaurants: "Restaurants",
        discover: "Entdecken",
        byCar: "Mit dem Auto",
        byTrain: "Mit dem Zug",
        byPlane: "Mit dem Flugzeug",
        gps: "GPS-Koordinaten",
        distance: "Entfernung",
        all: "Alle",
        onSite: "Vor Ort",
        nearby: "In der Nähe",
        book: "Buchen",
        visitWebsite: "Website besuchen",
        seeOnMap: "Auf der Karte ansehen",
        discoverRegion: "Die Region entdecken",
        discoverDesc: "Das Domaine de la Briouse ist ideal im Herzen des Pays Mélusin gelegen, umgeben von bemerkenswerten Orten.",
        filterByDistance: "Nach Entfernung filtern",
        heritageNature: "Kulturerbe & Natur",
        leisure: "Freizeit & Kultur",
        beaches: "Strände & Küste",
        contactTitle: "Brauchen Sie Informationen?",
        contactDesc: "Unser Team steht Ihnen zur Verfügung, um Ihren Aufenthalt zu planen.",
        contactBtn: "Kontaktieren Sie uns",
        callUs: "Rufen Sie uns an",
        name: "Name *",
        email: "E-Mail *",
        messageLabel: "Nachricht *",
        sendBtn: "Senden",
        msgSent: "Nachricht gesendet!",
        msgSentDesc: "Wir werden bald antworten.",
        msgError: "Fehler beim Senden",
        msgErrorDesc: "Bitte versuchen Sie es erneut.",
        chambreHotes: "B&B & Ferienhäuser",
        camping: "Camping",
        hotel: "Hotel",
        gite: "Ferienhaus",
        traditional: "Traditionelle Küche",
        gastro: "Gourmetküche",
        pizzeria: "Pizzeria",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Preisklasse"
      },
      adhesion: {
        title: "Mitgliedschaft",
        subtitle: "Mitglied werden",
        heroDesc: "Treten Sie dem Verein Brious'O Folies bei und nehmen Sie am Leben des Domaine de la Briouse teil.",
        why: "Warum beitreten?",
        benefit1: "Unsere Veranstaltungen unterstützen",
        benefit1Desc: "Ihre Mitgliedschaft finanziert direkt unsere Konzerte, Ritte und Aktivitäten.",
        benefit2: "Bevorzugter Zugang",
        benefit2Desc: "Ermäßigte Tarife und bevorzugter Zugang zu bestimmten Veranstaltungen.",
        benefit3: "Gemeinschaft",
        benefit3Desc: "Treten Sie einer leidenschaftlichen Gemeinschaft des Pays Mélusin bei.",
        joinNow: "Jetzt beitreten",
        memberFor10: "Jahresmitgliedschaft: 10€",
        helloAssoInfo: "Die Mitgliedschaft erfolgt über HelloAsso, unseren sicheren Zahlungspartner.",
        questions: "Fragen?",
        contactUs: "Kontaktieren Sie uns"
      },
      actualites: {
        title: "Neuigkeiten",
        subtitle: "Unsere Neuigkeiten",
        heroDesc: "Verfolgen Sie die neuesten Nachrichten von Brious'O Folies und dem Domaine de la Briouse.",
        noNews: "Derzeit keine Neuigkeiten.",
        stayTuned: "Bleiben Sie verbunden!",
        followUs: "Folgen Sie uns in den sozialen Medien, um nichts zu verpassen.",
        readMore: "Weiterlesen",
        published: "Veröffentlicht am",
        categories: "Kategorien",
        all: "Alle",
        mediaDeleted: "Medium gelöscht"
      },
      tombola: {
        title: "Große Tombola",
        subtitle: "Brious'O Folies Tombola",
        heroDesc: "Nehmen Sie an unserer großen Tombola teil und gewinnen Sie eine Ballonfahrt!",
        winBalloon: "Gewinnen Sie eine Ballonfahrt!",
        description: "Nehmen Sie an unserer großen Tombola teil und gewinnen Sie eine Ballonfahrt für 2 Personen, die direkt vom Domaine de la Briouse startet!",
        ticketPrice: "pro Los",
        drawDate: "Ziehung am 8. Nov. 2026",
        drawTime: "Ziehung um 18 Uhr",
        participate: "An der Tombola teilnehmen",
        howItWorks: "Wie funktioniert es?",
        step1: "Kaufen Sie Ihr Los",
        step1Desc: "Lose online über HelloAsso oder vor Ort bei unseren Veranstaltungen erhältlich.",
        step2: "Warten Sie auf die Ziehung",
        step2Desc: "Die Ziehung findet am 8. November 2026 um 18 Uhr auf dem Domaine de la Briouse statt.",
        step3: "Heben Sie ab!",
        step3Desc: "Der Gewinner genießt eine Ballonfahrt für 2 Personen.",
        rules: "Teilnahmebedingungen",
        rulesDesc: "Tombola gemäß den geltenden Vorschriften organisiert."
      },
      legal: {
        title: "Impressum",
        legalNotice: "Impressum",
        cgv: "AGB",
        privacy: "Datenschutz",
        editor: "Herausgeber der Website",
        hosting: "Hosting",
        intellectual: "Geistiges Eigentum",
        intellectualDesc: "Der gesamte Inhalt dieser Website (Texte, Bilder, Videos) ist urheberrechtlich geschützt.",
        dataProtection: "Datenschutz",
        dataProtectionDesc: "Gemäß der DSGVO haben Sie das Recht auf Zugang, Änderung und Löschung Ihrer persönlichen Daten.",
        cookies: "Cookies",
        cookiesDesc: "Diese Website verwendet Cookies, um Ihr Surferlebnis zu verbessern.",
        contact: "Kontakt"
      }
    }
  },
  nl: {
    translation: {
      nav: {
        home: "Home",
        events: "Evenementen",
        news: "Nieuws",
        association: "De Vereniging",
        partners: "Partners",
        gettingHere: "Routebeschrijving",
        contact: "Contact",
        volunteer: "Vrijwilligers",
        membership: "Lidmaatschap"
      },
      home: {
        welcome: "Welkom bij Brious'O Folies",
        subtitle: "Paardensportvereniging in het hart van Nouvelle-Aquitaine",
        discoverEvents: "Ontdek onze evenementen",
        joinUs: "Doe mee",
        becomeVolunteer: "Word vrijwilliger",
        becomeMember: "Word lid",
        upcomingEvents: "Komende evenementen",
        viewAllEvents: "Bekijk alle evenementen",
        newsletter: "Nieuwsbrief",
        newsletterDesc: "Blijf op de hoogte van ons nieuws",
        email: "Uw e-mail",
        subscribe: "Inschrijven"
      },
      events: {
        title: "Onze Evenementen",
        subtitle: "Ontdek onze endurance races en paardenritten",
        allEvents: "Alle",
        endurance: "Endurance",
        randonnee: "Rit",
        stage: "Training",
        concert: "Concert",
        register: "Inschrijven",
        learnMore: "Meer info",
        organization: "Organisatie",
        noEvents: "Momenteel geen evenementen"
      },
      endurance: {
        title: "Reglementen & Resultaten",
        subtitle: "Officiële FFE, FEI en SHF reglementen",
        regulations: "Officiële Reglementen",
        results: "Onze Resultaten",
        france: "Frankrijk - FFE",
        international: "Internationaal - FEI",
        youngHorses: "Jonge Paarden - SHF",
        usefulLinks: "Nuttige Links",
        download: "Downloaden"
      },
      organization: {
        title: "Organisatie",
        schedule: "Schema",
        participants: "Deelnemers",
        route: "Route",
        veterinary: "Dierenarts",
        practicalInfo: "Praktische Info",
        program: "Dagprogramma",
        races: "Wedstrijden",
        participantsList: "Deelnemerslijst & Startnummers",
        roadBooks: "Road Books",
        mapsRoutes: "Kaarten & Routes",
        vetCards: "Veterinaire volgkaarten",
        vetInfo: "Veterinaire informatie",
        usefulNumbers: "Nuttige nummers",
        emergencyNumbers: "Noodnummers",
        sitePlan: "Plattegrond",
        parking: "Parkeren",
        toilets: "Toiletten",
        vetZone: "Dierenarts zone",
        groomingZone: "Grooming zone",
        restZone: "Paardenrust zone",
        backToEvents: "Terug naar evenementen"
      },
      contact: {
        title: "Neem contact op",
        subtitle: "Een vraag? Aarzel niet om ons te schrijven",
        name: "Uw naam",
        email: "Uw e-mail",
        subject: "Onderwerp",
        message: "Uw bericht",
        send: "Verzenden",
        sending: "Verzenden...",
        success: "Bericht succesvol verzonden!",
        error: "Fout bij verzenden"
      },
      common: {
        readMore: "Lees meer",
        seeAll: "Bekijk alles",
        loading: "Laden...",
        error: "Fout",
        close: "Sluiten",
        save: "Opslaan",
        cancel: "Annuleren",
        delete: "Verwijderen",
        edit: "Bewerken",
        add: "Toevoegen",
        search: "Zoeken",
        filter: "Filteren",
        results: "resultaten",
        comingSoon: "Binnenkort",
        date: "Datum",
        location: "Locatie",
        distance: "Afstand",
        level: "Niveau",
        departure: "Start",
        back: "Terug",
        backToHome: "Terug naar home",
        backToEvents: "Terug naar evenementen",
        backToNews: "Terug naar nieuws",
        login: "Inloggen",
        logout: "Uitloggen",
        logoutSuccess: "Succesvol uitgelogd",
        loginSuccess: "Succesvol ingelogd",
        loginError: "Inlogfout",
        invalidCredentials: "Ongeldige inloggegevens.",
        welcome: "Welkom",
        book: "Boeken",
        free: "Gratis",
        send: "Versturen",
        sending: "Wordt verstuurd...",
        download: "Downloaden",
        register: "Inschrijving",
        confirm: "Bevestigen",
        errorOccurred: "Er is een fout opgetreden",
        tryAgain: "Probeer het opnieuw",
        errorSending: "Fout bij verzenden",
        errorCreating: "Fout bij aanmaken",
        errorUpdating: "Fout bij bijwerken",
        errorDeleting: "Fout bij verwijderen",
        errorUpload: "Fout bij uploaden",
        confirmDelete: "Dit item verwijderen?",
        confirmDeleteUser: "Deze gebruiker verwijderen?",
        addUser: "Gebruiker toevoegen",
        sendTestEmail: "Test e-mail versturen",
        sendTestTo: "Test e-mail versturen naar:",
        email: "E-mail",
        password: "Wachtwoord",
        adminLogin: "Admin Login",
        staffArea: "Personeelsruimte",
        manageMedia: "U kunt nu media beheren.",
        regulations: "Reglementen & Resultaten",
        officialRegulations: "Officiële reglementen & Raceresultaten",
        ourResults: "Onze Resultaten",
        raceResults: "Brious'O Folies raceresultaten",
        resultsComingSoon: "Resultaten binnenkort",
        savedSuccess: "Succesvol opgeslagen",
        savedError: "Fout bij opslaan"
      },
      footer: {
        rights: "Alle rechten voorbehouden",
        legalNotice: "Juridische kennisgeving",
        privacy: "Privacybeleid",
        terms: "Algemene voorwaarden",
        followUs: "Volg ons"
      },
      // Association page
      association: {
        whoAreWe: "Wie zijn wij?",
        title: "De Vereniging",
        description: "Brious'O Folies werkt het hele jaar aan de promotie van paardensportactiviteiten, buitensporten en culturele evenementen.",
        heartOfMelusin: "Een vereniging in het hart van",
        paysMelusin: "Pays Mélusin",
        presentation1: "is een vereniging zonder winstoogmerk volgens de wet van 1901, opgericht om sportieve, hippische en culturele evenementen te organiseren op het Domaine de la Briouse in Sanxay (86).",
        ourMission: "Onze missie:",
        missionDesc: "Het bevorderen en organiseren van hippische, sportieve, culturele en erfgoedactiviteiten, met aandacht voor gezelligheid, overdracht en toegang tot de natuur voor iedereen.",
        presentation2: "Paardenritten, endurance races, openluchtconcerten, familiebeurten... We creëren momenten van",
        conviviality: "gezelligheid, delen en ontdekking",
        presentation3: ", open voor ruiters, families, lokale bewoners en passerende bezoekers.",
        becomeMember: "Word Lid",
        becomeVolunteer: "Word Vrijwilliger",
        becomePartner: "Word Partner",
        keyFigures: "Kerncijfers 2025",
        eventsOrganized: "Georganiseerde evenementen",
        inYear: "in 2025",
        artistsPerformers: "Artiesten & performers",
        ridersWelcomed: "Verwelkomde ruiters",
        visitorsOnSite: "Bezoekers op locatie",
        ourTeam: "Ons Team",
        bureauMembers: "Bestuursleden",
        bureauDesc: "Een team van gepassioneerde vrijwilligers met complementaire vaardigheden, gedreven door sterke waarden.",
        whatDrivesUs: "Wat ons drijft",
        ourValues: "Onze Kernwaarden",
        benevolence: "Welwillendheid",
        benevolenceDesc: "Elke deelnemer, vrijwilliger of partner verwelkomen in een klimaat van respect, luisteren en veiligheid.",
        respect: "Respect",
        respectDesc: "Zorgen voor het welzijn van paarden, bescherming van het milieu en respect voor erfgoedsites en mensen.",
        conviviality2: "Gezelligheid",
        convivialityDesc: "Warme, intergenerationele momenten creëren waar families, ruiters, bewoners, toeristen en bedrijven samenkomen.",
        environment: "Milieu",
        environmentDesc: "Verantwoorde evenementen organiseren, met aandacht voor de impact op de natuur en het gebruik van landelijke ruimtes.",
        transmission: "Overdracht",
        transmissionDesc: "Hippische kennis, erfgoedkennis en burgerlijke waarden delen met jongeren en het grote publiek.",
        accessibility: "Toegankelijkheid",
        accessibilityDesc: "Sport, cultuur en natuur toegankelijk maken voor zoveel mogelijk mensen.",
        ourImpact: "Onze Impact",
        ourActions: "Onze Acties",
        actionsDesc: "Door zijn acties draagt de vereniging actief bij aan de revitalisering van het gebied, de ontwikkeling van plattelandstoerisme en de versterking van sociale banden.",
        contactUs: "Neem contact op",
        contactQuestion: "Voor vragen of informatieverzoeken",
        writeToUs: "Contact",
        joinAdventure: "Word deel van het avontuur!",
        ctaDesc: "Of je nu ruiter, cultuurliefhebber, natuurliefhebber of gewoon nieuwsgierig bent - er is een plek voor jou bij Brious'O Folies.",
        membershipFor: "Lid worden voor €10"
      },
      // Partners page
      partners: {
        becomePartner: "Word Partner",
        supportUs: "Steun Brious'O Folies",
        heroDesc: "Bedrijven, ambachtslieden, lokale overheden: word deel van het avontuur en geef zichtbaarheid aan uw organisatie terwijl u het gebied ondersteunt!",
        downloadDossier: "Download Sponsordossier",
        contactUs: "Neem Contact Op",
        whyJoinUs: "Waarom meedoen?",
        partnershipBenefits: "Voordelen van het Partnerschap",
        localVisibility: "Lokale Zichtbaarheid",
        localVisibilityDesc: "Bereik een familie-georiënteerd, gepassioneerd en betrokken publiek in het Pays Mélusin-gebied.",
        positiveImage: "Positief Imago",
        positiveImageDesc: "Verbind uw merk met sterke waarden: natuur, erfgoed, sport en toegankelijke cultuur.",
        network: "Netwerk",
        networkDesc: "Word lid van een netwerk van bedrijven en lokale overheden die zich inzetten voor het gebied.",
        taxBenefits: "Belastingvoordelen",
        taxBenefitsDesc: "Profiteer van belastingverminderingen door mecenaat (66% van de donatie aftrekbaar).",
        ourFormulas: "Onze Formules",
        choosePackage: "Kies Uw Partner Pakket",
        packagesDesc: "Formules aangepast aan alle budgetten, met concrete en meetbare voordelen.",
        selectPack: "Dit pakket kiezen",
        technicalPartnership: "Technisch Partnerschap / Mecenaat",
        technicalDesc: "Wilt u ons anders ondersteunen? Apparatuur, diensten, vaardigheden... Neem contact met ons op voor een aanbod op maat!",
        discussProject: "Laten we uw project bespreken",
        ourCommitment: "Onze Toezegging",
        whatWeGuarantee: "Wat wij u garanderen",
        dedicatedContact: "Een toegewijde contactpersoon voor elke partner",
        taxOptimization: "Geoptimaliseerde belasting (belastingkwitantie voor donaties)",
        customOffers: "Aanbiedingen op maat naar uw behoeften",
        fullTransparency: "Volledige transparantie over het gebruik van fondsen",
        detailedReport: "Gedetailleerd rapport na elk evenement",
        sponsorDossier: "Compleet Sponsordossier",
        dossierDesc: "Vind alle gedetailleerde informatie: evenementen, budgetten, voordelen en contacten.",
        downloadPdf: "PDF downloaden",
        questions: "Heeft u vragen?",
        questionsDesc: "Ons team staat tot uw beschikking om samen een partnerschap op maat op te bouwen.",
        thankPartners: "Dank aan onze partners",
        theyTrusted: "Zij vertrouwden ons",
        thankYouDesc: "Een grote dank aan alle bedrijven, instellingen en lokale overheden die Brious'O Folies ondersteunen.",
        institutionsCollectivities: "Instellingen & Lokale Overheden",
        equestrianFederations: "Paardensportfederaties",
        partnerCompanies: "Partnerbedrijven",
        tourismLeisure: "Toerisme & Vrije Tijd",
        readyToJoin: "Klaar om mee te doen?",
        ctaDesc: "Neem nu contact met ons op om uw partnerschapsproject te bespreken en deel uit te maken van het Brious'O Folies avontuur!",
        partnershipRequest: "Partnerschapsverzoek",
        selectedPack: "Geselecteerd pakket",
        thankYouInterest: "Bedankt voor uw interesse!",
        requestSent: "Uw verzoek is succesvol verzonden. We nemen zeer binnenkort contact met u op om uw partnerschap te bespreken.",
        fullName: "Volledige naam",
        company: "Bedrijf",
        phone: "Telefoon",
        sendRequest: "Mijn verzoek verzenden",
        formConsent: "Door dit formulier in te dienen, gaat u ermee akkoord dat de vereniging Brious'O Folies contact met u opneemt."
      },
      loginModal: {
        staffArea: "Personeelsruimte",
        memberArea: "Ledenruimte",
        staffDesc: "Beheer van de Brious'O Folies website",
        memberDesc: "Toegang tot uw persoonlijke ruimte",
        createAccount: "Maak uw lidaccount aan",
        member: "Lid",
        signIn: "Inloggen",
        firstName: "Voornaam",
        lastName: "Achternaam",
        phone: "Telefoon",
        createMyAccount: "Mijn account aanmaken",
        accountCreated: "Account aangemaakt! Log nu in.",
        alreadyAccount: "Al een account? Inloggen",
        noAccount: "Nog geen account? Registreren"
      },
      ip: {
        title: "Praktische Info", subtitle: "Alle essentiële informatie voor elk evenement",
        selectEvent: "Selecteer een evenement",
        navAcces: "Toegang", navParcours: "Parcours", navProgramme: "Programma", navDocuments: "Documenten",
        navContacts: "Contacten", navRestau: "Catering", navResultats: "Resultaten", navSecurite: "Veiligheid", navConseils: "Tips",
        accesTitle: "Toegang & Parkeren", consignes: "Toegangsinstructies",
        parcoursTitle: "Parcours & Routes",
        programmeTitle: "Programma & Tijdschema", programmeComingSoon: "Programma volgt",
        programmeComingSoonDesc: "Het programma wordt binnenkort gepubliceerd.",
        documentsTitle: "Documenten & Roadbook", documentsOfficiels: "Officiële Documenten",
        uploadDoc: "Document uploaden", uploading: "Uploaden...",
        noDocsYet: "Nog geen officiële documenten.",
        contactsTitle: "Contacten & Nuttige Nummers", emergency: "Noodgeval",
        restaurationTitle: "Catering & Verfrissingen", resultatsTitle: "Resultaten & Klassementen",
        securiteTitle: "Regels & Veiligheid", readRules: "Volledig reglement", hideRules: "Reglement verbergen",
        weather14: "14-daagse weer", seoTitle: "Trefwoorden", backToTop: "Terug naar boven",
        download: "Downloaden", downloadGpx: "GPX downloaden", downloadPdf: "Programma PDF downloaden",
        guideTitle: "Endurance paardrijden begrijpen", guideSubtitle: "Praktische gids",
        guideIntro: "Deze gids helpt u de proefcategorieën, afstanden en snelheden te begrijpen.",
        guideCategories: "Soorten proeven",
        guideTable: "Afstand / tijd tabel", guideTableSub: "Geschatte tijd per afstand en snelheid",
        guideCalc: "Snelheidscalculator",
        calcDepart: "Vertrektijd", calcArrivee: "Aankomsttijd", calcDistance: "Afgelegde afstand",
        calcReset: "Resetten", calcTotalTime: "Totale tijd", calcAvgSpeed: "Gemiddelde snelheid",
        calcPlaceholder: "Vul uw gegevens in", calcPlaceholderSub: "Resultaat verschijnt automatisch",
        guideRemember: "Te onthouden",
        guideRemember1: "De tijden zijn indicatieve richtpunten.",
        guideRemember2: "Het officiële reglement blijft de referentie.",
        guideRemember3: "Werkelijke tijden kunnen variëren.",
        guideRemember4: "Luister naar uw paard en geef prioriteit aan dierenwelzijn.",
        progDeparts: "Vertrekprogramma", progDistance: "Afstand", progDepart: "Start",
        progCategories: "Categorieën", progBoucles: "Te volgen lussen", progReal: "werkelijk",
        progReadCourse: "Hoe uw parcours te lezen", progReadCourseSub: "Volg de kleuren in de volgorde",
        progLegend: "Lus legende", progOrganisation: "Dagorganisatie",
        progPrizes: "Prijsuitreiking", progImportantInfo: "Belangrijke informatie",
        progBriefing: "De briefing is verplicht voor elke start.",
        progAdjust: "Tijden kunnen worden aangepast.",
        progVet: "Veterinaire controle is verplicht.",
        progReglement: "Raadpleeg het officiële reglement.",
        progWarning: "Ruiters moeten kleurmarkeringen strikt volgen.",
        elevDistance: "Afstand", elevDenivele: "Hoogteverschil", elevAltMin: "Hoogte Min", elevAltMax: "Hoogte Max",
        elevTerrain: "Paden en lokale wegen", elevWater: "Waterpunten langs het parcours",
        courses10to80: "Races 10 tot 80 km", courses100and120: "Races 100 en 120 km",
        guideDistLabel: "Afstanden", guideNivLabel: "Niveaus", guideSpeedLabel: "Snelheden",
        calcExample: "Voorbeeld", progBouclesLabel: "Lussen",
        catAmateurDesc: "Proeven voor ruiters met FFE-licentie. Amateurendurance biedt een aangepast competitiekader.",
        catClubDesc: "Ontdekkings- en opleidingsproeven voor clubruiters. Ideaal om te beginnen met wedstrijden.",
        catPrepaDesc: "Trainingsproeven in reële omstandigheden. Perfect ter voorbereiding.",
        catVIDesc: "De ruiter moet een door de jury opgelegde snelheid aanhouden. Regelmaat is essentieel.",
        catVRDesc: "De ruiter moet een doelsnelheid respecteren binnen een tolerantie.",
        catSHFDesc: "Programma voor jonge paarden van de Société Hippique Française. Progressieve sporttraining.",
        elevDistTooltip: "Afst.", elevAltTooltip: "Hoogte",
        secCavaliers: "Veiligheid ruiters", secChevaux: "Welzijn paarden", secEnvironnement: "Milieu",
        conseilsTitle: "Praktische Info & Tips", conseilsSub: "Checklist, aanbevelingen en weer",
        conseilsRecos: "Tips & Aanbevelingen", checklistTitle: "Ruiter Checklist",
        logistiqueTitle: "Logistieke Tips", viewAccommodation: "Bekijk accommodaties",
        weatherTitle: "Weer Sanxay — 14-daagse voorspelling",
        weatherForecast: "Bekijk 14-daagse voorspelling op Météo France",
        weatherLoading: "Voorspelling laden...", weatherUnavailable: "Voorspelling tijdelijk niet beschikbaar",
        weatherLink: "Bekijk Météo France — Sanxay",
        shareBtn: "DELEN", shareTitle: "Deel deze pagina", shareMessage: "Bekijk de praktische info voor {{event}} van Brious'O Folies",
        shareCopyLink: "Link kopiëren", shareCopied: "Link gekopieerd!"
      },
      homeExt: {
        heroTitle1: "Beleef de evenementen van",
        heroTitle2: "in Sanxay",
        heroSubtitle: "Paardensportactiviteiten, buitensporten en culturele evenementen in het hart van",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Evenementen bekijken",
        becomeMember: "Lid worden",
        becomeVolunteer: "Vrijwilliger worden",
        receiveNews: "Nieuws ontvangen",
        eventsPerYear: "Evenementen/jaar",
        visitorsWelcomed: "Verwelkomde bezoekers",
        volunteersActive: "Gemobiliseerde vrijwilligers",
        landArea: "Terrein",
        dontMiss: "Mis niets!",
        upcomingEvents: "Komende Evenementen",
        upcomingEventsDesc: "Concerten, paardritten, endurance races, country avonden... Ontdek ons programma en reserveer uw plek!",
        reserve: "Boeken",
        free: "GRATIS",
        seeAllEvents: "Alle evenementen bekijken",
        allYear: "Het hele jaar",
        seasonTitle: "Brious'O Folies Seizoen",
        seasonDesc: "Evenementen het hele jaar door in het ritme van de seizoenen",
        spring: "Lente",
        summer: "Zomer",
        autumn: "Herfst",
        winter: "Winter",
        springEvents: ["Paardrijlessen", "Natuurwandelingen", "Paaseieren zoeken", "Country avonden"],
        summerEvents: ["Koorconcerten", "Departementaal endurance kampioenschap", "Rommelmarkten"],
        autumnEvents: ["Halloween rit", "Film-middag", "Endurance race"],
        winterEvents: ["Film-middag", "Intieme concerten", "Workshops", "Spelletjes"],
        joinCommunity: "Word lid van de Brious'O Folies gemeenschap",
        newsletterDesc: "Ontvang nieuws over onze evenementen, concerten, natuuractiviteiten en endurance races.",
        iWantInfo: "Ik wil informatie ontvangen over:",
        nlEndurance: "Endurance paardritten",
        nlConcerts: "Concerten en shows",
        nlNature: "Natuuractiviteiten en wandelingen",
        nlFamily: "Familie-evenementen",
        nlPedagogy: "Educatieve activiteiten",
        nlVolunteer: "Vrijwilliger worden",
        emailPlaceholder: "Uw e-mailadres",
        joinCommunityBtn: "Ik word lid van de gemeenschap",
        thankYou: "Dank u!",
        subscribedMsg: "U bent nu ingeschreven voor onze nieuwsbrief.",
        welcomeMsg: "Welkom in de gemeenschap!",
        welcomeDesc: "U ontvangt binnenkort ons nieuws.",
        prefsUpdated: "Voorkeuren bijgewerkt!",
        prefsUpdatedDesc: "Uw interesses zijn bijgewerkt.",
        joinTeam: "Word lid van het team",
        becomeVolunteerTitle: "Word vrijwilliger bij Brious'O Folies",
        volunteerDesc: "Wilt u helpen bij het organiseren van sport- en culturele evenementen? Word lid van ons vrijwilligersteam voor onvergetelijke gedeelde momenten!",
        volunteerBenefit1: "Evenementen van binnenuit beleven",
        volunteerBenefit2: "Geweldige ontmoetingen maken",
        volunteerBenefit3: "Geen ervaring vereist",
        volunteerBtn: "Vrijwilliger worden",
        volunteersTrustUs: "Vrijwilligers vertrouwen ons",
        heritageNature: "Erfgoed & Natuur",
        discoverSanxay: "Ontdek Sanxay en zijn regio",
        discoverDesc: "Het Domaine de la Briouse is ideaal gelegen om de schatten van Pays Mélusin te ontdekken",
        discoverRegion: "De regio ontdekken",
        ourCommitment: "Ons Engagement",
        valuesTitle: "Waarden die ons verbinden",
        benevolence: "Welwillendheid",
        benevolenceDesc: "Een warm welkom voor iedereen",
        conviviality: "Gezelligheid",
        convivialityDesc: "Momenten van uitwisseling en ontmoeting",
        respect: "Respect",
        respectDesc: "Voor de natuur en de paarden",
        culture: "Cultuur",
        cultureDesc: "Toegankelijke artistieke evenementen",
        ourPlace: "Onze Locatie",
        domainTitle: "Het Domaine de la Briouse",
        domainDesc: "Gelegen in het hart van Pays Mélusin, biedt het Domaine de la Briouse een uitzonderlijk natuurlijk en cultureel kader. Dicht bij de beroemde Gallo-Romeinse site van Sanxay, is het de ideale plek voor evenementen die sport, cultuur en natuur combineren.",
        howToCome: "Hoe te komen",
        joinAdventure: "Word deel van het Brious'O Folies avontuur",
        ctaDesc: "Word lid en neem deel aan het verenigingsleven. Samen houden we het erfgoed en de gezelligheid van Pays Mélusin levend.",
        memberFor10: "Lid worden voor 10€",
        contactUsBtn: "Neem contact op",
        call: "Bellen",
        galloRomanSite: "Gallo-Romeinse Site van Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      eventsExt: {
        calendar: "Kalender",
        calendar2026: "Kalender 2026",
        title: "Onze Evenementen",
        subtitle: "Paardritten, concerten, endurance races en familie-evenementen... Ontdek al onze activiteiten op het Domaine de la Briouse.",
        downloadLivret: "PDF-brochure downloaden",
        featured: "Uitgelicht",
        grandeTombola: "Grote Tombola",
        winBalloon: "Win een Ballonvaart!",
        tombolaDesc: "Doe mee aan onze grote tombola en win een ballonvaart voor 2 personen die rechtstreeks opstijgt vanaf het Domaine de la Briouse!",
        ticket: "per lot",
        drawAt: "Trekking om 18u",
        participateTombola: "Deelnemen aan de Tombola",
        learnMore: "Meer informatie",
        filterByCategory: "Filteren op categorie",
        allCategories: "Alle categorieën",
        resetFilters: "Filters resetten",
        becomeMember: "Lid worden",
        memberDesc: "Steun onze vereniging en geniet van exclusieve voordelen.",
        memberFor10: "Lid worden voor 10€",
        noEventsFound: "Geen evenementen gevonden voor deze criteria.",
        seeAllEvents: "Alle evenementen bekijken",
        reserve: "Boeken",
        freeEntry: "Gratis toegang",
        orga: "Org",
        equitation: "Paardrijden",
        concert: "Concert",
        randonnee: "Wandelrit",
        course: "Race",
        brocante: "Rommelmarkt",
        cinema: "Bioscoop"
      },
      contactExt: {
        contactUs: "Neem contact op",
        title: "Contact",
        subtitle: "Een vraag, een suggestie, zin om mee te doen? Aarzel niet om contact met ons op te nemen.",
        contactInfo: "Contactgegevens",
        phone: "Telefoon",
        address: "Adres",
        onlineMembership: "Online Lidmaatschap",
        joinViaHelloAsso: "Word lid van onze vereniging via HelloAsso.",
        memberFor10: "Lid worden voor 10€",
        sendMessage: "Stuur ons een bericht",
        fullName: "Volledige naam *",
        email: "E-mail *",
        subject: "Onderwerp *",
        subjectPlaceholder: "Betreffende...",
        message: "Bericht *",
        messagePlaceholder: "Uw bericht...",
        newsletterCheckbox: "Ik wil me abonneren op de nieuwsbrief om nieuws van Brious'O Folies te ontvangen",
        sendBtn: "Bericht versturen",
        successMsg: "Bericht succesvol verstuurd!",
        successDescNewsletter: "U bent ook ingeschreven voor de nieuwsbrief.",
        successDesc: "We zullen zo snel mogelijk antwoorden.",
        errorMsg: "Fout bij het versturen van het bericht",
        errorDesc: "Probeer het later opnieuw.",
        findUs: "Vind ons"
      },
      benevoles: {
        joinAdventure: "Word deel van het avontuur",
        title: "Word Vrijwilliger",
        heroDesc: "De evenementen die we organiseren zouden niet mogelijk zijn zonder de inzet en de vrijgevigheid van degenen die een beetje van hun tijd geven.",
        signUp: "Ik meld me aan als vrijwilliger",
        thanks: "Bedankt!",
        callTitle: "Brious'O Folies doet een oproep!",
        callP1: "Vandaag doet <strong>Brious'O Folies</strong> een oproep aan alle inwoners die vrijwilliger willen worden en willen deelnemen aan het lokale leven.",
        callP2: "<strong>Sportevenementen, concerten, shows, wandelingen, familieactiviteiten of feestelijke bijeenkomsten</strong>: onze projecten zijn gevarieerd en iedereen kan zijn plek vinden.",
        callP3: "Publieksontvangs, organisatiehulp, logistiek, opbouw, communicatie, begeleiding van deelnemers of gewoon een helpende hand... <strong>er zijn duizend manieren om mee te doen</strong>, naar uw wensen, vaardigheden en beschikbaarheid.",
        chooseEvent: "Kies uw evenement",
        eventsCalendar: "Evenementenkalender",
        clickToSign: "Klik op een evenement om u aan te melden als vrijwilliger",
        selectedEvent: "Geselecteerd Evenement",
        monthEvents: "Evenementen deze maand",
        volunteerForEvent: "Vrijwilliger worden voor dit evenement",
        seeAllEvents: "Alle evenementen bekijken",
        noEventThisMonth: "Geen evenementen deze maand.",
        navigateCalendar: "Navigeer door de kalender!",
        findYourPlace: "Vind uw plek",
        missionTypes: "Soorten Opdrachten",
        missionDesc: "Er zijn veel manieren om bij te dragen naar uw wensen en vaardigheden.",
        publicWelcome: "Publieksontvangs",
        publicWelcomeDesc: "Bezoekers oriënteren en informeren tijdens onze evenementen",
        logistics: "Logistiek & Opbouw",
        logisticsDesc: "Stands opzetten, bewegwijzering en faciliteiten",
        animation: "Animatie",
        animationDesc: "Deelnemers begeleiden tijdens shows en concerten",
        helpOut: "Occasionele Hulp",
        helpOutDesc: "Diverse hulp naar beschikbaarheid en wensen",
        whyJoin: "Waarom meedoen?",
        beingVolunteer: "Vrijwilliger zijn betekent...",
        beingVolunteerDesc: "Evenementen van binnenuit beleven, sterke momenten delen, geweldige ontmoetingen maken en bijdragen aan betekenisvolle projecten voor ons gebied.",
        benefit1: "Evenementen van binnenuit beleven",
        benefit2: "Geweldige ontmoetingen maken",
        benefit3: "Bijdragen aan betekenisvolle projecten",
        benefit4: "Vriendelijke en zorgzame sfeer",
        benefit5: "Geen ervaring vereist",
        benefit6: "Inzet naar beschikbaarheid",
        essentialDesire: "Het belangrijkste is de wil!",
        essentialP1: "Geen bijzondere ervaring is nodig: het belangrijkste is de wil om deel te nemen, te delen en deel uit te maken van een collectief avontuur.",
        essentialP2: "Het vrijwilligersteam van Brious'O Folies vervoegen betekent je inzetten in een",
        essentialP2Bold: "vriendelijke en zorgzame sfeer",
        essentialP2End: ", in dienst van uitwisseling, cultuur, sport en natuur.",
        ifAdventureTempts: "Als het avontuur u aantrekt...",
        ctaDesc: "Kom ons ontmoeten op onze evenementen of meld u direct aan: we verwelkomen u graag en schrijven samen het volgende hoofdstuk van dit mooie verhaal!",
        becomeVolunteer: "Ik word vrijwilliger",
        contactUs: "Neem contact op",
        followSocial: "Volg ons op sociale media!",
        dayNames: ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"]
      },
      footerExt: {
        visitorsSay: "Wat onze bezoekers zeggen",
        review1: "Geweldige sfeer, top team!",
        review2: "Kwaliteitsevenementen, we komen terug!",
        review3: "Prachtige omgeving, goed verzorgde paarden",
        navigation: "Navigatie",
        home: "Home",
        events: "Evenementen",
        association: "De Vereniging",
        gettingHere: "Hoe te komen",
        news: "Nieuws",
        volunteers: "Vrijwilligers",
        partners: "Partners",
        contactLabel: "Contact",
        contactTitle: "Contact",
        contactUsLink: "Neem contact op",
        ourValues: "Onze Waarden",
        value1: "Overdracht & Delen",
        value2: "Verantwoorde Sport",
        value3: "Toegankelijke Cultuur",
        value4: "Respect voor de Natuur",
        value5: "Gezelligheid",
        value6: "Welwillendheid",
        becomeMember: "Lid worden",
        allRights: "Alle rechten voorbehouden",
        legalNotice: "Juridische kennisgeving",
        cgv: "AV",
        privacy: "Privacy",
        description: "Vereniging zonder winstoogmerk gewijd aan de promotie van paardensportactiviteiten, buitensporten en culturele evenementen op het Domaine de la Briouse."
      },
      venir: {
        title: "Hoe te komen",
        subtitle: "Domaine de la Briouse",
        heroDesc: "Alle praktische informatie om ons te bezoeken in het hart van Pays Mélusin.",
        howToCome: "Hoe te komen",
        accommodation: "Accommodatie",
        restaurants: "Restaurants",
        discover: "Ontdekken",
        byCar: "Met de auto",
        byTrain: "Met de trein",
        byPlane: "Met het vliegtuig",
        gps: "GPS Coördinaten",
        distance: "Afstand",
        all: "Alle",
        onSite: "Ter plaatse",
        nearby: "In de buurt",
        book: "Boeken",
        visitWebsite: "Website bezoeken",
        seeOnMap: "Op de kaart bekijken",
        discoverRegion: "De Regio Ontdekken",
        discoverDesc: "Het Domaine de la Briouse is ideaal gelegen in het hart van Pays Mélusin, omgeven door opmerkelijke plaatsen.",
        filterByDistance: "Filteren op afstand",
        heritageNature: "Erfgoed & Natuur",
        leisure: "Vrije tijd & Cultuur",
        beaches: "Stranden & Kust",
        contactTitle: "Informatie nodig?",
        contactDesc: "Ons team staat klaar om u te helpen bij het plannen van uw verblijf.",
        contactBtn: "Neem contact op",
        callUs: "Bel ons",
        name: "Naam *",
        email: "E-mail *",
        messageLabel: "Bericht *",
        sendBtn: "Versturen",
        msgSent: "Bericht verstuurd!",
        msgSentDesc: "We antwoorden snel.",
        msgError: "Fout bij verzenden",
        msgErrorDesc: "Probeer het opnieuw.",
        chambreHotes: "B&B & Vakantiehuizen",
        camping: "Camping",
        hotel: "Hotel",
        gite: "Vakantiehuis",
        traditional: "Traditionele keuken",
        gastro: "Gastronomie",
        pizzeria: "Pizzeria",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Prijsklasse"
      },
      adhesion: {
        title: "Lidmaatschap",
        subtitle: "Lid worden",
        heroDesc: "Word lid van de vereniging Brious'O Folies en neem deel aan het leven van het Domaine de la Briouse.",
        why: "Waarom lid worden?",
        benefit1: "Onze evenementen steunen",
        benefit1Desc: "Uw lidmaatschap financiert rechtstreeks onze concerten, ritten en activiteiten.",
        benefit2: "Bevoorrecht toegang",
        benefit2Desc: "Gereduceerde tarieven en bevoorrechte toegang tot bepaalde evenementen.",
        benefit3: "Gemeenschap",
        benefit3Desc: "Word lid van een gepassioneerde gemeenschap van Pays Mélusin.",
        joinNow: "Nu lid worden",
        memberFor10: "Jaarlijks lidmaatschap: 10€",
        helloAssoInfo: "Het lidmaatschap verloopt via HelloAsso, onze beveiligde betalingspartner.",
        questions: "Vragen?",
        contactUs: "Neem contact op"
      },
      actualites: {
        title: "Nieuws",
        subtitle: "Ons Nieuws",
        heroDesc: "Volg het laatste nieuws van Brious'O Folies en het Domaine de la Briouse.",
        noNews: "Momenteel geen nieuws.",
        stayTuned: "Blijf verbonden!",
        followUs: "Volg ons op sociale media om niets te missen.",
        readMore: "Lees meer",
        published: "Gepubliceerd op",
        categories: "Categorieën",
        all: "Alle",
        mediaDeleted: "Media verwijderd"
      },
      tombola: {
        title: "Grote Tombola",
        subtitle: "Brious'O Folies Tombola",
        heroDesc: "Doe mee aan onze grote tombola en win een ballonvaart!",
        winBalloon: "Win een Ballonvaart!",
        description: "Doe mee aan onze grote tombola en win een ballonvaart voor 2 personen die rechtstreeks opstijgt vanaf het Domaine de la Briouse!",
        ticketPrice: "per lot",
        drawDate: "Trekking op 8 nov. 2026",
        drawTime: "Trekking om 18u",
        participate: "Deelnemen aan de Tombola",
        howItWorks: "Hoe werkt het?",
        step1: "Koop uw lot",
        step1Desc: "Loten beschikbaar online via HelloAsso of ter plaatse tijdens onze evenementen.",
        step2: "Wacht op de trekking",
        step2Desc: "De trekking vindt plaats op 8 november 2026 om 18u op het Domaine de la Briouse.",
        step3: "Stijg op!",
        step3Desc: "De winnaar geniet van een ballonvaart voor 2 personen.",
        rules: "Reglement",
        rulesDesc: "Tombola georganiseerd conform de geldende regelgeving."
      },
      legal: {
        title: "Juridische Kennisgeving",
        legalNotice: "Juridische Kennisgeving",
        cgv: "Algemene Voorwaarden",
        privacy: "Privacybeleid",
        editor: "Uitgever van de website",
        hosting: "Hosting",
        intellectual: "Intellectueel eigendom",
        intellectualDesc: "Alle inhoud op deze website (teksten, afbeeldingen, video's) is beschermd door het auteursrecht.",
        dataProtection: "Gegevensbescherming",
        dataProtectionDesc: "Conform de AVG heeft u recht op toegang, wijziging en verwijdering van uw persoonlijke gegevens.",
        cookies: "Cookies",
        cookiesDesc: "Deze website gebruikt cookies om uw surfervaring te verbeteren.",
        contact: "Contact"
      }
    }
  },
  sv: {
    translation: {
      nav: {
        home: "Hem",
        events: "Evenemang",
        news: "Nyheter",
        association: "Föreningen",
        partners: "Partners",
        gettingHere: "Hitta hit",
        contact: "Kontakt",
        volunteer: "Volontärer",
        membership: "Medlemskap"
      },
      home: {
        welcome: "Välkommen till Brious'O Folies",
        subtitle: "Ridsportförening i hjärtat av Nouvelle-Aquitaine",
        discoverEvents: "Upptäck våra evenemang",
        joinUs: "Gå med oss",
        becomeVolunteer: "Bli volontär",
        becomeMember: "Bli medlem",
        upcomingEvents: "Kommande evenemang",
        viewAllEvents: "Visa alla evenemang",
        newsletter: "Nyhetsbrev",
        newsletterDesc: "Håll dig informerad om våra nyheter",
        email: "Din e-post",
        subscribe: "Prenumerera"
      },
      events: {
        title: "Våra Evenemang",
        subtitle: "Upptäck våra distansritter och ridturer",
        allEvents: "Alla",
        endurance: "Distans",
        randonnee: "Ritt",
        stage: "Träning",
        concert: "Konsert",
        register: "Anmälan",
        learnMore: "Läs mer",
        organization: "Organisation",
        noEvents: "Inga evenemang för tillfället"
      },
      endurance: {
        title: "Regler & Resultat",
        subtitle: "Officiella FFE, FEI och SHF regler",
        regulations: "Officiella Regler",
        results: "Våra Resultat",
        france: "Frankrike - FFE",
        international: "Internationellt - FEI",
        youngHorses: "Unga Hästar - SHF",
        usefulLinks: "Användbara Länkar",
        download: "Ladda ner"
      },
      organization: {
        title: "Organisation",
        schedule: "Schema",
        participants: "Deltagare",
        route: "Rutt",
        veterinary: "Veterinär",
        practicalInfo: "Praktisk Info",
        program: "Dagsprogram",
        races: "Tävlingar",
        participantsList: "Deltagarlista & Startnummer",
        roadBooks: "Road Books",
        mapsRoutes: "Kartor & Rutter",
        vetCards: "Veterinära uppföljningskort",
        vetInfo: "Veterinär information",
        usefulNumbers: "Användbara nummer",
        emergencyNumbers: "Nödnummer",
        sitePlan: "Platskarta",
        parking: "Parkering",
        toilets: "Toaletter",
        vetZone: "Veterinärzon",
        groomingZone: "Grooming-zon",
        restZone: "Hästvilozon",
        backToEvents: "Tillbaka till evenemang"
      },
      contact: {
        title: "Kontakta oss",
        subtitle: "Har du en fråga? Tveka inte att skriva till oss",
        name: "Ditt namn",
        email: "Din e-post",
        subject: "Ämne",
        message: "Ditt meddelande",
        send: "Skicka",
        sending: "Skickar...",
        success: "Meddelande skickat!",
        error: "Fel vid sändning"
      },
      common: {
        readMore: "Läs mer",
        seeAll: "Visa alla",
        loading: "Laddar...",
        error: "Fel",
        close: "Stäng",
        save: "Spara",
        cancel: "Avbryt",
        delete: "Ta bort",
        edit: "Redigera",
        add: "Lägg till",
        search: "Sök",
        filter: "Filtrera",
        results: "resultat",
        comingSoon: "Kommer snart",
        date: "Datum",
        location: "Plats",
        distance: "Distans",
        level: "Nivå",
        departure: "Start",
        back: "Tillbaka",
        backToHome: "Tillbaka till startsidan",
        backToEvents: "Tillbaka till evenemang",
        backToNews: "Tillbaka till nyheter",
        login: "Logga in",
        logout: "Logga ut",
        logoutSuccess: "Utloggad",
        loginSuccess: "Inloggad",
        loginError: "Inloggningsfel",
        invalidCredentials: "Ogiltiga inloggningsuppgifter.",
        welcome: "Välkommen",
        book: "Boka",
        free: "Gratis",
        send: "Skicka",
        sending: "Skickar...",
        download: "Ladda ner",
        register: "Registrera",
        confirm: "Bekräfta",
        errorOccurred: "Ett fel uppstod",
        tryAgain: "Försök igen",
        errorSending: "Fel vid sändning",
        errorCreating: "Fel vid skapande",
        errorUpdating: "Fel vid uppdatering",
        errorDeleting: "Fel vid borttagning",
        errorUpload: "Uppladdningsfel",
        confirmDelete: "Ta bort detta objekt?",
        confirmDeleteUser: "Ta bort denna användare?",
        addUser: "Lägg till användare",
        sendTestEmail: "Skicka test-e-post",
        sendTestTo: "Skicka test-e-post till:",
        email: "E-post",
        password: "Lösenord",
        adminLogin: "Adminlogin",
        staffArea: "Personalområde",
        manageMedia: "Du kan nu hantera media.",
        regulations: "Reglement & Resultat",
        officialRegulations: "Officiella reglement & Tävlingsresultat",
        ourResults: "Våra Resultat",
        raceResults: "Brious'O Folies tävlingsresultat",
        resultsComingSoon: "Resultat kommer snart",
        savedSuccess: "Sparat",
        savedError: "Fel vid sparande"
      },
      footer: {
        rights: "Alla rättigheter förbehållna",
        legalNotice: "Juridisk information",
        privacy: "Integritetspolicy",
        terms: "Villkor",
        followUs: "Följ oss"
      },
      // Association page
      association: {
        whoAreWe: "Vilka är vi?",
        title: "Föreningen",
        description: "Brious'O Folies arbetar året runt för att främja ridaktiviteter, utomhussporter och kulturella evenemang.",
        heartOfMelusin: "En förening i hjärtat av",
        paysMelusin: "Pays Mélusin",
        presentation1: "är en ideell förening enligt 1901 års lag, skapad för att organisera sport-, rid- och kulturella evenemang på Domaine de la Briouse i Sanxay (86).",
        ourMission: "Vårt uppdrag:",
        missionDesc: "Att främja och organisera rid-, sport-, kultur- och kulturarvsaktiviteter, samtidigt som vi främjar gemenskap, kunskapsöverföring och tillgång till naturen för alla.",
        presentation2: "Ridturer, uthållighetslopp, utomhuskonserter, familjeevenemang... Vi skapar stunder av",
        conviviality: "gemenskap, delning och upptäckt",
        presentation3: ", öppna för ryttare, familjer, lokala invånare och förbipasserande besökare.",
        becomeMember: "Bli Medlem",
        becomeVolunteer: "Bli Volontär",
        becomePartner: "Bli Partner",
        keyFigures: "Nyckeltal 2025",
        eventsOrganized: "Organiserade evenemang",
        inYear: "år 2025",
        artistsPerformers: "Artister & artister",
        ridersWelcomed: "Välkomnade ryttare",
        visitorsOnSite: "Besökare på plats",
        ourTeam: "Vårt Team",
        bureauMembers: "Styrelsemedlemmar",
        bureauDesc: "Ett team av passionerade volontärer med kompletterande färdigheter, drivna av starka värderingar.",
        whatDrivesUs: "Vad som driver oss",
        ourValues: "Våra Kärnvärden",
        benevolence: "Välvilja",
        benevolenceDesc: "Välkomna varje deltagare, volontär eller partner i en atmosfär av respekt, lyhördhet och säkerhet.",
        respect: "Respekt",
        respectDesc: "Säkerställa hästarnas välbefinnande, skydda miljön och respektera kulturarvsplatser och människor.",
        conviviality2: "Gemenskap",
        convivialityDesc: "Skapa varma, generationsöverskridande stunder där familjer, ryttare, invånare, turister och företag möts.",
        environment: "Miljö",
        environmentDesc: "Organisera ansvarsfulla evenemang, med hänsyn till påverkan på naturen och användningen av landsbygdsområden.",
        transmission: "Kunskapsöverföring",
        transmissionDesc: "Dela ridkunnande, kulturarvskunskap och medborgerliga värderingar med ungdomar och allmänheten.",
        accessibility: "Tillgänglighet",
        accessibilityDesc: "Göra sport, kultur och natur tillgängliga för så många som möjligt.",
        ourImpact: "Vår Påverkan",
        ourActions: "Våra Aktioner",
        actionsDesc: "Genom sina aktiviteter bidrar föreningen aktivt till att vitalisera området, utveckla landsbygdsturism och stärka sociala band.",
        contactUs: "Kontakta oss",
        contactQuestion: "För frågor eller informationsförfrågningar",
        writeToUs: "Kontakt",
        joinAdventure: "Bli en del av äventyret!",
        ctaDesc: "Oavsett om du är ryttare, kulturälskare, naturentusiast eller bara nyfiken - det finns en plats för dig hos Brious'O Folies.",
        membershipFor: "Bli medlem för 10€"
      },
      // Partners page
      partners: {
        becomePartner: "Bli Partner",
        supportUs: "Stöd Brious'O Folies",
        heroDesc: "Företag, hantverkare, kommuner: bli en del av äventyret och ge synlighet åt din organisation samtidigt som du stödjer området!",
        downloadDossier: "Ladda ner Sponsordossier",
        contactUs: "Kontakta Oss",
        whyJoinUs: "Varför gå med?",
        partnershipBenefits: "Fördelar med Partnerskap",
        localVisibility: "Lokal Synlighet",
        localVisibilityDesc: "Nå en familjeorienterad, passionerad och engagerad publik i Pays Mélusin-området.",
        positiveImage: "Positivt Image",
        positiveImageDesc: "Associera ditt varumärke med starka värderingar: natur, kulturarv, sport och tillgänglig kultur.",
        network: "Nätverk",
        networkDesc: "Gå med i ett nätverk av företag och kommuner som engagerar sig för området.",
        taxBenefits: "Skattefördelar",
        taxBenefitsDesc: "Dra nytta av skatteavdrag genom mecenat (66% av donationen avdragsgill).",
        ourFormulas: "Våra Formler",
        choosePackage: "Välj Ditt Partnerpaket",
        packagesDesc: "Formler anpassade till alla budgetar, med konkreta och mätbara förmåner.",
        selectPack: "Välj detta paket",
        technicalPartnership: "Tekniskt Partnerskap / Mecenat",
        technicalDesc: "Vill du stödja oss på annat sätt? Utrustning, tjänster, kompetens... Kontakta oss för ett skräddarsytt erbjudande!",
        discussProject: "Låt oss diskutera ditt projekt",
        ourCommitment: "Vårt Åtagande",
        whatWeGuarantee: "Vad vi garanterar dig",
        dedicatedContact: "En dedikerad kontaktperson för varje partner",
        taxOptimization: "Optimerad beskattning (skattekvitto för donationer)",
        customOffers: "Skräddarsydda erbjudanden efter dina behov",
        fullTransparency: "Full transparens om användningen av medel",
        detailedReport: "Detaljerad rapport efter varje evenemang",
        sponsorDossier: "Komplett Sponsordossier",
        dossierDesc: "Hitta all detaljerad information: evenemang, budgetar, förmåner och kontakter.",
        downloadPdf: "Ladda ner PDF",
        questions: "Har du frågor?",
        questionsDesc: "Vårt team står till ditt förfogande för att tillsammans bygga ett skräddarsytt partnerskap.",
        thankPartners: "Tack till våra partners",
        theyTrusted: "De litade på oss",
        thankYouDesc: "Ett stort tack till alla företag, institutioner och kommuner som stödjer Brious'O Folies.",
        institutionsCollectivities: "Institutioner & Kommuner",
        equestrianFederations: "Ridsportförbund",
        partnerCompanies: "Partnerföretag",
        tourismLeisure: "Turism & Fritid",
        readyToJoin: "Redo att gå med?",
        ctaDesc: "Kontakta oss nu för att diskutera ditt partnerskapsprojekt och bli en del av Brious'O Folies-äventyret!",
        partnershipRequest: "Partnerskapsförfrågan",
        selectedPack: "Valt paket",
        thankYouInterest: "Tack för ditt intresse!",
        requestSent: "Din förfrågan har skickats framgångsrikt. Vi kontaktar dig mycket snart för att diskutera ditt partnerskap.",
        fullName: "Fullständigt namn",
        company: "Företag",
        phone: "Telefon",
        sendRequest: "Skicka min förfrågan",
        formConsent: "Genom att skicka in detta formulär godkänner du att bli kontaktad av föreningen Brious'O Folies."
      },
      loginModal: {
        staffArea: "Personalområde",
        memberArea: "Medlemsområde",
        staffDesc: "Administration av Brious'O Folies webbplats",
        memberDesc: "Åtkomst till ditt personliga utrymme",
        createAccount: "Skapa ditt medlemskonto",
        member: "Medlem",
        signIn: "Logga in",
        firstName: "Förnamn",
        lastName: "Efternamn",
        phone: "Telefon",
        createMyAccount: "Skapa mitt konto",
        accountCreated: "Konto skapat! Logga in nu.",
        alreadyAccount: "Redan ett konto? Logga in",
        noAccount: "Inget konto ännu? Registrera dig"
      },
      ip: {
        title: "Praktisk Info", subtitle: "All viktig information för varje evenemang",
        selectEvent: "Välj ett evenemang",
        navAcces: "Tillträde", navParcours: "Banor", navProgramme: "Program", navDocuments: "Dokument",
        navContacts: "Kontakter", navRestau: "Servering", navResultats: "Resultat", navSecurite: "Säkerhet", navConseils: "Tips",
        accesTitle: "Tillträde & Parkering", consignes: "Tillträdesinstruktioner",
        parcoursTitle: "Banor & Rutter",
        programmeTitle: "Program & Tidtabell", programmeComingSoon: "Program kommer snart",
        programmeComingSoonDesc: "Programmet publiceras snart.",
        documentsTitle: "Dokument & Roadbook", documentsOfficiels: "Officiella Dokument",
        uploadDoc: "Ladda upp dokument", uploading: "Laddar upp...",
        noDocsYet: "Inga officiella dokument ännu.",
        contactsTitle: "Kontakter & Viktiga Nummer", emergency: "Nödfall",
        restaurationTitle: "Servering & Förfriskningar", resultatsTitle: "Resultat & Rankningar",
        securiteTitle: "Regler & Säkerhet", readRules: "Läs regler", hideRules: "Dölj regler",
        weather14: "14-dagars väder", seoTitle: "Nyckelord", backToTop: "Tillbaka till toppen",
        download: "Ladda ner", downloadGpx: "Ladda ner GPX", downloadPdf: "Ladda ner program PDF",
        guideTitle: "Förstå uthållighetsridning", guideSubtitle: "Praktisk guide",
        guideIntro: "Denna guide hjälper dig att förstå tävlingskategorierna, distanserna och hastigheterna.",
        guideCategories: "Typer av tävlingar",
        guideTable: "Distans / tid tabell", guideTableSub: "Beräknad tid per distans och hastighet",
        guideCalc: "Hastighetsberäknare",
        calcDepart: "Avgångstid", calcArrivee: "Ankomsttid", calcDistance: "Tillryggalagd distans",
        calcReset: "Återställ", calcTotalTime: "Total tid", calcAvgSpeed: "Medelhastighet",
        calcPlaceholder: "Fyll i dina uppgifter", calcPlaceholderSub: "Resultatet visas automatiskt",
        guideRemember: "Att komma ihåg",
        guideRemember1: "Angivna tider är vägledande riktmärken.",
        guideRemember2: "Det officiella reglementet är referensen.",
        guideRemember3: "Verkliga tider kan variera.",
        guideRemember4: "Lyssna på din häst och prioritera djurens välbefinnande.",
        progDeparts: "Startprogram", progDistance: "Distans", progDepart: "Start",
        progCategories: "Kategorier", progBoucles: "Slingor att följa", progReal: "verklig",
        progReadCourse: "Hur du läser din bana", progReadCourseSub: "Följ färgerna i ordningen",
        progLegend: "Slingförklaring", progOrganisation: "Dagens organisation",
        progPrizes: "Prisutdelning", progImportantInfo: "Viktig information",
        progBriefing: "Briefingen är obligatorisk före varje start.",
        progAdjust: "Tider kan justeras.",
        progVet: "Veterinärkontroll är obligatorisk.",
        progReglement: "Se det officiella reglementet.",
        progWarning: "Ryttare måste följa färgmarkeringarna.",
        elevDistance: "Distans", elevDenivele: "Höjdskillnad", elevAltMin: "Höjd Min", elevAltMax: "Höjd Max",
        elevTerrain: "Stigar och lokala vägar", elevWater: "Vattenpunkter längs banan",
        courses10to80: "Lopp 10 till 80 km", courses100and120: "Lopp 100 och 120 km",
        guideDistLabel: "Distanser", guideNivLabel: "Nivåer", guideSpeedLabel: "Hastigheter",
        calcExample: "Exempel", progBouclesLabel: "Slingor",
        catAmateurDesc: "Tävlingar för ryttare med FFE-licens. Amatördistansritt erbjuder en anpassad tävlingsram.",
        catClubDesc: "Utbildningstävlingar för klubbryttare. Perfekt för nybörjare.",
        catPrepaDesc: "Träningstävlingar under verkliga förhållanden. Perfekt förberedelse.",
        catVIDesc: "Ryttaren måste hålla en av juryn bestämd hastighet. Regelbundenhet är avgörande.",
        catVRDesc: "Ryttaren måste respektera en målhastighet inom en tolerans.",
        catSHFDesc: "Program för unga hästar under Société Hippique Française. Progressiv utbildning.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Höjd",
        secCavaliers: "Ryttarsäkerhet", secChevaux: "Hästens välbefinnande", secEnvironnement: "Miljö",
        conseilsTitle: "Praktisk Info & Tips", conseilsSub: "Checklista, rekommendationer och väder",
        conseilsRecos: "Tips & Rekommendationer", checklistTitle: "Ryttarchecklista",
        logistiqueTitle: "Logistiktips", viewAccommodation: "Visa boenden",
        weatherTitle: "Väder Sanxay — 14-dagarsprognos",
        weatherForecast: "Se 14-dagarsprognos på Météo France",
        weatherLoading: "Laddar prognos...", weatherUnavailable: "Prognos tillfälligt otillgänglig",
        weatherLink: "Se Météo France — Sanxay",
        shareBtn: "DELA", shareTitle: "Dela denna sida", shareMessage: "Kolla praktisk info för {{event}} av Brious'O Folies",
        shareCopyLink: "Kopiera länk", shareCopied: "Länk kopierad!"
      },
      homeExt: {
        heroTitle1: "Upplev evenemangen hos",
        heroTitle2: "i Sanxay",
        heroSubtitle: "Hästsportaktiviteter, utomhussporter och kulturella evenemang i hjärtat av",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Se evenemang",
        becomeMember: "Bli medlem",
        becomeVolunteer: "Bli volontär",
        receiveNews: "Få nyheter",
        eventsPerYear: "Evenemang/år",
        visitorsWelcomed: "Välkomnade besökare",
        volunteersActive: "Mobiliserade volontärer",
        landArea: "Mark",
        dontMiss: "Missa inget!",
        upcomingEvents: "Kommande Evenemang",
        upcomingEventsDesc: "Konserter, ridturer, uthållighetslopp, country-kvällar... Upptäck vårt program och boka din plats!",
        reserve: "Boka",
        free: "GRATIS",
        seeAllEvents: "Se alla evenemang",
        allYear: "Hela året",
        seasonTitle: "Brious'O Folies Säsong",
        seasonDesc: "Evenemang hela året i årstidernas rytm",
        spring: "Vår",
        summer: "Sommar",
        autumn: "Höst",
        winter: "Vinter",
        springEvents: ["Ridlektioner", "Naturvandringar", "Påskäggsjakt", "Country-kvällar"],
        summerEvents: ["Körkonserter", "Departementalt uthållighetsmästerskap", "Loppmarknader"],
        autumnEvents: ["Halloween-ritt", "Film-eftermiddag", "Uthållighetslopp"],
        winterEvents: ["Film-eftermiddag", "Intima konserter", "Workshops", "Spel"],
        joinCommunity: "Gå med i Brious'O Folies gemenskap",
        newsletterDesc: "Få nyheter om våra evenemang, konserter, naturaktiviteter och uthållighetslopp.",
        iWantInfo: "Jag vill få information om:",
        nlEndurance: "Uthållighetsridning",
        nlConcerts: "Konserter och shower",
        nlNature: "Naturaktiviteter och vandringar",
        nlFamily: "Familjeevenemang",
        nlPedagogy: "Pedagogiska aktiviteter",
        nlVolunteer: "Bli volontär",
        emailPlaceholder: "Din e-postadress",
        joinCommunityBtn: "Jag går med i gemenskapen",
        thankYou: "Tack!",
        subscribedMsg: "Du är nu prenumerant på vårt nyhetsbrev.",
        welcomeMsg: "Välkommen till gemenskapen!",
        welcomeDesc: "Du kommer snart att få våra nyheter.",
        prefsUpdated: "Inställningar uppdaterade!",
        prefsUpdatedDesc: "Dina intressen har uppdaterats.",
        joinTeam: "Gå med i teamet",
        becomeVolunteerTitle: "Bli volontär hos Brious'O Folies",
        volunteerDesc: "Vill du hjälpa till att organisera sport- och kulturevenemang? Gå med i vårt volontärteam för oförglömliga gemensamma stunder!",
        volunteerBenefit1: "Upplev evenemang inifrån",
        volunteerBenefit2: "Skapa fantastiska kontakter",
        volunteerBenefit3: "Ingen erfarenhet krävs",
        volunteerBtn: "Bli volontär",
        volunteersTrustUs: "Volontärer litar på oss",
        heritageNature: "Kulturarv & Natur",
        discoverSanxay: "Upptäck Sanxay och dess region",
        discoverDesc: "Domaine de la Briouse är idealiskt beläget för att utforska Pays Mélusins skatter",
        discoverRegion: "Upptäck regionen",
        ourCommitment: "Vårt Engagemang",
        valuesTitle: "Värderingar som förenar oss",
        benevolence: "Välvilja",
        benevolenceDesc: "Varmt välkomnande för alla",
        conviviality: "Samvaro",
        convivialityDesc: "Stunder av utbyte och möte",
        respect: "Respekt",
        respectDesc: "För naturen och hästarna",
        culture: "Kultur",
        cultureDesc: "Tillgängliga konstnärliga evenemang",
        ourPlace: "Vår Plats",
        domainTitle: "Domaine de la Briouse",
        domainDesc: "Beläget i hjärtat av Pays Mélusin erbjuder Domaine de la Briouse en exceptionell natur- och kulturmiljö. Nära den berömda gallo-romerska platsen i Sanxay är det den perfekta platsen för evenemang som kombinerar sport, kultur och natur.",
        howToCome: "Vägbeskrivning",
        joinAdventure: "Gå med i Brious'O Folies äventyret",
        ctaDesc: "Bli medlem och delta i föreningslivet. Tillsammans håller vi Pays Mélusins arv och samvaro levande.",
        memberFor10: "Bli medlem för 10€",
        contactUsBtn: "Kontakta oss",
        call: "Ring",
        galloRomanSite: "Gallo-Romersk plats i Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      eventsExt: {
        calendar: "Kalender",
        calendar2026: "Kalender 2026",
        title: "Våra Evenemang",
        subtitle: "Ridturer, konserter, uthållighetslopp och familjeevenemang... Upptäck alla våra aktiviteter på Domaine de la Briouse.",
        downloadLivret: "Ladda ner PDF-broschyren",
        featured: "Aktuellt",
        grandeTombola: "Stor Tombola",
        winBalloon: "Vinn en Ballongtur!",
        tombolaDesc: "Delta i vår stora tombola och vinn en ballongtur för 2 personer som lyfter direkt från Domaine de la Briouse!",
        ticket: "per lott",
        drawAt: "Dragning kl 18",
        participateTombola: "Delta i Tombolan",
        learnMore: "Mer information",
        filterByCategory: "Filtrera efter kategori",
        allCategories: "Alla kategorier",
        resetFilters: "Återställ filter",
        becomeMember: "Bli Medlem",
        memberDesc: "Stöd vår förening och njut av exklusiva förmåner.",
        memberFor10: "Bli medlem för 10€",
        noEventsFound: "Inga evenemang hittades för dessa kriterier.",
        seeAllEvents: "Se alla evenemang",
        reserve: "Boka",
        freeEntry: "Fri entré",
        orga: "Org",
        equitation: "Ridning",
        concert: "Konsert",
        randonnee: "Ridtur",
        course: "Lopp",
        brocante: "Loppmarknad",
        cinema: "Bio"
      },
      contactExt: {
        contactUs: "Kontakta oss",
        title: "Kontakt",
        subtitle: "En fråga, ett förslag, vill du gå med? Tveka inte att kontakta oss.",
        contactInfo: "Kontaktinformation",
        phone: "Telefon",
        address: "Adress",
        onlineMembership: "Online Medlemskap",
        joinViaHelloAsso: "Gå med i vår förening via HelloAsso.",
        memberFor10: "Bli medlem för 10€",
        sendMessage: "Skicka oss ett meddelande",
        fullName: "Fullständigt namn *",
        email: "E-post *",
        subject: "Ämne *",
        subjectPlaceholder: "Angående...",
        message: "Meddelande *",
        messagePlaceholder: "Ditt meddelande...",
        newsletterCheckbox: "Jag vill prenumerera på nyhetsbrevet för att få nyheter från Brious'O Folies",
        sendBtn: "Skicka meddelande",
        successMsg: "Meddelande skickat!",
        successDescNewsletter: "Du är också prenumerant på nyhetsbrevet.",
        successDesc: "Vi svarar så snart som möjligt.",
        errorMsg: "Fel vid sändning",
        errorDesc: "Försök igen senare.",
        findUs: "Hitta oss"
      },
      benevoles: {
        joinAdventure: "Gå med i äventyret",
        title: "Bli Volontär",
        heroDesc: "Evenemangen vi organiserar skulle inte vara möjliga utan engagemanget och generositeten hos dem som ger lite av sin tid.",
        signUp: "Jag anmäler mig som volontär",
        thanks: "Tack!",
        callTitle: "Brious'O Folies gör en vädjan!",
        callP1: "Idag gör <strong>Brious'O Folies</strong> en vädjan till alla invånare som vill bli volontärer och delta i det lokala livet.",
        callP2: "<strong>Sportevenemang, konserter, shower, vandringar, familjeaktiviteter eller festliga sammankomster</strong>: våra projekt är varierade och alla kan hitta sin plats.",
        callP3: "Publikmottagning, organisationshjälp, logistik, uppsättning, kommunikation, ledsagning av deltagare eller en enkel hjälpande hand... <strong>det finns tusen sätt att engagera sig</strong>, efter dina önskemål, kompetenser och tillgänglighet.",
        chooseEvent: "Välj ditt evenemang",
        eventsCalendar: "Evenemangskalender",
        clickToSign: "Klicka på ett evenemang för att anmäla dig som volontär",
        selectedEvent: "Valt Evenemang",
        monthEvents: "Månadens evenemang",
        volunteerForEvent: "Bli volontär för detta evenemang",
        seeAllEvents: "Se alla evenemang",
        noEventThisMonth: "Inga evenemang denna månad.",
        navigateCalendar: "Navigera i kalendern!",
        findYourPlace: "Hitta din plats",
        missionTypes: "Typer av Uppdrag",
        missionDesc: "Det finns många sätt att bidra efter dina önskemål och kompetenser.",
        publicWelcome: "Publikmottagning",
        publicWelcomeDesc: "Orientera och informera besökare under våra evenemang",
        logistics: "Logistik & Uppsättning",
        logisticsDesc: "Sätta upp stånd, skyltar och anläggningar",
        animation: "Underhållning",
        animationDesc: "Assistera deltagare under shower och konserter",
        helpOut: "Tillfällig Hjälp",
        helpOutDesc: "Diverse hjälp efter tillgänglighet och önskemål",
        whyJoin: "Varför gå med?",
        beingVolunteer: "Att vara volontär är...",
        beingVolunteerDesc: "Uppleva evenemang inifrån, dela starka stunder, skapa fantastiska kontakter och bidra till meningsfulla projekt för vårt område.",
        benefit1: "Uppleva evenemang inifrån",
        benefit2: "Skapa fantastiska kontakter",
        benefit3: "Bidra till meningsfulla projekt",
        benefit4: "Vänlig och omtänksam atmosfär",
        benefit5: "Ingen erfarenhet krävs",
        benefit6: "Engagemang efter tillgänglighet",
        essentialDesire: "Det viktigaste är viljan!",
        essentialP1: "Ingen särskild erfarenhet behövs: det viktigaste är viljan att delta, dela och vara del av ett gemensamt äventyr.",
        essentialP2: "Att gå med i Brious'O Folies volontärteam innebär att engagera sig i en",
        essentialP2Bold: "vänlig och omtänksam atmosfär",
        essentialP2End: ", i tjänst av utbyte, kultur, sport och natur.",
        ifAdventureTempts: "Om äventyret lockar dig...",
        ctaDesc: "Kom och träffa oss på våra evenemang eller anmäl dig direkt: vi välkomnar dig gärna och skriver nästa kapitel av denna vackra historia tillsammans!",
        becomeVolunteer: "Jag blir volontär",
        contactUs: "Kontakta oss",
        followSocial: "Följ oss på sociala medier!",
        dayNames: ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"]
      },
      footerExt: {
        visitorsSay: "Vad våra besökare säger",
        review1: "Fantastisk stämning, toppteam!",
        review2: "Kvalitetsevenemang, vi kommer tillbaka!",
        review3: "Underbar miljö, välskötta hästar",
        navigation: "Navigation",
        home: "Hem",
        events: "Evenemang",
        association: "Föreningen",
        gettingHere: "Vägbeskrivning",
        news: "Nyheter",
        volunteers: "Volontärer",
        partners: "Partners",
        contactLabel: "Kontakt",
        contactTitle: "Kontakt",
        contactUsLink: "Kontakta oss",
        ourValues: "Våra Värderingar",
        value1: "Överföring & Delning",
        value2: "Ansvarsfull Sport",
        value3: "Tillgänglig Kultur",
        value4: "Respekt för Naturen",
        value5: "Samvaro",
        value6: "Välvilja",
        becomeMember: "Bli Medlem",
        allRights: "Alla rättigheter förbehållna",
        legalNotice: "Juridisk Information",
        cgv: "Villkor",
        privacy: "Integritet",
        description: "Ideell förening för att främja hästsportaktiviteter, utomhussporter och kulturella evenemang på Domaine de la Briouse."
      },
      venir: {
        title: "Vägbeskrivning",
        subtitle: "Domaine de la Briouse",
        heroDesc: "All praktisk information för att besöka oss i hjärtat av Pays Mélusin.",
        howToCome: "Vägbeskrivning",
        accommodation: "Boende",
        restaurants: "Restauranger",
        discover: "Upptäck",
        byCar: "Med bil",
        byTrain: "Med tåg",
        byPlane: "Med flyg",
        gps: "GPS-koordinater",
        distance: "Avstånd",
        all: "Alla",
        onSite: "På plats",
        nearby: "I närheten",
        book: "Boka",
        visitWebsite: "Besök webbplats",
        seeOnMap: "Se på kartan",
        discoverRegion: "Upptäck Regionen",
        discoverDesc: "Domaine de la Briouse är idealiskt beläget i hjärtat av Pays Mélusin, omgivet av anmärkningsvärda platser.",
        filterByDistance: "Filtrera efter avstånd",
        heritageNature: "Kulturarv & Natur",
        leisure: "Fritid & Kultur",
        beaches: "Stränder & Kust",
        contactTitle: "Behöver du information?",
        contactDesc: "Vårt team finns tillgängligt för att hjälpa dig planera din vistelse.",
        contactBtn: "Kontakta oss",
        callUs: "Ring oss",
        name: "Namn *",
        email: "E-post *",
        messageLabel: "Meddelande *",
        sendBtn: "Skicka",
        msgSent: "Meddelande skickat!",
        msgSentDesc: "Vi svarar snart.",
        msgError: "Fel vid sändning",
        msgErrorDesc: "Försök igen.",
        chambreHotes: "B&B & Stugor",
        camping: "Camping",
        hotel: "Hotell",
        gite: "Semesterhus",
        traditional: "Traditionellt kök",
        gastro: "Finare matlagning",
        pizzeria: "Pizzeria",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Prisklass"
      },
      adhesion: {
        title: "Medlemskap",
        subtitle: "Bli Medlem",
        heroDesc: "Gå med i föreningen Brious'O Folies och delta i livet på Domaine de la Briouse.",
        why: "Varför gå med?",
        benefit1: "Stöd våra evenemang",
        benefit1Desc: "Ditt medlemskap finansierar direkt våra konserter, ridturer och aktiviteter.",
        benefit2: "Prioriterad åtkomst",
        benefit2Desc: "Reducerade priser och prioriterad åtkomst till vissa evenemang.",
        benefit3: "Gemenskap",
        benefit3Desc: "Gå med i en passionerad gemenskap i Pays Mélusin.",
        joinNow: "Gå med nu",
        memberFor10: "Årligt medlemskap: 10€",
        helloAssoInfo: "Medlemskapet sker via HelloAsso, vår säkra betalningspartner.",
        questions: "Frågor?",
        contactUs: "Kontakta oss"
      },
      actualites: {
        title: "Nyheter",
        subtitle: "Våra Nyheter",
        heroDesc: "Följ de senaste nyheterna från Brious'O Folies och Domaine de la Briouse.",
        noNews: "Inga nyheter för tillfället.",
        stayTuned: "Håll dig uppkopplad!",
        followUs: "Följ oss på sociala medier för att inte missa något.",
        readMore: "Läs mer",
        published: "Publicerad den",
        categories: "Kategorier",
        all: "Alla",
        mediaDeleted: "Media raderad"
      },
      tombola: {
        title: "Stor Tombola",
        subtitle: "Brious'O Folies Tombola",
        heroDesc: "Delta i vår stora tombola och vinn en ballongtur!",
        winBalloon: "Vinn en Ballongtur!",
        description: "Delta i vår stora tombola och vinn en ballongtur för 2 personer som lyfter direkt från Domaine de la Briouse!",
        ticketPrice: "per lott",
        drawDate: "Dragning 8 nov. 2026",
        drawTime: "Dragning kl 18",
        participate: "Delta i Tombolan",
        howItWorks: "Hur fungerar det?",
        step1: "Köp din lott",
        step1Desc: "Lotter tillgängliga online via HelloAsso eller på plats under våra evenemang.",
        step2: "Vänta på dragningen",
        step2Desc: "Dragningen sker den 8 november 2026 kl 18 på Domaine de la Briouse.",
        step3: "Lyft!",
        step3Desc: "Vinnaren får njuta av en ballongtur för 2 personer.",
        rules: "Regler",
        rulesDesc: "Tombola organiserad i enlighet med gällande regler."
      },
      legal: {
        title: "Juridisk Information",
        legalNotice: "Juridisk Information",
        cgv: "Villkor",
        privacy: "Integritetspolicy",
        editor: "Webbplatsutgivare",
        hosting: "Hosting",
        intellectual: "Immateriella rättigheter",
        intellectualDesc: "Allt innehåll på denna webbplats (texter, bilder, videor) skyddas av upphovsrätten.",
        dataProtection: "Dataskydd",
        dataProtectionDesc: "I enlighet med GDPR har du rätt att få tillgång till, ändra och radera dina personuppgifter.",
        cookies: "Cookies",
        cookiesDesc: "Denna webbplats använder cookies för att förbättra din surfupplevelse.",
        contact: "Kontakt"
      }
    }
  },
  ro: {
    translation: {
      nav: {
        home: "Acasă",
        events: "Evenimente",
        news: "Știri",
        association: "Asociația",
        partners: "Parteneri",
        gettingHere: "Cum ajungi",
        contact: "Contact",
        volunteer: "Voluntari",
        membership: "Membru"
      },
      home: {
        welcome: "Bine ați venit la Brious'O Folies",
        subtitle: "Asociație ecvestră în inima Nouvelle-Aquitaine",
        discoverEvents: "Descoperă evenimentele noastre",
        joinUs: "Alătură-te nouă",
        becomeVolunteer: "Devino voluntar",
        becomeMember: "Devino membru",
        upcomingEvents: "Evenimente viitoare",
        viewAllEvents: "Vezi toate evenimentele",
        newsletter: "Newsletter",
        newsletterDesc: "Rămâi informat despre noutățile noastre",
        email: "Emailul tău",
        subscribe: "Abonează-te"
      },
      events: {
        title: "Evenimentele Noastre",
        subtitle: "Descoperă cursele noastre de anduranță și trasee ecvestre",
        allEvents: "Toate",
        endurance: "Anduranță",
        randonnee: "Traseu",
        stage: "Antrenament",
        concert: "Concert",
        register: "Înscrie-te",
        learnMore: "Mai multe informații",
        organization: "Organizare",
        noEvents: "Niciun eveniment momentan"
      },
      endurance: {
        title: "Regulamente & Rezultate",
        subtitle: "Regulamente oficiale FFE, FEI și SHF",
        regulations: "Regulamente Oficiale",
        results: "Rezultatele Noastre",
        france: "Franța - FFE",
        international: "Internațional - FEI",
        youngHorses: "Cai Tineri - SHF",
        usefulLinks: "Linkuri Utile",
        download: "Descarcă"
      },
      organization: {
        title: "Organizare",
        schedule: "Program",
        participants: "Participanți",
        route: "Traseu",
        veterinary: "Veterinar",
        practicalInfo: "Info Practice",
        program: "Programul zilei",
        races: "Probe",
        participantsList: "Lista participanților și numere de start",
        roadBooks: "Road Books",
        mapsRoutes: "Hărți și trasee",
        vetCards: "Fișe de monitorizare veterinară",
        vetInfo: "Informații veterinare",
        usefulNumbers: "Numere utile",
        emergencyNumbers: "Numere de urgență",
        sitePlan: "Planul locației",
        parking: "Parcare",
        toilets: "Toalete",
        vetZone: "Zonă veterinară",
        groomingZone: "Zonă grooming",
        restZone: "Zonă odihnă cai",
        backToEvents: "Înapoi la evenimente"
      },
      contact: {
        title: "Contactează-ne",
        subtitle: "Ai o întrebare? Nu ezita să ne scrii",
        name: "Numele tău",
        email: "Emailul tău",
        subject: "Subiect",
        message: "Mesajul tău",
        send: "Trimite",
        sending: "Se trimite...",
        success: "Mesaj trimis cu succes!",
        error: "Eroare la trimitere"
      },
      common: {
        readMore: "Citește mai mult",
        seeAll: "Vezi tot",
        loading: "Se încarcă...",
        error: "Eroare",
        close: "Închide",
        save: "Salvează",
        cancel: "Anulează",
        delete: "Șterge",
        edit: "Editează",
        add: "Adaugă",
        search: "Caută",
        filter: "Filtrează",
        results: "rezultate",
        comingSoon: "În curând",
        date: "Dată",
        location: "Locație",
        distance: "Distanță",
        level: "Nivel",
        departure: "Start",
        back: "Înapoi",
        backToHome: "Înapoi acasă",
        backToEvents: "Înapoi la evenimente",
        backToNews: "Înapoi la știri",
        login: "Autentificare",
        logout: "Deconectare",
        logoutSuccess: "Deconectat cu succes",
        loginSuccess: "Autentificat cu succes",
        loginError: "Eroare de autentificare",
        invalidCredentials: "Credențiale invalide.",
        welcome: "Bun venit",
        book: "Rezervă",
        free: "Gratuit",
        send: "Trimite",
        sending: "Se trimite...",
        download: "Descarcă",
        register: "Înregistrare",
        confirm: "Confirmă",
        errorOccurred: "A apărut o eroare",
        tryAgain: "Vă rugăm să încercați din nou",
        errorSending: "Eroare la trimitere",
        errorCreating: "Eroare la creare",
        errorUpdating: "Eroare la actualizare",
        errorDeleting: "Eroare la ștergere",
        errorUpload: "Eroare la încărcare",
        confirmDelete: "Ștergeți acest element?",
        confirmDeleteUser: "Ștergeți acest utilizator?",
        addUser: "Adaugă Utilizator",
        sendTestEmail: "Trimite email de test",
        sendTestTo: "Trimite email de test la:",
        email: "Email",
        password: "Parolă",
        adminLogin: "Autentificare Admin",
        staffArea: "Zona Staff",
        manageMedia: "Acum puteți gestiona media.",
        regulations: "Regulamente & Rezultate",
        officialRegulations: "Regulamente oficiale & Rezultate curse",
        ourResults: "Rezultatele Noastre",
        raceResults: "Rezultate curse Brious'O Folies",
        resultsComingSoon: "Rezultate în curând",
        savedSuccess: "Salvat cu succes",
        savedError: "Eroare la salvare"
      },
      footer: {
        rights: "Toate drepturile rezervate",
        legalNotice: "Mențiuni legale",
        privacy: "Politica de confidențialitate",
        terms: "Termeni și condiții",
        followUs: "Urmărește-ne"
      },
      // Association page
      association: {
        whoAreWe: "Cine suntem?",
        title: "Asociația",
        description: "Brious'O Folies lucrează tot anul pentru a promova activitățile ecvestre, sporturile în aer liber și evenimentele culturale.",
        heartOfMelusin: "O asociație în inima",
        paysMelusin: "Pays Mélusin",
        presentation1: "este o asociație non-profit conform legii din 1901, creată pentru a organiza evenimente sportive, ecvestre și culturale la Domaine de la Briouse, în Sanxay (86).",
        ourMission: "Misiunea noastră:",
        missionDesc: "Promovarea și organizarea activităților ecvestre, sportive, culturale și de patrimoniu, încurajând în același timp convivialitatea, transmisia și accesul la natură pentru toți.",
        presentation2: "Plimbări călare, curse de anduranță, concerte în aer liber, evenimente de familie... Creăm momente de",
        conviviality: "convivialitate, împărtășire și descoperire",
        presentation3: ", deschise călăreților, familiilor, rezidenților locali și vizitatorilor în trecere.",
        becomeMember: "Devino Membru",
        becomeVolunteer: "Devino Voluntar",
        becomePartner: "Devino Partener",
        keyFigures: "Cifre Cheie 2025",
        eventsOrganized: "Evenimente organizate",
        inYear: "în 2025",
        artistsPerformers: "Artiști și interpreți",
        ridersWelcomed: "Călăreți primiți",
        visitorsOnSite: "Vizitatori pe loc",
        ourTeam: "Echipa Noastră",
        bureauMembers: "Membrii Consiliului",
        bureauDesc: "O echipă de voluntari pasionați cu competențe complementare, motivați de valori puternice.",
        whatDrivesUs: "Ce ne motivează",
        ourValues: "Valorile Noastre Fundamentale",
        benevolence: "Bunăvoință",
        benevolenceDesc: "Primirea fiecărui participant, voluntar sau partener într-un climat de respect, ascultare și siguranță.",
        respect: "Respect",
        respectDesc: "Asigurarea bunăstării cailor, protecția mediului și respectul pentru situri de patrimoniu și oameni.",
        conviviality2: "Convivialitate",
        convivialityDesc: "Crearea de momente calde, intergeneraționale, unde familiile, călăreții, rezidenții, turiștii și întreprinderile se întâlnesc.",
        environment: "Mediu",
        environmentDesc: "Organizarea de evenimente responsabile, atente la impactul asupra naturii și la utilizarea spațiilor rurale.",
        transmission: "Transmitere",
        transmissionDesc: "Împărtășirea cunoștințelor ecvestre, a cunoștințelor de patrimoniu și a valorilor civice cu tinerii și publicul larg.",
        accessibility: "Accesibilitate",
        accessibilityDesc: "Făcând sportul, cultura și natura accesibile pentru cât mai mulți oameni posibil.",
        ourImpact: "Impactul Nostru",
        ourActions: "Acțiunile Noastre",
        actionsDesc: "Prin acțiunile sale, asociația participă activ la revitalizarea teritoriului, dezvoltarea turismului rural și consolidarea legăturilor sociale.",
        contactUs: "Contactează-ne",
        contactQuestion: "Pentru orice întrebare sau cerere de informații",
        writeToUs: "Contact",
        joinAdventure: "Alătură-te aventurii!",
        ctaDesc: "Fie că ești călăreț, iubitor de cultură, pasionat de natură sau pur și simplu curios, există un loc pentru tine la Brious'O Folies.",
        membershipFor: "Alătură-te pentru 10€"
      },
      // Partners page
      partners: {
        becomePartner: "Devino Partener",
        supportUs: "Susține Brious'O Folies",
        heroDesc: "Companii, meșteșugari, autorități locale: alătură-te aventurii și oferă vizibilitate organizației tale susținând în același timp teritoriul!",
        downloadDossier: "Descarcă Dosarul de Sponsorizare",
        contactUs: "Contactează-ne",
        whyJoinUs: "De ce să te alături?",
        partnershipBenefits: "Beneficiile Parteneriatului",
        localVisibility: "Vizibilitate Locală",
        localVisibilityDesc: "Ajunge la un public orientat spre familie, pasionat și angajat în teritoriul Pays Mélusin.",
        positiveImage: "Imagine Pozitivă",
        positiveImageDesc: "Asociază-ți marca cu valori puternice: natură, patrimoniu, sport și cultură accesibilă.",
        network: "Rețea",
        networkDesc: "Alătură-te unei rețele de companii și autorități locale angajate pentru teritoriu.",
        taxBenefits: "Beneficii Fiscale",
        taxBenefitsDesc: "Beneficiază de reduceri fiscale prin mecenat (66% din donație deductibil).",
        ourFormulas: "Formulele Noastre",
        choosePackage: "Alege-ți Pachetul de Partener",
        packagesDesc: "Formule adaptate la toate bugetele, cu avantaje concrete și măsurabile.",
        selectPack: "Alege acest pachet",
        technicalPartnership: "Parteneriat Tehnic / Mecenat",
        technicalDesc: "Vrei să ne susții altfel? Echipamente, servicii, competențe... Contactează-ne pentru o ofertă personalizată!",
        discussProject: "Să discutăm despre proiectul tău",
        ourCommitment: "Angajamentul Nostru",
        whatWeGuarantee: "Ce îți garantăm",
        dedicatedContact: "O persoană de contact dedicată pentru fiecare partener",
        taxOptimization: "Fiscalitate optimizată (chitanță fiscală pentru donații)",
        customOffers: "Oferte personalizate în funcție de nevoile tale",
        fullTransparency: "Transparență totală asupra utilizării fondurilor",
        detailedReport: "Raport detaliat după fiecare eveniment",
        sponsorDossier: "Dosar Complet de Sponsorizare",
        dossierDesc: "Găsește toate informațiile detaliate: evenimente, bugete, avantaje și contacte.",
        downloadPdf: "Descarcă PDF",
        questions: "Ai întrebări?",
        questionsDesc: "Echipa noastră este la dispoziția ta pentru a construi împreună un parteneriat personalizat.",
        thankPartners: "Mulțumim partenerilor noștri",
        theyTrusted: "Ei au avut încredere în noi",
        thankYouDesc: "Un mare mulțumesc tuturor companiilor, instituțiilor și autorităților locale care susțin Brious'O Folies.",
        institutionsCollectivities: "Instituții & Autorități Locale",
        equestrianFederations: "Federații Ecvestre",
        partnerCompanies: "Companii Partenere",
        tourismLeisure: "Turism & Agrement",
        readyToJoin: "Gata să te alături?",
        ctaDesc: "Contactează-ne acum pentru a discuta proiectul tău de parteneriat și a te alătura aventurii Brious'O Folies!",
        partnershipRequest: "Cerere de parteneriat",
        selectedPack: "Pachet selectat",
        thankYouInterest: "Mulțumim pentru interesul tău!",
        requestSent: "Cererea ta a fost trimisă cu succes. Te vom contacta foarte curând pentru a discuta parteneriatul tău.",
        fullName: "Nume complet",
        company: "Companie",
        phone: "Telefon",
        sendRequest: "Trimite cererea mea",
        formConsent: "Prin trimiterea acestui formular, accepți să fii contactat de asociația Brious'O Folies."
      },
      loginModal: {
        staffArea: "Zona Staff",
        memberArea: "Zona Membrilor",
        staffDesc: "Administrarea site-ului Brious'O Folies",
        memberDesc: "Accesați spațiul dvs. personal",
        createAccount: "Creați-vă contul de membru",
        member: "Membru",
        signIn: "Autentificare",
        firstName: "Prenume",
        lastName: "Nume",
        phone: "Telefon",
        createMyAccount: "Creează contul meu",
        accountCreated: "Cont creat! Autentificați-vă acum.",
        alreadyAccount: "Aveți deja un cont? Autentificare",
        noAccount: "Nu aveți cont? Înregistrare"
      },
      ip: {
        title: "Informații Practice", subtitle: "Toate informațiile esențiale pentru fiecare eveniment",
        selectEvent: "Selectați un eveniment",
        navAcces: "Acces", navParcours: "Trasee", navProgramme: "Program", navDocuments: "Documente",
        navContacts: "Contacte", navRestau: "Catering", navResultats: "Rezultate", navSecurite: "Securitate", navConseils: "Sfaturi",
        accesTitle: "Acces & Parcare", consignes: "Instrucțiuni de acces",
        parcoursTitle: "Trasee & Rute",
        programmeTitle: "Program & Orar", programmeComingSoon: "Program în curând",
        programmeComingSoonDesc: "Programul va fi publicat în curând.",
        documentsTitle: "Documente & Roadbook", documentsOfficiels: "Documente Oficiale",
        uploadDoc: "Încarcă un document", uploading: "Se încarcă...",
        noDocsYet: "Niciun document oficial încă.",
        contactsTitle: "Contacte & Numere Utile", emergency: "Urgență",
        restaurationTitle: "Catering & Băuturi", resultatsTitle: "Rezultate & Clasamente",
        securiteTitle: "Reguli & Securitate", readRules: "Citește regulamentul", hideRules: "Ascunde regulamentul",
        weather14: "Meteo pe 14 zile", seoTitle: "Cuvinte cheie", backToTop: "Înapoi sus",
        download: "Descarcă", downloadGpx: "Descarcă GPX", downloadPdf: "Descarcă programul PDF",
        guideTitle: "Înțelegerea anduranței ecvestre", guideSubtitle: "Ghid practic",
        guideIntro: "Acest ghid vă ajută să înțelegeți categoriile de probe, distanțele și vitezele.",
        guideCategories: "Tipuri de probe",
        guideTable: "Tabel distanță / timp", guideTableSub: "Timp estimat pe traseu după distanță și viteză",
        guideCalc: "Calculator de viteză",
        calcDepart: "Ora de plecare", calcArrivee: "Ora de sosire", calcDistance: "Distanța parcursă",
        calcReset: "Resetare", calcTotalTime: "Timp total", calcAvgSpeed: "Viteză medie",
        calcPlaceholder: "Introduceți datele", calcPlaceholderSub: "Rezultatul va apărea automat",
        guideRemember: "De reținut",
        guideRemember1: "Timpii sunt repere orientative.",
        guideRemember2: "Regulamentul oficial rămâne referința.",
        guideRemember3: "Timpii reali pot varia.",
        guideRemember4: "Ascultați-vă calul și prioritizați bunăstarea animalelor.",
        progDeparts: "Program plecări", progDistance: "Distanță", progDepart: "Start",
        progCategories: "Categorii", progBoucles: "Bucle de urmărit", progReal: "reale",
        progReadCourse: "Cum să citiți traseul", progReadCourseSub: "Urmați culorile în ordine",
        progLegend: "Legenda buclelor", progOrganisation: "Organizarea zilei",
        progPrizes: "Ceremonia de premiere", progImportantInfo: "Informații importante",
        progBriefing: "Briefingul oficial este obligatoriu.",
        progAdjust: "Orarul poate fi ajustat.",
        progVet: "Controlul veterinar este obligatoriu.",
        progReglement: "Consultați regulamentul oficial.",
        progWarning: "Călăreții trebuie să respecte marcajele de culoare.",
        elevDistance: "Distanță", elevDenivele: "Diferență de nivel", elevAltMin: "Alt. Min", elevAltMax: "Alt. Max",
        elevTerrain: "Drumuri, poteci și drumuri locale", elevWater: "Puncte de apă pe traseu",
        courses10to80: "Curse 10 la 80 km", courses100and120: "Curse 100 și 120 km",
        guideDistLabel: "Distanțe", guideNivLabel: "Niveluri", guideSpeedLabel: "Viteze",
        calcExample: "Exemplu", progBouclesLabel: "Bucle",
        catAmateurDesc: "Probe deschise călăreților cu licență FFE. Anduranța amator oferă un cadru competitiv adaptat.",
        catClubDesc: "Probe de descoperire și formare pentru călăreții de club. Ideale pentru a debuta în competiție.",
        catPrepaDesc: "Probe de antrenament în condiții reale. Perfecte pentru pregătire.",
        catVIDesc: "Călărețul trebuie să mențină o viteză precisă impusă de juriu. Regularitatea este esențială.",
        catVRDesc: "Călărețul trebuie să respecte o viteză țintă cu o toleranță definită.",
        catSHFDesc: "Program dedicat cailor tineri sub Société Hippique Française. Formare sportivă progresivă.",
        elevDistTooltip: "Dist.", elevAltTooltip: "Alt.",
        secCavaliers: "Siguranța călăreților", secChevaux: "Bunăstarea cailor", secEnvironnement: "Mediu",
        conseilsTitle: "Info Practice & Sfaturi", conseilsSub: "Lista de verificare, recomandări și meteo",
        conseilsRecos: "Sfaturi & Recomandări", checklistTitle: "Lista călăreților",
        logistiqueTitle: "Sfaturi Logistice", viewAccommodation: "Vezi cazări",
        weatherTitle: "Meteo Sanxay — Prognoză 14 zile",
        weatherForecast: "Vezi prognoza pe 14 zile pe Météo France",
        weatherLoading: "Se încarcă prognoza...", weatherUnavailable: "Prognoza temporar indisponibilă",
        weatherLink: "Consultă Météo France — Sanxay",
        shareBtn: "DISTRIBUIE", shareTitle: "Distribuie această pagină", shareMessage: "Descoperă info practică pentru {{event}} de la Brious'O Folies",
        shareCopyLink: "Copiază linkul", shareCopied: "Link copiat!"
      },
      homeExt: {
        heroTitle1: "Trăiește evenimentele de la",
        heroTitle2: "în Sanxay",
        heroSubtitle: "Activități ecvestre, sporturi în aer liber și evenimente culturale în inima",
        paysMelusin: "Pays Mélusin",
        seeEvents: "Vezi evenimente",
        becomeMember: "Devino Membru",
        becomeVolunteer: "Devino voluntar",
        receiveNews: "Primește știri",
        eventsPerYear: "Evenimente/an",
        visitorsWelcomed: "Vizitatori primiți",
        volunteersActive: "Voluntari mobilizați",
        landArea: "De teren",
        dontMiss: "Nu rata nimic!",
        upcomingEvents: "Evenimente Viitoare",
        upcomingEventsDesc: "Concerte, plimbări călare, curse de anduranță, seri country... Descoperă programul nostru și rezervă-ți locul!",
        reserve: "Rezervă",
        free: "GRATUIT",
        seeAllEvents: "Vezi toate evenimentele",
        allYear: "Tot anul",
        seasonTitle: "Sezonul Brious'O Folies",
        seasonDesc: "Evenimente tot anul în ritmul anotimpurilor",
        spring: "Primăvară",
        summer: "Vară",
        autumn: "Toamnă",
        winter: "Iarnă",
        springEvents: ["Lecții de echitație", "Drumeții în natură", "Vânătoare de ouă", "Seri country"],
        summerEvents: ["Concerte de cor", "Campionat departamental de anduranță", "Târguri de vechituri"],
        autumnEvents: ["Călărie de Halloween", "Cinema-gustare", "Cursă de anduranță"],
        winterEvents: ["Cinema-gustare", "Concerte intime", "Ateliere", "Jocuri"],
        joinCommunity: "Alătură-te comunității Brious'O Folies",
        newsletterDesc: "Primește știri despre evenimentele noastre, concerte, activități în natură și curse de anduranță.",
        iWantInfo: "Vreau să primesc informații despre:",
        nlEndurance: "Curse de anduranță ecvestră",
        nlConcerts: "Concerte și spectacole",
        nlNature: "Activități în natură și drumeții",
        nlFamily: "Evenimente de familie",
        nlPedagogy: "Activități pedagogice",
        nlVolunteer: "Devino voluntar",
        emailPlaceholder: "Adresa ta de email",
        joinCommunityBtn: "Mă alătur comunității",
        thankYou: "Mulțumesc!",
        subscribedMsg: "Ești acum abonat la newsletter-ul nostru.",
        welcomeMsg: "Bun venit în comunitate!",
        welcomeDesc: "Vei primi în curând știrile noastre.",
        prefsUpdated: "Preferințe actualizate!",
        prefsUpdatedDesc: "Interesele tale au fost actualizate.",
        joinTeam: "Alătură-te echipei",
        becomeVolunteerTitle: "Devino voluntar Brious'O Folies",
        volunteerDesc: "Vrei să participi la organizarea de evenimente sportive și culturale? Alătură-te echipei noastre de voluntari pentru momente de neuitat!",
        volunteerBenefit1: "Trăiește evenimentele din interior",
        volunteerBenefit2: "Fă întâlniri minunate",
        volunteerBenefit3: "Fără experiență necesară",
        volunteerBtn: "Devino voluntar",
        volunteersTrustUs: "Voluntari ne acordă încredere",
        heritageNature: "Patrimoniu & Natură",
        discoverSanxay: "Descoperă Sanxay și regiunea sa",
        discoverDesc: "Domaine de la Briouse este ideal situat pentru a explora comorile Pays Mélusin",
        discoverRegion: "Descoperă regiunea",
        ourCommitment: "Angajamentul Nostru",
        valuesTitle: "Valori care ne unesc",
        benevolence: "Bunăvoință",
        benevolenceDesc: "Primire caldă pentru toți",
        conviviality: "Convivialitate",
        convivialityDesc: "Momente de schimb și întâlnire",
        respect: "Respect",
        respectDesc: "Pentru natură și cai",
        culture: "Cultură",
        cultureDesc: "Evenimente artistice accesibile",
        ourPlace: "Locul Nostru",
        domainTitle: "Domaine de la Briouse",
        domainDesc: "Situat în inima Pays Mélusin, Domaine de la Briouse oferă un cadru natural și cultural excepțional. Aproape de celebrul sit galo-roman din Sanxay, este locul ideal pentru evenimente care combină sport, cultură și natură.",
        howToCome: "Cum ajungi",
        joinAdventure: "Alătură-te aventurii Brious'O Folies",
        ctaDesc: "Devino membru și participă la viața asociației noastre. Împreună, menținem vie moștenirea și convivialitatea din Pays Mélusin.",
        memberFor10: "Alătură-te pentru 10€",
        contactUsBtn: "Contactează-ne",
        call: "Sună",
        galloRomanSite: "Situl Galo-Roman din Sanxay",
        futuroscope: "Futuroscope",
        maraisPoitevin: "Marais Poitevin",
        laRochelle: "La Rochelle"
      },
      eventsExt: {
        calendar: "Calendar",
        calendar2026: "Calendar 2026",
        title: "Evenimentele Noastre",
        subtitle: "Plimbări călare, concerte, curse de anduranță și evenimente de familie... Descoperă toate activitățile noastre la Domaine de la Briouse.",
        downloadLivret: "Descarcă Broșura PDF",
        featured: "La Vedete",
        grandeTombola: "Marea Tombolă",
        winBalloon: "Câștigă un Zbor cu Balonul!",
        tombolaDesc: "Participă la marea noastră tombolă și câștigă un zbor cu balonul pentru 2 persoane decolând direct de la Domaine de la Briouse!",
        ticket: "biletul",
        drawAt: "Tragere la ora 18",
        participateTombola: "Participă la Tombolă",
        learnMore: "Mai multe informații",
        filterByCategory: "Filtrează după categorie",
        allCategories: "Toate categoriile",
        resetFilters: "Resetează filtrele",
        becomeMember: "Devino Membru",
        memberDesc: "Susține asociația noastră și bucură-te de avantaje exclusive.",
        memberFor10: "Alătură-te pentru 10€",
        noEventsFound: "Niciun eveniment găsit pentru aceste criterii.",
        seeAllEvents: "Vezi toate evenimentele",
        reserve: "Rezervă",
        freeEntry: "Intrare liberă",
        orga: "Org",
        equitation: "Echitație",
        concert: "Concert",
        randonnee: "Plimbare",
        course: "Cursă",
        brocante: "Târg de vechituri",
        cinema: "Cinema"
      },
      contactExt: {
        contactUs: "Contactează-ne",
        title: "Contact",
        subtitle: "O întrebare, o sugestie, vrei să te alături? Nu ezita să ne contactezi.",
        contactInfo: "Informații de Contact",
        phone: "Telefon",
        address: "Adresă",
        onlineMembership: "Membru Online",
        joinViaHelloAsso: "Alătură-te asociației noastre prin HelloAsso.",
        memberFor10: "Alătură-te pentru 10€",
        sendMessage: "Trimite-ne un mesaj",
        fullName: "Nume complet *",
        email: "Email *",
        subject: "Subiect *",
        subjectPlaceholder: "Despre...",
        message: "Mesaj *",
        messagePlaceholder: "Mesajul tău...",
        newsletterCheckbox: "Vreau să mă abonez la newsletter pentru a primi știri de la Brious'O Folies",
        sendBtn: "Trimite mesajul",
        successMsg: "Mesaj trimis cu succes!",
        successDescNewsletter: "Ești de asemenea abonat la newsletter.",
        successDesc: "Vă vom răspunde cât mai curând posibil.",
        errorMsg: "Eroare la trimiterea mesajului",
        errorDesc: "Vă rugăm să încercați mai târziu.",
        findUs: "Găsește-ne"
      },
      benevoles: {
        joinAdventure: "Alătură-te aventurii",
        title: "Devino Voluntar",
        heroDesc: "Evenimentele pe care le organizăm nu ar fi posibile fără angajamentul și generozitatea celor care dau puțin din timpul lor.",
        signUp: "Mă înscriu ca voluntar",
        thanks: "Mulțumesc!",
        callTitle: "Brious'O Folies face un apel!",
        callP1: "Astăzi, <strong>Brious'O Folies</strong> face un apel la toți locuitorii care doresc să devină voluntari și să participe la viața locală.",
        callP2: "<strong>Evenimente sportive, concerte, spectacole, drumeții, activități de familie sau întâlniri festive</strong>: proiectele noastre sunt variate și fiecare își poate găsi locul.",
        callP3: "Primirea publicului, ajutor la organizare, logistică, instalare, comunicare, însoțirea participanților sau pur și simplu o mână de ajutor... <strong>există o mie de moduri de a te implica</strong>, după dorințele, competențele și disponibilitatea ta.",
        chooseEvent: "Alege evenimentul tău",
        eventsCalendar: "Calendar Evenimente",
        clickToSign: "Click pe un eveniment pentru a te înscrie ca voluntar",
        selectedEvent: "Eveniment Selectat",
        monthEvents: "Evenimentele lunii",
        volunteerForEvent: "Devino voluntar pentru acest eveniment",
        seeAllEvents: "Vezi toate evenimentele",
        noEventThisMonth: "Niciun eveniment luna aceasta.",
        navigateCalendar: "Navighează în calendar!",
        findYourPlace: "Găsește-ți locul",
        missionTypes: "Tipuri de Misiuni",
        missionDesc: "Există multe moduri de a contribui după dorințele și competențele tale.",
        publicWelcome: "Primirea publicului",
        publicWelcomeDesc: "Orientarea și informarea vizitatorilor în timpul evenimentelor noastre",
        logistics: "Logistică & Instalare",
        logisticsDesc: "Montajul standurilor, semnalizarea și amenajările",
        animation: "Animație",
        animationDesc: "Însoțirea participanților în timpul spectacolelor și concertelor",
        helpOut: "Ajutor ocazional",
        helpOutDesc: "Ajutor divers după disponibilitate și dorințe",
        whyJoin: "De ce să te alături?",
        beingVolunteer: "A fi voluntar înseamnă...",
        beingVolunteerDesc: "Trăiește evenimentele din interior, împarte momente puternice, fă întâlniri minunate și contribuie la proiecte semnificative pentru teritoriul nostru.",
        benefit1: "Trăiește evenimentele din interior",
        benefit2: "Fă întâlniri minunate",
        benefit3: "Contribuie la proiecte semnificative",
        benefit4: "Atmosferă prietenoasă și grijulie",
        benefit5: "Fără experiență necesară",
        benefit6: "Angajament după disponibilitate",
        essentialDesire: "Esențialul este dorința!",
        essentialP1: "Nu este necesară nicio experiență specială: esențialul este dorința de a participa, de a împărtăși și de a face parte dintr-o aventură colectivă.",
        essentialP2: "Alăturarea echipei de voluntari Brious'O Folies înseamnă angajarea într-o",
        essentialP2Bold: "atmosferă prietenoasă și grijulie",
        essentialP2End: ", în serviciul schimbului, culturii, sportului și naturii.",
        ifAdventureTempts: "Dacă aventura te tentează...",
        ctaDesc: "Vino să ne întâlnești la evenimentele noastre sau înscrie-te direct: te vom primi cu plăcere și vom scrie împreună următorul capitol al acestei povești frumoase!",
        becomeVolunteer: "Devin voluntar",
        contactUs: "Contactează-ne",
        followSocial: "Urmărește-ne pe rețelele sociale!",
        dayNames: ["Lun", "Mar", "Mie", "Joi", "Vin", "Sâm", "Dum"]
      },
      footerExt: {
        visitorsSay: "Ce spun vizitatorii noștri",
        review1: "Atmosferă excelentă, echipă de top!",
        review2: "Evenimente de calitate, vom reveni!",
        review3: "Cadru magnific, cai bine îngrijiți",
        navigation: "Navigare",
        home: "Acasă",
        events: "Evenimente",
        association: "Asociația",
        gettingHere: "Cum ajungi",
        news: "Știri",
        volunteers: "Voluntari",
        partners: "Parteneri",
        contactLabel: "Contact",
        contactTitle: "Contact",
        contactUsLink: "Contactează-ne",
        ourValues: "Valorile Noastre",
        value1: "Transmitere & Împărtășire",
        value2: "Sport Responsabil",
        value3: "Cultură Accesibilă",
        value4: "Respect pentru Natură",
        value5: "Convivialitate",
        value6: "Bunăvoință",
        becomeMember: "Devino Membru",
        allRights: "Toate drepturile rezervate",
        legalNotice: "Mențiuni Legale",
        cgv: "CGV",
        privacy: "Confidențialitate",
        description: "Asociație non-profit dedicată promovării activităților ecvestre, sporturilor în aer liber și evenimentelor culturale la Domaine de la Briouse."
      },
      venir: {
        title: "Cum Ajungi",
        subtitle: "Domaine de la Briouse",
        heroDesc: "Toate informațiile practice pentru a ne vizita în inima Pays Mélusin.",
        howToCome: "Cum ajungi",
        accommodation: "Cazare",
        restaurants: "Restaurante",
        discover: "Descoperă",
        byCar: "Cu mașina",
        byTrain: "Cu trenul",
        byPlane: "Cu avionul",
        gps: "Coordonate GPS",
        distance: "Distanță",
        all: "Toate",
        onSite: "La fața locului",
        nearby: "În apropiere",
        book: "Rezervă",
        visitWebsite: "Vizitează site-ul",
        seeOnMap: "Vezi pe hartă",
        discoverRegion: "Descoperă Regiunea",
        discoverDesc: "Domaine de la Briouse este ideal situat în inima Pays Mélusin, înconjurat de locuri remarcabile.",
        filterByDistance: "Filtrează după distanță",
        heritageNature: "Patrimoniu & Natură",
        leisure: "Agrement & Cultură",
        beaches: "Plaje & Litoral",
        contactTitle: "Ai nevoie de informații?",
        contactDesc: "Echipa noastră este disponibilă pentru a te ajuta să-ți organizezi sejurul.",
        contactBtn: "Contactează-ne",
        callUs: "Sună-ne",
        name: "Nume *",
        email: "Email *",
        messageLabel: "Mesaj *",
        sendBtn: "Trimite",
        msgSent: "Mesaj trimis!",
        msgSentDesc: "Vă vom răspunde rapid.",
        msgError: "Eroare la trimitere",
        msgErrorDesc: "Vă rugăm să încercați din nou.",
        chambreHotes: "Camere de oaspeți & Cabane",
        camping: "Camping",
        hotel: "Hotel",
        gite: "Cabană",
        traditional: "Bucătărie tradițională",
        gastro: "Gastronomie",
        pizzeria: "Pizzerie",
        bar: "Bar",
        crêperie: "Crêperie",
        priceRange: "Interval de prețuri"
      },
      adhesion: {
        title: "Membru",
        subtitle: "Devino Membru",
        heroDesc: "Alătură-te asociației Brious'O Folies și participă la viața Domaine de la Briouse.",
        why: "De ce să te alături?",
        benefit1: "Susține evenimentele noastre",
        benefit1Desc: "Contribuția ta finanțează direct concertele, plimbările și activitățile noastre.",
        benefit2: "Acces prioritar",
        benefit2Desc: "Tarife reduse și acces prioritar la anumite evenimente.",
        benefit3: "Comunitate",
        benefit3Desc: "Alătură-te unei comunități pasionate din Pays Mélusin.",
        joinNow: "Alătură-te acum",
        memberFor10: "Membru anual: 10€",
        helloAssoInfo: "Înscriera se face prin HelloAsso, partenerul nostru de plată securizat.",
        questions: "Întrebări?",
        contactUs: "Contactează-ne"
      },
      actualites: {
        title: "Știri",
        subtitle: "Știrile Noastre",
        heroDesc: "Urmărește cele mai recente știri de la Brious'O Folies și Domaine de la Briouse.",
        noNews: "Nicio știre momentan.",
        stayTuned: "Rămâi conectat!",
        followUs: "Urmărește-ne pe rețelele sociale pentru a nu rata nimic.",
        readMore: "Citește mai mult",
        published: "Publicat pe",
        categories: "Categorii",
        all: "Toate",
        mediaDeleted: "Media ștearsă"
      },
      tombola: {
        title: "Marea Tombolă",
        subtitle: "Tombola Brious'O Folies",
        heroDesc: "Participă la marea noastră tombolă și câștigă un zbor cu balonul!",
        winBalloon: "Câștigă un Zbor cu Balonul!",
        description: "Participă la marea noastră tombolă și câștigă un zbor cu balonul pentru 2 persoane decolând direct de la Domaine de la Briouse!",
        ticketPrice: "biletul",
        drawDate: "Tragere pe 8 Nov. 2026",
        drawTime: "Tragere la ora 18",
        participate: "Participă la Tombolă",
        howItWorks: "Cum funcționează?",
        step1: "Cumpără-ți biletul",
        step1Desc: "Bilete disponibile online prin HelloAsso sau la fața locului în timpul evenimentelor noastre.",
        step2: "Așteaptă tragerea",
        step2Desc: "Tragerea va avea loc pe 8 noiembrie 2026 la ora 18 la Domaine de la Briouse.",
        step3: "Zboară!",
        step3Desc: "Câștigătorul se va bucura de un zbor cu balonul pentru 2 persoane.",
        rules: "Regulament",
        rulesDesc: "Tombolă organizată conform reglementărilor în vigoare."
      },
      legal: {
        title: "Mențiuni Legale",
        legalNotice: "Mențiuni Legale",
        cgv: "Termeni și Condiții",
        privacy: "Politica de Confidențialitate",
        editor: "Editorul site-ului",
        hosting: "Găzduire",
        intellectual: "Proprietate intelectuală",
        intellectualDesc: "Tot conținutul acestui site (texte, imagini, videouri) este protejat de dreptul de autor.",
        dataProtection: "Protecția datelor",
        dataProtectionDesc: "Conform RGPD, aveți dreptul de acces, modificare și ștergere a datelor personale.",
        cookies: "Cookie-uri",
        cookiesDesc: "Acest site folosește cookie-uri pentru a îmbunătăți experiența de navigare.",
        contact: "Contact"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n;
